// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg viewBox=%270 0 16 16%27 fill=%27white%27 xmlns=%27http://www.w3.org/2000/svg%27%3e%3ccircle cx=%278%27 cy=%278%27 r=%273%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../style_modules/less-components/fonts/GothamSSm-Bold.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../../style_modules/less-components/fonts/GothamSSm-Bold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../../style_modules/less-components/fonts/GothamSSm-Bold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../../style_modules/less-components/fonts/GothamSSm-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../../../style_modules/less-components/fonts/GothamSSm-Bold.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../../../style_modules/less-components/fonts/GothamSSm-BoldItalic.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../../../style_modules/less-components/fonts/GothamSSm-Book.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../../../style_modules/less-components/fonts/GothamSSm-Book.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("../../../style_modules/less-components/fonts/GothamSSm-Book.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("../../../style_modules/less-components/fonts/GothamSSm-Book.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("../../../style_modules/less-components/fonts/GothamSSm-Book.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("../../../style_modules/less-components/fonts/GothamSSm-BookItalic.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("../../../style_modules/less-components/fonts/GothamSSm-light.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("../../../style_modules/less-components/fonts/GothamSSm-light.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("../../../style_modules/less-components/fonts/GothamSSm-light.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("../../../style_modules/less-components/fonts/GothamSSm-light.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("../../../style_modules/less-components/fonts/GothamSSm-Light.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("../../../style_modules/less-components/fonts/GothamSSm-LightItalic.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_19___ = new URL("../../../style_modules/less-components/fonts/GothamSSm-Medium.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_20___ = new URL("../../../style_modules/less-components/fonts/GothamSSm-Medium.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_21___ = new URL("../../../style_modules/less-components/fonts/GothamSSm-Medium.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_22___ = new URL("../../../style_modules/less-components/fonts/GothamSSm-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_23___ = new URL("../../../style_modules/less-components/fonts/GothamSSm-Medium.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_24___ = new URL("../../../style_modules/less-components/fonts/GothamSSm-MediumItalic.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_25___ = new URL("../../../style_modules/less-components/fonts/Roboto/Roboto-Regular.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_26___ = new URL("../../../style_modules/less-components/fonts/Roboto/Roboto-Regular.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_27___ = new URL("../../../style_modules/less-components/fonts/Roboto/Roboto-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_28___ = new URL("../../../style_modules/less-components/fonts/Roboto/Roboto-Regular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_29___ = new URL("../../../style_modules/less-components/fonts/Roboto/Roboto-Regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_30___ = new URL("../../../style_modules/less-components/fonts/Roboto/Roboto-Bold.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_31___ = new URL("../../../style_modules/less-components/fonts/Roboto/Roboto-Bold.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_32___ = new URL("../../../style_modules/less-components/fonts/Roboto/Roboto-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_33___ = new URL("../../../style_modules/less-components/fonts/Roboto/Roboto-Bold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_34___ = new URL("../../../style_modules/less-components/fonts/Roboto/Roboto-Bold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_35___ = new URL("../../../style_modules/less-components/fonts/Roboto/Roboto-Medium.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_36___ = new URL("../../../style_modules/less-components/fonts/Roboto/Roboto-Medium.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_37___ = new URL("../../../style_modules/less-components/fonts/Roboto/Roboto-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_38___ = new URL("../../../style_modules/less-components/fonts/Roboto/Roboto-Medium.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_39___ = new URL("../../../style_modules/less-components/fonts/Roboto/Roboto-Medium.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_40___ = new URL("../../../style_modules/less-components/fonts/Roboto/Roboto-Light.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_41___ = new URL("../../../style_modules/less-components/fonts/Roboto/Roboto-Light.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_42___ = new URL("../../../style_modules/less-components/fonts/Roboto/Roboto-Light.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_43___ = new URL("../../../style_modules/less-components/fonts/Roboto/Roboto-Light.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_44___ = new URL("../../../style_modules/less-components/fonts/Roboto/Roboto-Light.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_45___ = new URL("../../../style_modules/less-components/fonts/RobotoMono/RobotoMono-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_46___ = new URL("../../../style_modules/less-components/fonts/Nato/NotoSansArabic-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_47___ = new URL("../../../style_modules/less-components/fonts/Nato/NotoSansArabic-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_48___ = new URL("../../../style_modules/less-components/fonts/Nato/NotoSansArabic-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_49___ = new URL("../images/clear-search.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_50___ = new URL("../images/clear-search-white.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_19___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_20___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_21___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
var ___CSS_LOADER_URL_REPLACEMENT_22___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_19___);
var ___CSS_LOADER_URL_REPLACEMENT_23___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_19___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_24___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_20___);
var ___CSS_LOADER_URL_REPLACEMENT_25___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_21___);
var ___CSS_LOADER_URL_REPLACEMENT_26___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_22___);
var ___CSS_LOADER_URL_REPLACEMENT_27___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_23___);
var ___CSS_LOADER_URL_REPLACEMENT_28___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_24___);
var ___CSS_LOADER_URL_REPLACEMENT_29___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_25___);
var ___CSS_LOADER_URL_REPLACEMENT_30___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_25___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_31___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_26___, { hash: "#Roboto-Regular" });
var ___CSS_LOADER_URL_REPLACEMENT_32___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_27___);
var ___CSS_LOADER_URL_REPLACEMENT_33___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_28___);
var ___CSS_LOADER_URL_REPLACEMENT_34___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_29___);
var ___CSS_LOADER_URL_REPLACEMENT_35___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_30___);
var ___CSS_LOADER_URL_REPLACEMENT_36___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_30___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_37___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_31___, { hash: "#Roboto-Bold" });
var ___CSS_LOADER_URL_REPLACEMENT_38___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_32___);
var ___CSS_LOADER_URL_REPLACEMENT_39___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_33___);
var ___CSS_LOADER_URL_REPLACEMENT_40___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_34___);
var ___CSS_LOADER_URL_REPLACEMENT_41___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_35___);
var ___CSS_LOADER_URL_REPLACEMENT_42___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_35___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_43___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_36___, { hash: "#Roboto-Medium" });
var ___CSS_LOADER_URL_REPLACEMENT_44___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_37___);
var ___CSS_LOADER_URL_REPLACEMENT_45___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_38___);
var ___CSS_LOADER_URL_REPLACEMENT_46___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_39___);
var ___CSS_LOADER_URL_REPLACEMENT_47___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_40___);
var ___CSS_LOADER_URL_REPLACEMENT_48___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_40___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_49___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_41___, { hash: "#Roboto-Light" });
var ___CSS_LOADER_URL_REPLACEMENT_50___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_42___);
var ___CSS_LOADER_URL_REPLACEMENT_51___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_43___);
var ___CSS_LOADER_URL_REPLACEMENT_52___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_44___);
var ___CSS_LOADER_URL_REPLACEMENT_53___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_45___);
var ___CSS_LOADER_URL_REPLACEMENT_54___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_46___);
var ___CSS_LOADER_URL_REPLACEMENT_55___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_47___);
var ___CSS_LOADER_URL_REPLACEMENT_56___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_48___);
var ___CSS_LOADER_URL_REPLACEMENT_57___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_49___);
var ___CSS_LOADER_URL_REPLACEMENT_58___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_50___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*! tailwindcss v4.1.18 | MIT License | https://tailwindcss.com */
@layer properties;
@layer theme, base, components, utilities;
@layer theme {
  :root, :host {
    --font-sans: Roboto;
    --font-mono: RobotoMono;
    --color-red-100: oklch(93.6% 0.032 17.717);
    --color-red-500: oklch(63.7% 0.237 25.331);
    --color-red-600: oklch(57.7% 0.245 27.325);
    --color-orange-200: oklch(90.1% 0.076 70.697);
    --color-orange-900: oklch(40.8% 0.123 38.172);
    --color-amber-100: oklch(96.2% 0.059 95.617);
    --color-amber-200: oklch(92.4% 0.12 95.746);
    --color-amber-700: oklch(55.5% 0.163 48.998);
    --color-amber-900: oklch(41.4% 0.112 45.904);
    --color-yellow-100: var(--color-yellow-light);
    --color-yellow-400: oklch(85.2% 0.199 91.936);
    --color-yellow-800: oklch(47.6% 0.114 61.907);
    --color-green-100: oklch(96.2% 0.044 156.743);
    --color-green-200: oklch(92.5% 0.084 155.995);
    --color-green-500: oklch(72.3% 0.219 149.579);
    --color-green-600: oklch(62.7% 0.194 149.214);
    --color-green-700: oklch(52.7% 0.154 150.069);
    --color-green-900: oklch(39.3% 0.095 152.535);
    --color-blue-300: oklch(80.9% 0.105 251.813);
    --color-blue-500: oklch(62.3% 0.214 259.815);
    --color-blue-600: oklch(54.6% 0.245 262.881);
    --color-blue-700: oklch(48.8% 0.243 264.376);
    --color-blue-800: oklch(42.4% 0.199 265.638);
    --color-purple-500: oklch(62.7% 0.265 303.9);
    --color-gray-50: oklch(98.5% 0.002 247.839);
    --color-gray-100: var(--color-super-light-grey);
    --color-gray-200: var(--color-dark-background);
    --color-gray-300: var(--color-ornament);
    --color-gray-400: var(--color-light-grey);
    --color-gray-500: var(--color-mid-grey);
    --color-gray-600: var(--color-icon);
    --color-gray-700: var(--color-dark-icon);
    --color-gray-800: var(--color-dark-grey);
    --color-gray-900: var(--color-super-dark-grey);
    --color-black: var(--color-black);
    --color-white: var(--color-white);
    --spacing: 0.25rem;
    --breakpoint-sm: 40rem;
    --breakpoint-md: 48rem;
    --container-xs: 20rem;
    --container-sm: 24rem;
    --container-md: 28rem;
    --container-xl: 36rem;
    --container-2xl: 42rem;
    --container-3xl: 48rem;
    --text-xs: 0.75rem;
    --text-xs--line-height: calc(1 / 0.75);
    --text-sm: 0.875rem;
    --text-sm--line-height: calc(1.25 / 0.875);
    --text-base: 1rem;
    --text-base--line-height: calc(1.5 / 1);
    --text-lg: 1.125rem;
    --text-lg--line-height: calc(1.75 / 1.125);
    --text-xl: 1.25rem;
    --text-xl--line-height: calc(1.75 / 1.25);
    --text-2xl: 1.5rem;
    --text-2xl--line-height: calc(2 / 1.5);
    --text-3xl: 1.875rem;
    --text-3xl--line-height: calc(2.25 / 1.875);
    --font-weight-thin: 100;
    --font-weight-light: 300;
    --font-weight-normal: 400;
    --font-weight-medium: 500;
    --font-weight-semibold: 600;
    --font-weight-bold: 700;
    --tracking-tight: -0.025em;
    --tracking-normal: 0em;
    --tracking-wide: 0.025em;
    --tracking-wider: 0.05em;
    --leading-normal: 1.5;
    --leading-relaxed: 1.625;
    --radius-xs: 0.125rem;
    --radius-sm: 0.25rem;
    --radius-md: 0.375rem;
    --radius-lg: 0.5rem;
    --radius-xl: 0.75rem;
    --radius-2xl: 1rem;
    --radius-3xl: 1.5rem;
    --radius-4xl: 2rem;
    --ease-in: cubic-bezier(0.4, 0, 1, 1);
    --ease-out: cubic-bezier(0, 0, 0.2, 1);
    --ease-in-out: cubic-bezier(0.4, 0, 0.2, 1);
    --animate-spin: spin 1s linear infinite;
    --animate-ping: ping 1s cubic-bezier(0, 0, 0.2, 1) infinite;
    --animate-pulse: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
    --blur-sm: 8px;
    --aspect-video: 16 / 9;
    --default-transition-duration: 150ms;
    --default-transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    --default-font-family: var(--font-sans);
    --default-mono-font-family: var(--font-mono);
    --color-main: var(--color-main);
    --color-green: var(--color-green);
    --color-red: var(--color-red);
    --color-yellow: var(--color-yellow);
    --color-chatYou: var(--color-chat-you);
    --color-link: var(--color-link);
    --color-pbx-conference: var(--color-conference);
    --color-pbx-refer: var(--color-refer);
    --color-pbx-huntgroup: var(--color-huntgroup);
    --color-pbx-channel: var(--color-channel);
    --color-pbx-voicemail: var(--color-voicemail);
    --color-pbx-connection: var(--color-connection);
    --color-iconOnBrand: var(--color-iconOnBrand);
    --color-textOnBrand: var(--color-textOnBrand);
    --color-flavor-1: var(--color-flavor-1);
    --color-flavor-2: var(--color-flavor-2);
    --color-flavor-3: var(--color-flavor-3);
    --color-flavor-4: var(--color-flavor-4);
    --color-flavor-5: var(--color-flavor-5);
    --color-flavor-6: var(--color-flavor-6);
    --color-flavor-7: var(--color-flavor-7);
    --color-flavor-8: var(--color-flavor-8);
    --color-flavor-9: var(--color-flavor-9);
    --color-gray-150: var(--color-light-background);
    --spacing-meeting-footer: 6rem;
    --spacing-meeting-header: 5rem;
    --spacing-meeting-side-panel: 370px;
    --text-2xs: 0.625rem;
    --animate-fade: fade 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
    --animate-fade-in: fadeIn 200ms ease-out;
    --animate-slideInDialpad: slideInDialpad 300ms ease-in forwards;
    --animate-slideOut: slideOut 300ms ease-in forwards;
    --animate-incomingCallPulseLarge: incomingCallPulseLarge 0.8s infinite;
    --animate-spinSmoothAcceleration: spinSmoothAcceleration 2s infinite;
    --animate-slideInFromBottom: slideInFromBottom 0.3s ease-out;
    --animate-ellipsis: ellipsis 1.5s steps(4, end) infinite;
  }
}
@layer base {
  *, ::after, ::before, ::backdrop, ::file-selector-button {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
    border: 0 solid;
  }
  html, :host {
    line-height: 1.5;
    -webkit-text-size-adjust: 100%;
    tab-size: 4;
    font-family: var(--default-font-family, ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji");
    font-feature-settings: var(--default-font-feature-settings, normal);
    font-variation-settings: var(--default-font-variation-settings, normal);
    -webkit-tap-highlight-color: transparent;
  }
  hr {
    height: 0;
    color: inherit;
    border-top-width: 1px;
  }
  abbr:where([title]) {
    -webkit-text-decoration: underline dotted;
    text-decoration: underline dotted;
  }
  h1, h2, h3, h4, h5, h6 {
    font-size: inherit;
    font-weight: inherit;
  }
  a {
    color: inherit;
    -webkit-text-decoration: inherit;
    text-decoration: inherit;
  }
  b, strong {
    font-weight: bolder;
  }
  code, kbd, samp, pre {
    font-family: var(--default-mono-font-family, ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace);
    font-feature-settings: var(--default-mono-font-feature-settings, normal);
    font-variation-settings: var(--default-mono-font-variation-settings, normal);
    font-size: 1em;
  }
  small {
    font-size: 80%;
  }
  sub, sup {
    font-size: 75%;
    line-height: 0;
    position: relative;
    vertical-align: baseline;
  }
  sub {
    bottom: -0.25em;
  }
  sup {
    top: -0.5em;
  }
  table {
    text-indent: 0;
    border-color: inherit;
    border-collapse: collapse;
  }
  :-moz-focusring {
    outline: auto;
  }
  progress {
    vertical-align: baseline;
  }
  summary {
    display: list-item;
  }
  ol, ul, menu {
    list-style: none;
  }
  img, svg, video, canvas, audio, iframe, embed, object {
    display: block;
    vertical-align: middle;
  }
  img, video {
    max-width: 100%;
    height: auto;
  }
  button, input, select, optgroup, textarea, ::file-selector-button {
    font: inherit;
    font-feature-settings: inherit;
    font-variation-settings: inherit;
    letter-spacing: inherit;
    color: inherit;
    border-radius: 0;
    background-color: transparent;
    opacity: 1;
  }
  :where(select:is([multiple], [size])) optgroup {
    font-weight: bolder;
  }
  :where(select:is([multiple], [size])) optgroup option {
    padding-inline-start: 20px;
  }
  ::file-selector-button {
    margin-inline-end: 4px;
  }
  ::placeholder {
    opacity: 1;
  }
  @supports (not (-webkit-appearance: -apple-pay-button))  or (contain-intrinsic-size: 1px) {
    ::placeholder {
      color: currentcolor;
      @supports (color: color-mix(in lab, red, red)) {
        color: color-mix(in oklab, currentcolor 50%, transparent);
      }
    }
  }
  textarea {
    resize: vertical;
  }
  ::-webkit-search-decoration {
    -webkit-appearance: none;
  }
  ::-webkit-date-and-time-value {
    min-height: 1lh;
    text-align: inherit;
  }
  ::-webkit-datetime-edit {
    display: inline-flex;
  }
  ::-webkit-datetime-edit-fields-wrapper {
    padding: 0;
  }
  ::-webkit-datetime-edit, ::-webkit-datetime-edit-year-field, ::-webkit-datetime-edit-month-field, ::-webkit-datetime-edit-day-field, ::-webkit-datetime-edit-hour-field, ::-webkit-datetime-edit-minute-field, ::-webkit-datetime-edit-second-field, ::-webkit-datetime-edit-millisecond-field, ::-webkit-datetime-edit-meridiem-field {
    padding-block: 0;
  }
  ::-webkit-calendar-picker-indicator {
    line-height: 1;
  }
  :-moz-ui-invalid {
    box-shadow: none;
  }
  button, input:where([type="button"], [type="reset"], [type="submit"]), ::file-selector-button {
    appearance: button;
  }
  ::-webkit-inner-spin-button, ::-webkit-outer-spin-button {
    height: auto;
  }
  [hidden]:where(:not([hidden="until-found"])) {
    display: none !important;
  }
}
@layer utilities {
  .\\@container\\/meeting-footer {
    container-type: inline-size;
    container-name: meeting-footer;
  }
  .\\@container\\/messages {
    container-type: inline-size;
    container-name: messages;
  }
  .\\@container {
    container-type: inline-size;
  }
  .meeting-tile-avatar-container {
    container-type: size;
  }
  .reveal-on-hover-or-focus {
    opacity: 0;
    pointer-events: none;
    :where(.group):hover &, :where(.group):is(:focus-visible, :has(:focus-visible)) & {
      opacity: 1;
      pointer-events: auto;
    }
  }
  .pointer-events-auto {
    pointer-events: auto;
  }
  .pointer-events-none {
    pointer-events: none;
  }
  .collapse {
    visibility: collapse;
  }
  .invisible {
    visibility: hidden;
  }
  .visible {
    visibility: visible;
  }
  .stretched-control {
    &::after {
      content: var(--tw-content);
      position: absolute;
    }
    &::after {
      content: var(--tw-content);
      inset: calc(var(--spacing) * 0);
    }
    &::after {
      content: var(--tw-content);
      border-radius: var(--radius-sm);
    }
    outline-style: none;
    &.focus-ring:focus-visible:focus-visible {
      outline-style: none;
    }
    &:focus-visible::after {
      outline: auto 1px;
      outline-color: inherit;
      outline-offset: -3px;
    }
  }
  .sr-only {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip-path: inset(50%);
    white-space: nowrap;
    border-width: 0;
  }
  .sr-only-until-hover-or-focus {
    &:not(:where(.group):is(:hover, :focus-visible, :has(:focus-visible)) *) {
      position: absolute;
      width: 1px;
      height: 1px;
      padding: 0;
      margin: -1px;
      overflow: hidden;
      clip-path: inset(50%);
      white-space: nowrap;
      border-width: 0;
    }
  }
  .\\!fixed {
    position: fixed !important;
  }
  .absolute {
    position: absolute;
  }
  .fixed {
    position: fixed;
  }
  .relative {
    position: relative;
  }
  .static {
    position: static;
  }
  .sticky {
    position: sticky;
  }
  .inset-0 {
    inset: calc(var(--spacing) * 0);
  }
  .inset-x-0 {
    inset-inline: calc(var(--spacing) * 0);
  }
  .inset-x-1 {
    inset-inline: calc(var(--spacing) * 1);
  }
  .inset-x-2 {
    inset-inline: calc(var(--spacing) * 2);
  }
  .inset-x-3 {
    inset-inline: calc(var(--spacing) * 3);
  }
  .inset-y-0 {
    inset-block: calc(var(--spacing) * 0);
  }
  .inset-y-2 {
    inset-block: calc(var(--spacing) * 2);
  }
  .start-0 {
    inset-inline-start: calc(var(--spacing) * 0);
  }
  .start-1 {
    inset-inline-start: calc(var(--spacing) * 1);
  }
  .start-1\\.5 {
    inset-inline-start: calc(var(--spacing) * 1.5);
  }
  .start-1\\/2 {
    inset-inline-start: calc(1/2 * 100%);
  }
  .start-2 {
    inset-inline-start: calc(var(--spacing) * 2);
  }
  .start-3 {
    inset-inline-start: calc(var(--spacing) * 3);
  }
  .start-6 {
    inset-inline-start: calc(var(--spacing) * 6);
  }
  .-end-0\\.5 {
    inset-inline-end: calc(var(--spacing) * -0.5);
  }
  .-end-1 {
    inset-inline-end: calc(var(--spacing) * -1);
  }
  .-end-1\\.5 {
    inset-inline-end: calc(var(--spacing) * -1.5);
  }
  .-end-2 {
    inset-inline-end: calc(var(--spacing) * -2);
  }
  .-end-3 {
    inset-inline-end: calc(var(--spacing) * -3);
  }
  .-end-10 {
    inset-inline-end: calc(var(--spacing) * -10);
  }
  .end-0 {
    inset-inline-end: calc(var(--spacing) * 0);
  }
  .end-0\\.5 {
    inset-inline-end: calc(var(--spacing) * 0.5);
  }
  .end-1 {
    inset-inline-end: calc(var(--spacing) * 1);
  }
  .end-1\\.5 {
    inset-inline-end: calc(var(--spacing) * 1.5);
  }
  .end-2 {
    inset-inline-end: calc(var(--spacing) * 2);
  }
  .end-3 {
    inset-inline-end: calc(var(--spacing) * 3);
  }
  .end-4 {
    inset-inline-end: calc(var(--spacing) * 4);
  }
  .end-9 {
    inset-inline-end: calc(var(--spacing) * 9);
  }
  .end-\\[3px\\] {
    inset-inline-end: 3px;
  }
  .end-\\[6px\\] {
    inset-inline-end: 6px;
  }
  .end-\\[calc\\(var\\(--spacing-meeting-side-panel\\)\\+16px\\)\\] {
    inset-inline-end: calc(var(--spacing-meeting-side-panel) + 16px);
  }
  .end-\\[calc\\(var\\(--spacing-meeting-side-panel\\)-2\\.5rem\\)\\] {
    inset-inline-end: calc(var(--spacing-meeting-side-panel) - 2.5rem);
  }
  .-top-0\\.5 {
    top: calc(var(--spacing) * -0.5);
  }
  .-top-1 {
    top: calc(var(--spacing) * -1);
  }
  .-top-1\\.5 {
    top: calc(var(--spacing) * -1.5);
  }
  .-top-2 {
    top: calc(var(--spacing) * -2);
  }
  .-top-3 {
    top: calc(var(--spacing) * -3);
  }
  .-top-4 {
    top: calc(var(--spacing) * -4);
  }
  .-top-6 {
    top: calc(var(--spacing) * -6);
  }
  .-top-8 {
    top: calc(var(--spacing) * -8);
  }
  .top-0 {
    top: calc(var(--spacing) * 0);
  }
  .top-1 {
    top: calc(var(--spacing) * 1);
  }
  .top-1\\.5 {
    top: calc(var(--spacing) * 1.5);
  }
  .top-1\\/2 {
    top: calc(1/2 * 100%);
  }
  .top-2 {
    top: calc(var(--spacing) * 2);
  }
  .top-3 {
    top: calc(var(--spacing) * 3);
  }
  .top-4 {
    top: calc(var(--spacing) * 4);
  }
  .top-5 {
    top: calc(var(--spacing) * 5);
  }
  .top-6 {
    top: calc(var(--spacing) * 6);
  }
  .top-11 {
    top: calc(var(--spacing) * 11);
  }
  .top-16 {
    top: calc(var(--spacing) * 16);
  }
  .top-20 {
    top: calc(var(--spacing) * 20);
  }
  .top-\\[var\\(--spacing-meeting-header\\)\\] {
    top: var(--spacing-meeting-header);
  }
  .top-full {
    top: 100%;
  }
  .-right-2 {
    right: calc(var(--spacing) * -2);
  }
  .right-2 {
    right: calc(var(--spacing) * 2);
  }
  .right-4 {
    right: calc(var(--spacing) * 4);
  }
  .bottom-0 {
    bottom: calc(var(--spacing) * 0);
  }
  .bottom-0\\.5 {
    bottom: calc(var(--spacing) * 0.5);
  }
  .bottom-1 {
    bottom: calc(var(--spacing) * 1);
  }
  .bottom-1\\/2 {
    bottom: calc(1/2 * 100%);
  }
  .bottom-2 {
    bottom: calc(var(--spacing) * 2);
  }
  .bottom-3 {
    bottom: calc(var(--spacing) * 3);
  }
  .bottom-4 {
    bottom: calc(var(--spacing) * 4);
  }
  .bottom-6 {
    bottom: calc(var(--spacing) * 6);
  }
  .bottom-14 {
    bottom: calc(var(--spacing) * 14);
  }
  .bottom-\\[3px\\] {
    bottom: 3px;
  }
  .bottom-\\[6px\\] {
    bottom: 6px;
  }
  .bottom-\\[calc\\(var\\(--spacing-meeting-footer\\)\\+4px\\)\\] {
    bottom: calc(var(--spacing-meeting-footer) + 4px);
  }
  .bottom-\\[var\\(--spacing-meeting-footer\\)\\] {
    bottom: var(--spacing-meeting-footer);
  }
  .bottom-full {
    bottom: 100%;
  }
  .left-1\\/2 {
    left: calc(1/2 * 100%);
  }
  .left-4 {
    left: calc(var(--spacing) * 4);
  }
  .isolate {
    isolation: isolate;
  }
  .z-0 {
    z-index: 0;
  }
  .z-2 {
    z-index: 2;
  }
  .z-10 {
    z-index: 10;
  }
  .z-12 {
    z-index: 12;
  }
  .z-20 {
    z-index: 20;
  }
  .z-25 {
    z-index: 25;
  }
  .z-30 {
    z-index: 30;
  }
  .z-40 {
    z-index: 40;
  }
  .z-50 {
    z-index: 50;
  }
  .z-\\[1\\] {
    z-index: 1;
  }
  .z-\\[2\\] {
    z-index: 2;
  }
  .z-\\[11\\] {
    z-index: 11;
  }
  .z-\\[12\\] {
    z-index: 12;
  }
  .z-\\[300\\] {
    z-index: 300;
  }
  .z-\\[9999\\] {
    z-index: 9999;
  }
  .z-\\[99999\\] {
    z-index: 99999;
  }
  .z-\\[100000\\] {
    z-index: 100000;
  }
  .z-\\[100001\\] {
    z-index: 100001;
  }
  .-order-1 {
    order: calc(1 * -1);
  }
  .col-span-1 {
    grid-column: span 1 / span 1;
  }
  .col-span-2 {
    grid-column: span 2 / span 2;
  }
  .col-span-3 {
    grid-column: span 3 / span 3;
  }
  .col-start-1 {
    grid-column-start: 1;
  }
  .row-start-1 {
    grid-row-start: 1;
  }
  .container {
    width: 100%;
    @media (width >= 480px) {
      max-width: 480px;
    }
    @media (width >= 720px) {
      max-width: 720px;
    }
    @media (width >= 800px) {
      max-width: 800px;
    }
    @media (width >= 40rem) {
      max-width: 40rem;
    }
    @media (width >= 48rem) {
      max-width: 48rem;
    }
    @media (width >= 64rem) {
      max-width: 64rem;
    }
    @media (width >= 80rem) {
      max-width: 80rem;
    }
    @media (width >= 96rem) {
      max-width: 96rem;
    }
  }
  .m-0 {
    margin: calc(var(--spacing) * 0);
  }
  .m-1 {
    margin: calc(var(--spacing) * 1);
  }
  .m-1\\.5 {
    margin: calc(var(--spacing) * 1.5);
  }
  .m-2 {
    margin: calc(var(--spacing) * 2);
  }
  .m-3 {
    margin: calc(var(--spacing) * 3);
  }
  .m-3\\.75 {
    margin: calc(var(--spacing) * 3.75);
  }
  .m-6 {
    margin: calc(var(--spacing) * 6);
  }
  .m-\\[-3px\\] {
    margin: -3px;
  }
  .m-auto {
    margin: auto;
  }
  .-mx-2 {
    margin-inline: calc(var(--spacing) * -2);
  }
  .mx-0 {
    margin-inline: calc(var(--spacing) * 0);
  }
  .mx-0\\.5 {
    margin-inline: calc(var(--spacing) * 0.5);
  }
  .mx-1 {
    margin-inline: calc(var(--spacing) * 1);
  }
  .mx-2 {
    margin-inline: calc(var(--spacing) * 2);
  }
  .mx-3 {
    margin-inline: calc(var(--spacing) * 3);
  }
  .mx-4 {
    margin-inline: calc(var(--spacing) * 4);
  }
  .mx-\\[1px\\] {
    margin-inline: 1px;
  }
  .mx-auto {
    margin-inline: auto;
  }
  .-my-1 {
    margin-block: calc(var(--spacing) * -1);
  }
  .my-0 {
    margin-block: calc(var(--spacing) * 0);
  }
  .my-0\\.5 {
    margin-block: calc(var(--spacing) * 0.5);
  }
  .my-1 {
    margin-block: calc(var(--spacing) * 1);
  }
  .my-1\\.5 {
    margin-block: calc(var(--spacing) * 1.5);
  }
  .my-2 {
    margin-block: calc(var(--spacing) * 2);
  }
  .my-3 {
    margin-block: calc(var(--spacing) * 3);
  }
  .my-4 {
    margin-block: calc(var(--spacing) * 4);
  }
  .my-5 {
    margin-block: calc(var(--spacing) * 5);
  }
  .my-6 {
    margin-block: calc(var(--spacing) * 6);
  }
  .my-9 {
    margin-block: calc(var(--spacing) * 9);
  }
  .my-auto {
    margin-block: auto;
  }
  .-ms-1 {
    margin-inline-start: calc(var(--spacing) * -1);
  }
  .-ms-2 {
    margin-inline-start: calc(var(--spacing) * -2);
  }
  .-ms-3 {
    margin-inline-start: calc(var(--spacing) * -3);
  }
  .ms-0\\.5 {
    margin-inline-start: calc(var(--spacing) * 0.5);
  }
  .ms-1 {
    margin-inline-start: calc(var(--spacing) * 1);
  }
  .ms-1\\.5 {
    margin-inline-start: calc(var(--spacing) * 1.5);
  }
  .ms-2 {
    margin-inline-start: calc(var(--spacing) * 2);
  }
  .ms-3 {
    margin-inline-start: calc(var(--spacing) * 3);
  }
  .ms-4 {
    margin-inline-start: calc(var(--spacing) * 4);
  }
  .ms-6 {
    margin-inline-start: calc(var(--spacing) * 6);
  }
  .ms-7 {
    margin-inline-start: calc(var(--spacing) * 7);
  }
  .ms-8 {
    margin-inline-start: calc(var(--spacing) * 8);
  }
  .ms-9 {
    margin-inline-start: calc(var(--spacing) * 9);
  }
  .ms-12 {
    margin-inline-start: calc(var(--spacing) * 12);
  }
  .ms-18 {
    margin-inline-start: calc(var(--spacing) * 18);
  }
  .ms-auto {
    margin-inline-start: auto;
  }
  .\\!me-2 {
    margin-inline-end: calc(var(--spacing) * 2) !important;
  }
  .-me-1 {
    margin-inline-end: calc(var(--spacing) * -1);
  }
  .-me-1\\.5 {
    margin-inline-end: calc(var(--spacing) * -1.5);
  }
  .-me-2 {
    margin-inline-end: calc(var(--spacing) * -2);
  }
  .me-0 {
    margin-inline-end: calc(var(--spacing) * 0);
  }
  .me-1 {
    margin-inline-end: calc(var(--spacing) * 1);
  }
  .me-1\\.5 {
    margin-inline-end: calc(var(--spacing) * 1.5);
  }
  .me-2 {
    margin-inline-end: calc(var(--spacing) * 2);
  }
  .me-3 {
    margin-inline-end: calc(var(--spacing) * 3);
  }
  .me-3\\.75 {
    margin-inline-end: calc(var(--spacing) * 3.75);
  }
  .me-4 {
    margin-inline-end: calc(var(--spacing) * 4);
  }
  .me-5 {
    margin-inline-end: calc(var(--spacing) * 5);
  }
  .me-6 {
    margin-inline-end: calc(var(--spacing) * 6);
  }
  .me-auto {
    margin-inline-end: auto;
  }
  .me-px {
    margin-inline-end: 1px;
  }
  .\\!-mt-0 {
    margin-top: calc(var(--spacing) * -0) !important;
  }
  .\\!-mt-6 {
    margin-top: calc(var(--spacing) * -6) !important;
  }
  .-mt-1 {
    margin-top: calc(var(--spacing) * -1);
  }
  .mt-0 {
    margin-top: calc(var(--spacing) * 0);
  }
  .mt-0\\.5 {
    margin-top: calc(var(--spacing) * 0.5);
  }
  .mt-1 {
    margin-top: calc(var(--spacing) * 1);
  }
  .mt-1\\.5 {
    margin-top: calc(var(--spacing) * 1.5);
  }
  .mt-2 {
    margin-top: calc(var(--spacing) * 2);
  }
  .mt-2\\.5 {
    margin-top: calc(var(--spacing) * 2.5);
  }
  .mt-3 {
    margin-top: calc(var(--spacing) * 3);
  }
  .mt-4 {
    margin-top: calc(var(--spacing) * 4);
  }
  .mt-5 {
    margin-top: calc(var(--spacing) * 5);
  }
  .mt-6 {
    margin-top: calc(var(--spacing) * 6);
  }
  .mt-7 {
    margin-top: calc(var(--spacing) * 7);
  }
  .mt-8 {
    margin-top: calc(var(--spacing) * 8);
  }
  .mt-9 {
    margin-top: calc(var(--spacing) * 9);
  }
  .mt-10 {
    margin-top: calc(var(--spacing) * 10);
  }
  .mt-12 {
    margin-top: calc(var(--spacing) * 12);
  }
  .mt-18 {
    margin-top: calc(var(--spacing) * 18);
  }
  .mt-auto {
    margin-top: auto;
  }
  .mr-2 {
    margin-right: calc(var(--spacing) * 2);
  }
  .mr-4 {
    margin-right: calc(var(--spacing) * 4);
  }
  .-mb-1 {
    margin-bottom: calc(var(--spacing) * -1);
  }
  .-mb-5 {
    margin-bottom: calc(var(--spacing) * -5);
  }
  .mb-0 {
    margin-bottom: calc(var(--spacing) * 0);
  }
  .mb-0\\.5 {
    margin-bottom: calc(var(--spacing) * 0.5);
  }
  .mb-1 {
    margin-bottom: calc(var(--spacing) * 1);
  }
  .mb-1\\.5 {
    margin-bottom: calc(var(--spacing) * 1.5);
  }
  .mb-2 {
    margin-bottom: calc(var(--spacing) * 2);
  }
  .mb-2\\.5 {
    margin-bottom: calc(var(--spacing) * 2.5);
  }
  .mb-3 {
    margin-bottom: calc(var(--spacing) * 3);
  }
  .mb-4 {
    margin-bottom: calc(var(--spacing) * 4);
  }
  .mb-5 {
    margin-bottom: calc(var(--spacing) * 5);
  }
  .mb-6 {
    margin-bottom: calc(var(--spacing) * 6);
  }
  .mb-8 {
    margin-bottom: calc(var(--spacing) * 8);
  }
  .mb-9 {
    margin-bottom: calc(var(--spacing) * 9);
  }
  .mb-10 {
    margin-bottom: calc(var(--spacing) * 10);
  }
  .mb-24 {
    margin-bottom: calc(var(--spacing) * 24);
  }
  .ml-1 {
    margin-left: calc(var(--spacing) * 1);
  }
  .ml-2 {
    margin-left: calc(var(--spacing) * 2);
  }
  .ml-4 {
    margin-left: calc(var(--spacing) * 4);
  }
  .ml-10 {
    margin-left: calc(var(--spacing) * 10);
  }
  .box-border {
    box-sizing: border-box;
  }
  .box-content {
    box-sizing: content-box;
  }
  .form-radio {
    appearance: none;
    padding: 0;
    print-color-adjust: exact;
    display: inline-block;
    vertical-align: middle;
    background-origin: border-box;
    user-select: none;
    flex-shrink: 0;
    height: 1rem;
    width: 1rem;
    color: oklch(54.6% 0.245 262.881);
    background-color: #fff;
    border-color: var(--color-mid-grey);
    border-width: 1px;
    --tw-shadow: 0 0 #0000;
    border-radius: 100%;
    &:focus {
      outline: 2px solid transparent;
      outline-offset: 2px;
      --tw-ring-inset: var(--tw-empty,/*!*/ /*!*/);
      --tw-ring-offset-width: 2px;
      --tw-ring-offset-color: #fff;
      --tw-ring-color: oklch(54.6% 0.245 262.881);
      --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
      --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
      box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
    }
    &:checked {
      border-color: transparent;
      background-color: currentColor;
      background-size: 100% 100%;
      background-position: center;
      background-repeat: no-repeat;
    }
    &:checked {
      background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
      @media (forced-colors: active) {
        appearance: auto;
      }
    }
    &:checked:hover {
      border-color: transparent;
      background-color: currentColor;
    }
    &:checked:focus {
      border-color: transparent;
      background-color: currentColor;
    }
  }
  .form-input {
    appearance: none;
    background-color: #fff;
    border-color: var(--color-mid-grey);
    border-width: 1px;
    border-radius: 0px;
    padding-top: 0.5rem;
    padding-right: 0.75rem;
    padding-bottom: 0.5rem;
    padding-left: 0.75rem;
    font-size: 1rem;
    line-height: 1.5rem;
    --tw-shadow: 0 0 #0000;
    &:focus {
      outline: 2px solid transparent;
      outline-offset: 2px;
      --tw-ring-inset: var(--tw-empty,/*!*/ /*!*/);
      --tw-ring-offset-width: 0px;
      --tw-ring-offset-color: #fff;
      --tw-ring-color: oklch(54.6% 0.245 262.881);
      --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
      --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
      box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
      border-color: oklch(54.6% 0.245 262.881);
    }
    &::placeholder {
      color: var(--color-mid-grey);
      opacity: 1;
    }
    &::-webkit-datetime-edit-fields-wrapper {
      padding: 0;
    }
    &::-webkit-date-and-time-value {
      min-height: 1.5em;
    }
    &::-webkit-date-and-time-value {
      text-align: inherit;
    }
    &::-webkit-datetime-edit {
      display: inline-flex;
    }
    &::-webkit-datetime-edit {
      padding-top: 0;
      padding-bottom: 0;
    }
    &::-webkit-datetime-edit-year-field {
      padding-top: 0;
      padding-bottom: 0;
    }
    &::-webkit-datetime-edit-month-field {
      padding-top: 0;
      padding-bottom: 0;
    }
    &::-webkit-datetime-edit-day-field {
      padding-top: 0;
      padding-bottom: 0;
    }
    &::-webkit-datetime-edit-hour-field {
      padding-top: 0;
      padding-bottom: 0;
    }
    &::-webkit-datetime-edit-minute-field {
      padding-top: 0;
      padding-bottom: 0;
    }
    &::-webkit-datetime-edit-second-field {
      padding-top: 0;
      padding-bottom: 0;
    }
    &::-webkit-datetime-edit-millisecond-field {
      padding-top: 0;
      padding-bottom: 0;
    }
    &::-webkit-datetime-edit-meridiem-field {
      padding-top: 0;
      padding-bottom: 0;
    }
  }
  .line-clamp-1 {
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
  }
  .line-clamp-2 {
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }
  .line-clamp-4 {
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 4;
  }
  .line-clamp-5 {
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 5;
  }
  .\\!flex {
    display: flex !important;
  }
  .\\!hidden {
    display: none !important;
  }
  .\\!inline {
    display: inline !important;
  }
  .block {
    display: block;
  }
  .contents {
    display: contents;
  }
  .flex {
    display: flex;
  }
  .grid {
    display: grid;
  }
  .hidden {
    display: none;
  }
  .inline {
    display: inline;
  }
  .inline-block {
    display: inline-block;
  }
  .inline-flex {
    display: inline-flex;
  }
  .table {
    display: table;
  }
  .aspect-auto {
    aspect-ratio: auto;
  }
  .aspect-square {
    aspect-ratio: 1 / 1;
  }
  .aspect-video {
    aspect-ratio: var(--aspect-video);
  }
  .meeting-tile-avatar {
    --meeting-tile-avatar-size: clamp(24px, calc(100cqmin - 48px), 124px);
    width: var(--meeting-tile-avatar-size);
    height: var(--meeting-tile-avatar-size);
    font-size: calc(var(--meeting-tile-avatar-size) * 0.194);
  }
  .\\!size-4 {
    width: calc(var(--spacing) * 4) !important;
    height: calc(var(--spacing) * 4) !important;
  }
  .\\!size-full {
    width: 100% !important;
    height: 100% !important;
  }
  .size-1 {
    width: calc(var(--spacing) * 1);
    height: calc(var(--spacing) * 1);
  }
  .size-1\\.5 {
    width: calc(var(--spacing) * 1.5);
    height: calc(var(--spacing) * 1.5);
  }
  .size-2 {
    width: calc(var(--spacing) * 2);
    height: calc(var(--spacing) * 2);
  }
  .size-2\\.5 {
    width: calc(var(--spacing) * 2.5);
    height: calc(var(--spacing) * 2.5);
  }
  .size-3 {
    width: calc(var(--spacing) * 3);
    height: calc(var(--spacing) * 3);
  }
  .size-4 {
    width: calc(var(--spacing) * 4);
    height: calc(var(--spacing) * 4);
  }
  .size-4\\.5 {
    width: calc(var(--spacing) * 4.5);
    height: calc(var(--spacing) * 4.5);
  }
  .size-5 {
    width: calc(var(--spacing) * 5);
    height: calc(var(--spacing) * 5);
  }
  .size-6 {
    width: calc(var(--spacing) * 6);
    height: calc(var(--spacing) * 6);
  }
  .size-7 {
    width: calc(var(--spacing) * 7);
    height: calc(var(--spacing) * 7);
  }
  .size-8 {
    width: calc(var(--spacing) * 8);
    height: calc(var(--spacing) * 8);
  }
  .size-8\\! {
    width: calc(var(--spacing) * 8) !important;
    height: calc(var(--spacing) * 8) !important;
  }
  .size-9 {
    width: calc(var(--spacing) * 9);
    height: calc(var(--spacing) * 9);
  }
  .size-10 {
    width: calc(var(--spacing) * 10);
    height: calc(var(--spacing) * 10);
  }
  .size-10\\! {
    width: calc(var(--spacing) * 10) !important;
    height: calc(var(--spacing) * 10) !important;
  }
  .size-12 {
    width: calc(var(--spacing) * 12);
    height: calc(var(--spacing) * 12);
  }
  .size-14 {
    width: calc(var(--spacing) * 14);
    height: calc(var(--spacing) * 14);
  }
  .size-20 {
    width: calc(var(--spacing) * 20);
    height: calc(var(--spacing) * 20);
  }
  .size-24 {
    width: calc(var(--spacing) * 24);
    height: calc(var(--spacing) * 24);
  }
  .size-40 {
    width: calc(var(--spacing) * 40);
    height: calc(var(--spacing) * 40);
  }
  .size-\\[10px\\] {
    width: 10px;
    height: 10px;
  }
  .size-\\[18px\\]\\! {
    width: 18px !important;
    height: 18px !important;
  }
  .size-full {
    width: 100%;
    height: 100%;
  }
  .\\!h-6 {
    height: calc(var(--spacing) * 6) !important;
  }
  .\\!h-11 {
    height: calc(var(--spacing) * 11) !important;
  }
  .\\!h-36 {
    height: calc(var(--spacing) * 36) !important;
  }
  .h-1 {
    height: calc(var(--spacing) * 1);
  }
  .h-1\\.5 {
    height: calc(var(--spacing) * 1.5);
  }
  .h-2 {
    height: calc(var(--spacing) * 2);
  }
  .h-2\\.5 {
    height: calc(var(--spacing) * 2.5);
  }
  .h-3 {
    height: calc(var(--spacing) * 3);
  }
  .h-3\\.5 {
    height: calc(var(--spacing) * 3.5);
  }
  .h-3\\/4 {
    height: calc(3/4 * 100%);
  }
  .h-4 {
    height: calc(var(--spacing) * 4);
  }
  .h-5 {
    height: calc(var(--spacing) * 5);
  }
  .h-6 {
    height: calc(var(--spacing) * 6);
  }
  .h-7 {
    height: calc(var(--spacing) * 7);
  }
  .h-7\\.5 {
    height: calc(var(--spacing) * 7.5);
  }
  .h-8 {
    height: calc(var(--spacing) * 8);
  }
  .h-9 {
    height: calc(var(--spacing) * 9);
  }
  .h-10 {
    height: calc(var(--spacing) * 10);
  }
  .h-11 {
    height: calc(var(--spacing) * 11);
  }
  .h-12 {
    height: calc(var(--spacing) * 12);
  }
  .h-13 {
    height: calc(var(--spacing) * 13);
  }
  .h-14 {
    height: calc(var(--spacing) * 14);
  }
  .h-15 {
    height: calc(var(--spacing) * 15);
  }
  .h-16 {
    height: calc(var(--spacing) * 16);
  }
  .h-18 {
    height: calc(var(--spacing) * 18);
  }
  .h-20 {
    height: calc(var(--spacing) * 20);
  }
  .h-21 {
    height: calc(var(--spacing) * 21);
  }
  .h-27 {
    height: calc(var(--spacing) * 27);
  }
  .h-32 {
    height: calc(var(--spacing) * 32);
  }
  .h-36 {
    height: calc(var(--spacing) * 36);
  }
  .h-40 {
    height: calc(var(--spacing) * 40);
  }
  .h-64 {
    height: calc(var(--spacing) * 64);
  }
  .h-72 {
    height: calc(var(--spacing) * 72);
  }
  .h-96 {
    height: calc(var(--spacing) * 96);
  }
  .h-\\[1px\\] {
    height: 1px;
  }
  .h-\\[21\\.5rem\\] {
    height: 21.5rem;
  }
  .h-\\[22\\.5rem\\] {
    height: 22.5rem;
  }
  .h-\\[39\\.5rem\\] {
    height: 39.5rem;
  }
  .h-\\[40px\\] {
    height: 40px;
  }
  .h-\\[45px\\] {
    height: 45px;
  }
  .h-\\[46px\\] {
    height: 46px;
  }
  .h-\\[49rem\\] {
    height: 49rem;
  }
  .h-\\[60dvh\\] {
    height: 60dvh;
  }
  .h-\\[60px\\] {
    height: 60px;
  }
  .h-\\[80dvh\\] {
    height: 80dvh;
  }
  .h-\\[84px\\] {
    height: 84px;
  }
  .h-\\[90px\\] {
    height: 90px;
  }
  .h-\\[120\\%\\] {
    height: 120%;
  }
  .h-\\[140px\\] {
    height: 140px;
  }
  .h-\\[184px\\] {
    height: 184px;
  }
  .h-\\[200px\\] {
    height: 200px;
  }
  .h-\\[300px\\] {
    height: 300px;
  }
  .h-\\[440px\\] {
    height: 440px;
  }
  .h-\\[510px\\] {
    height: 510px;
  }
  .h-\\[620px\\] {
    height: 620px;
  }
  .h-\\[calc\\(90dvh-60px\\)\\] {
    height: calc(90dvh - 60px);
  }
  .h-\\[calc\\(100\\%-38rem\\)\\] {
    height: calc(100% - 38rem);
  }
  .h-\\[calc\\(100vh-var\\(--spacing-meeting-header\\)-var\\(--spacing-meeting-footer\\)\\)\\] {
    height: calc(100vh - var(--spacing-meeting-header) - var(--spacing-meeting-footer));
  }
  .h-auto {
    height: auto;
  }
  .h-fit {
    height: fit-content;
  }
  .h-full {
    height: 100%;
  }
  .h-meeting-footer {
    height: var(--spacing-meeting-footer);
  }
  .h-meeting-header {
    height: var(--spacing-meeting-header);
  }
  .h-px {
    height: 1px;
  }
  .h-screen {
    height: 100vh;
  }
  .\\!max-h-72 {
    max-height: calc(var(--spacing) * 72) !important;
  }
  .max-h-6 {
    max-height: calc(var(--spacing) * 6);
  }
  .max-h-24 {
    max-height: calc(var(--spacing) * 24);
  }
  .max-h-32 {
    max-height: calc(var(--spacing) * 32);
  }
  .max-h-40 {
    max-height: calc(var(--spacing) * 40);
  }
  .max-h-42 {
    max-height: calc(var(--spacing) * 42);
  }
  .max-h-52 {
    max-height: calc(var(--spacing) * 52);
  }
  .max-h-56 {
    max-height: calc(var(--spacing) * 56);
  }
  .max-h-60 {
    max-height: calc(var(--spacing) * 60);
  }
  .max-h-64 {
    max-height: calc(var(--spacing) * 64);
  }
  .max-h-72 {
    max-height: calc(var(--spacing) * 72);
  }
  .max-h-96 {
    max-height: calc(var(--spacing) * 96);
  }
  .max-h-200 {
    max-height: calc(var(--spacing) * 200);
  }
  .max-h-\\[30dvh\\] {
    max-height: 30dvh;
  }
  .max-h-\\[80dvh\\] {
    max-height: 80dvh;
  }
  .max-h-\\[90dvh\\] {
    max-height: 90dvh;
  }
  .max-h-\\[184px\\] {
    max-height: 184px;
  }
  .max-h-\\[200px\\] {
    max-height: 200px;
  }
  .max-h-\\[210px\\] {
    max-height: 210px;
  }
  .max-h-\\[230px\\] {
    max-height: 230px;
  }
  .max-h-\\[270px\\] {
    max-height: 270px;
  }
  .max-h-\\[320px\\] {
    max-height: 320px;
  }
  .max-h-\\[340px\\] {
    max-height: 340px;
  }
  .max-h-\\[350px\\] {
    max-height: 350px;
  }
  .max-h-\\[360px\\] {
    max-height: 360px;
  }
  .max-h-\\[400px\\] {
    max-height: 400px;
  }
  .max-h-\\[500px\\] {
    max-height: 500px;
  }
  .max-h-\\[520px\\] {
    max-height: 520px;
  }
  .max-h-\\[780px\\] {
    max-height: 780px;
  }
  .max-h-\\[calc\\(100\\%-60px\\)\\] {
    max-height: calc(100% - 60px);
  }
  .max-h-\\[calc\\(100\\%-140px\\)\\] {
    max-height: calc(100% - 140px);
  }
  .max-h-\\[calc\\(100\\%-240px\\)\\] {
    max-height: calc(100% - 240px);
  }
  .max-h-\\[calc\\(100dvh-2rem\\)\\] {
    max-height: calc(100dvh - 2rem);
  }
  .max-h-full {
    max-height: 100%;
  }
  .min-h-0 {
    min-height: calc(var(--spacing) * 0);
  }
  .min-h-4 {
    min-height: calc(var(--spacing) * 4);
  }
  .min-h-6 {
    min-height: calc(var(--spacing) * 6);
  }
  .min-h-9 {
    min-height: calc(var(--spacing) * 9);
  }
  .min-h-10 {
    min-height: calc(var(--spacing) * 10);
  }
  .min-h-12 {
    min-height: calc(var(--spacing) * 12);
  }
  .min-h-16 {
    min-height: calc(var(--spacing) * 16);
  }
  .min-h-40 {
    min-height: calc(var(--spacing) * 40);
  }
  .min-h-42 {
    min-height: calc(var(--spacing) * 42);
  }
  .min-h-52 {
    min-height: calc(var(--spacing) * 52);
  }
  .min-h-64 {
    min-height: calc(var(--spacing) * 64);
  }
  .min-h-\\[32px\\] {
    min-height: 32px;
  }
  .min-h-\\[50dvh\\] {
    min-height: 50dvh;
  }
  .min-h-\\[90dvh\\] {
    min-height: 90dvh;
  }
  .min-h-\\[260px\\] {
    min-height: 260px;
  }
  .min-h-\\[320px\\] {
    min-height: 320px;
  }
  .min-h-\\[400px\\] {
    min-height: 400px;
  }
  .min-h-\\[564px\\] {
    min-height: 564px;
  }
  .min-h-\\[796px\\] {
    min-height: 796px;
  }
  .min-h-\\[min\\(480px\\,80dvh\\)\\] {
    min-height: min(480px, 80dvh);
  }
  .min-h-full {
    min-height: 100%;
  }
  .min-h-screen {
    min-height: 100vh;
  }
  .\\!w-0 {
    width: calc(var(--spacing) * 0) !important;
  }
  .\\!w-6 {
    width: calc(var(--spacing) * 6) !important;
  }
  .\\!w-36 {
    width: calc(var(--spacing) * 36) !important;
  }
  .\\!w-\\[600px\\] {
    width: 600px !important;
  }
  .\\!w-auto {
    width: auto !important;
  }
  .w-\\(--button-width\\) {
    width: var(--button-width);
  }
  .w-\\(--input-width\\) {
    width: var(--input-width);
  }
  .w-\\(--spacing-meeting-side-panel\\) {
    width: var(--spacing-meeting-side-panel);
  }
  .w-0 {
    width: calc(var(--spacing) * 0);
  }
  .w-2 {
    width: calc(var(--spacing) * 2);
  }
  .w-2\\.5 {
    width: calc(var(--spacing) * 2.5);
  }
  .w-2\\/3 {
    width: calc(2/3 * 100%);
  }
  .w-2\\/5 {
    width: calc(2/5 * 100%);
  }
  .w-2xl {
    width: var(--container-2xl);
  }
  .w-3 {
    width: calc(var(--spacing) * 3);
  }
  .w-3\\/4 {
    width: calc(3/4 * 100%);
  }
  .w-4 {
    width: calc(var(--spacing) * 4);
  }
  .w-4\\/5 {
    width: calc(4/5 * 100%);
  }
  .w-5 {
    width: calc(var(--spacing) * 5);
  }
  .w-5\\/6 {
    width: calc(5/6 * 100%);
  }
  .w-6 {
    width: calc(var(--spacing) * 6);
  }
  .w-7 {
    width: calc(var(--spacing) * 7);
  }
  .w-7\\/12 {
    width: calc(7/12 * 100%);
  }
  .w-8 {
    width: calc(var(--spacing) * 8);
  }
  .w-9 {
    width: calc(var(--spacing) * 9);
  }
  .w-9\\/12 {
    width: calc(9/12 * 100%);
  }
  .w-10 {
    width: calc(var(--spacing) * 10);
  }
  .w-10\\/12 {
    width: calc(10/12 * 100%);
  }
  .w-11 {
    width: calc(var(--spacing) * 11);
  }
  .w-11\\/12 {
    width: calc(11/12 * 100%);
  }
  .w-12 {
    width: calc(var(--spacing) * 12);
  }
  .w-16 {
    width: calc(var(--spacing) * 16);
  }
  .w-20 {
    width: calc(var(--spacing) * 20);
  }
  .w-21 {
    width: calc(var(--spacing) * 21);
  }
  .w-24 {
    width: calc(var(--spacing) * 24);
  }
  .w-28 {
    width: calc(var(--spacing) * 28);
  }
  .w-32 {
    width: calc(var(--spacing) * 32);
  }
  .w-36 {
    width: calc(var(--spacing) * 36);
  }
  .w-40 {
    width: calc(var(--spacing) * 40);
  }
  .w-44 {
    width: calc(var(--spacing) * 44);
  }
  .w-46 {
    width: calc(var(--spacing) * 46);
  }
  .w-48 {
    width: calc(var(--spacing) * 48);
  }
  .w-52 {
    width: calc(var(--spacing) * 52);
  }
  .w-56 {
    width: calc(var(--spacing) * 56);
  }
  .w-60 {
    width: calc(var(--spacing) * 60);
  }
  .w-64 {
    width: calc(var(--spacing) * 64);
  }
  .w-72 {
    width: calc(var(--spacing) * 72);
  }
  .w-80 {
    width: calc(var(--spacing) * 80);
  }
  .w-90 {
    width: calc(var(--spacing) * 90);
  }
  .w-96 {
    width: calc(var(--spacing) * 96);
  }
  .w-99 {
    width: calc(var(--spacing) * 99);
  }
  .w-\\[1px\\] {
    width: 1px;
  }
  .w-\\[3px\\] {
    width: 3px;
  }
  .w-\\[5\\.5rem\\] {
    width: 5.5rem;
  }
  .w-\\[40px\\] {
    width: 40px;
  }
  .w-\\[80px\\] {
    width: 80px;
  }
  .w-\\[160px\\] {
    width: 160px;
  }
  .w-\\[180px\\] {
    width: 180px;
  }
  .w-\\[200px\\] {
    width: 200px;
  }
  .w-\\[216px\\] {
    width: 216px;
  }
  .w-\\[300px\\] {
    width: 300px;
  }
  .w-\\[320px\\] {
    width: 320px;
  }
  .w-\\[328px\\] {
    width: 328px;
  }
  .w-\\[360px\\] {
    width: 360px;
  }
  .w-\\[400px\\] {
    width: 400px;
  }
  .w-\\[420px\\] {
    width: 420px;
  }
  .w-\\[440px\\] {
    width: 440px;
  }
  .w-\\[450px\\] {
    width: 450px;
  }
  .w-\\[480px\\] {
    width: 480px;
  }
  .w-\\[500px\\] {
    width: 500px;
  }
  .w-\\[600px\\] {
    width: 600px;
  }
  .w-\\[700px\\] {
    width: 700px;
  }
  .w-\\[800px\\] {
    width: 800px;
  }
  .w-\\[924px\\] {
    width: 924px;
  }
  .w-auto {
    width: auto;
  }
  .w-fit {
    width: fit-content;
  }
  .w-full {
    width: 100%;
  }
  .w-max {
    width: max-content;
  }
  .w-px {
    width: 1px;
  }
  .w-screen {
    width: 100vw;
  }
  .max-w-1\\/2 {
    max-width: calc(1/2 * 100%);
  }
  .max-w-1\\/5 {
    max-width: calc(1/5 * 100%);
  }
  .max-w-2xl {
    max-width: var(--container-2xl);
  }
  .max-w-3\\/4 {
    max-width: calc(3/4 * 100%);
  }
  .max-w-3xl {
    max-width: var(--container-3xl);
  }
  .max-w-4\\.5 {
    max-width: calc(var(--spacing) * 4.5);
  }
  .max-w-5 {
    max-width: calc(var(--spacing) * 5);
  }
  .max-w-6 {
    max-width: calc(var(--spacing) * 6);
  }
  .max-w-40 {
    max-width: calc(var(--spacing) * 40);
  }
  .max-w-96 {
    max-width: calc(var(--spacing) * 96);
  }
  .max-w-99 {
    max-width: calc(var(--spacing) * 99);
  }
  .max-w-180 {
    max-width: calc(var(--spacing) * 180);
  }
  .max-w-\\[60\\%\\] {
    max-width: 60%;
  }
  .max-w-\\[90px\\] {
    max-width: 90px;
  }
  .max-w-\\[120px\\] {
    max-width: 120px;
  }
  .max-w-\\[180px\\] {
    max-width: 180px;
  }
  .max-w-\\[184px\\] {
    max-width: 184px;
  }
  .max-w-\\[240px\\] {
    max-width: 240px;
  }
  .max-w-\\[280px\\] {
    max-width: 280px;
  }
  .max-w-\\[300px\\] {
    max-width: 300px;
  }
  .max-w-\\[400px\\] {
    max-width: 400px;
  }
  .max-w-\\[500px\\] {
    max-width: 500px;
  }
  .max-w-\\[540px\\] {
    max-width: 540px;
  }
  .max-w-\\[600\\] {
    max-width: 600;
  }
  .max-w-\\[600px\\] {
    max-width: 600px;
  }
  .max-w-\\[1200px\\] {
    max-width: 1200px;
  }
  .max-w-\\[calc\\(100\\%-var\\(--spacing-meeting-side-panel\\)\\)\\] {
    max-width: calc(100% - var(--spacing-meeting-side-panel));
  }
  .max-w-\\[calc\\(568px_-_44px\\)\\] {
    max-width: calc(568px - 44px);
  }
  .max-w-fit {
    max-width: fit-content;
  }
  .max-w-full {
    max-width: 100%;
  }
  .max-w-md {
    max-width: var(--container-md);
  }
  .max-w-none {
    max-width: none;
  }
  .max-w-screen-md {
    max-width: var(--breakpoint-md);
  }
  .max-w-screen-sm {
    max-width: var(--breakpoint-sm);
  }
  .max-w-sm {
    max-width: var(--container-sm);
  }
  .max-w-xl {
    max-width: var(--container-xl);
  }
  .max-w-xs {
    max-width: var(--container-xs);
  }
  .\\!min-w-0 {
    min-width: calc(var(--spacing) * 0) !important;
  }
  .\\!min-w-8 {
    min-width: calc(var(--spacing) * 8) !important;
  }
  .\\!min-w-\\[80px\\] {
    min-width: 80px !important;
  }
  .\\!min-w-\\[82px\\] {
    min-width: 82px !important;
  }
  .\\!min-w-max {
    min-width: max-content !important;
  }
  .\\!min-w-min {
    min-width: min-content !important;
  }
  .min-w-0 {
    min-width: calc(var(--spacing) * 0);
  }
  .min-w-1\\/2 {
    min-width: calc(1/2 * 100%);
  }
  .min-w-1\\/4 {
    min-width: calc(1/4 * 100%);
  }
  .min-w-2 {
    min-width: calc(var(--spacing) * 2);
  }
  .min-w-4 {
    min-width: calc(var(--spacing) * 4);
  }
  .min-w-8 {
    min-width: calc(var(--spacing) * 8);
  }
  .min-w-9 {
    min-width: calc(var(--spacing) * 9);
  }
  .min-w-10 {
    min-width: calc(var(--spacing) * 10);
  }
  .min-w-14 {
    min-width: calc(var(--spacing) * 14);
  }
  .min-w-16 {
    min-width: calc(var(--spacing) * 16);
  }
  .min-w-36 {
    min-width: calc(var(--spacing) * 36);
  }
  .min-w-42 {
    min-width: calc(var(--spacing) * 42);
  }
  .min-w-47 {
    min-width: calc(var(--spacing) * 47);
  }
  .min-w-48 {
    min-width: calc(var(--spacing) * 48);
  }
  .min-w-52 {
    min-width: calc(var(--spacing) * 52);
  }
  .min-w-64 {
    min-width: calc(var(--spacing) * 64);
  }
  .min-w-72 {
    min-width: calc(var(--spacing) * 72);
  }
  .min-w-\\[4ch\\] {
    min-width: 4ch;
  }
  .min-w-\\[6rem\\] {
    min-width: 6rem;
  }
  .min-w-\\[60px\\] {
    min-width: 60px;
  }
  .min-w-\\[120px\\] {
    min-width: 120px;
  }
  .min-w-\\[150px\\] {
    min-width: 150px;
  }
  .min-w-\\[180px\\] {
    min-width: 180px;
  }
  .min-w-\\[186px\\] {
    min-width: 186px;
  }
  .min-w-\\[200px\\] {
    min-width: 200px;
  }
  .min-w-\\[276px\\] {
    min-width: 276px;
  }
  .min-w-\\[280px\\] {
    min-width: 280px;
  }
  .min-w-\\[360px\\] {
    min-width: 360px;
  }
  .min-w-\\[400px\\] {
    min-width: 400px;
  }
  .min-w-\\[688px\\] {
    min-width: 688px;
  }
  .min-w-fit {
    min-width: fit-content;
  }
  .min-w-full {
    min-width: 100%;
  }
  .min-w-max {
    min-width: max-content;
  }
  .flex-0 {
    flex: 0;
  }
  .flex-1 {
    flex: 1;
  }
  .flex-2 {
    flex: 2;
  }
  .flex-\\[1_99_auto\\] {
    flex: 1 99 auto;
  }
  .flex-auto {
    flex: auto;
  }
  .flex-shrink-0 {
    flex-shrink: 0;
  }
  .shrink {
    flex-shrink: 1;
  }
  .shrink-0 {
    flex-shrink: 0;
  }
  .grow {
    flex-grow: 1;
  }
  .grow-0 {
    flex-grow: 0;
  }
  .grow-\\[2\\] {
    flex-grow: 2;
  }
  .basis-\\(--spacing-meeting-side-panel\\) {
    flex-basis: var(--spacing-meeting-side-panel);
  }
  .basis-0 {
    flex-basis: calc(var(--spacing) * 0);
  }
  .basis-4\\/12 {
    flex-basis: calc(4/12 * 100%);
  }
  .basis-7\\/12 {
    flex-basis: calc(7/12 * 100%);
  }
  .basis-full {
    flex-basis: 100%;
  }
  .border-collapse {
    border-collapse: collapse;
  }
  .origin-bottom-right {
    transform-origin: 100% 100%;
  }
  .origin-top {
    transform-origin: top;
  }
  .origin-top-right {
    transform-origin: 100% 0;
  }
  .translate-0 {
    --tw-translate-x: calc(var(--spacing) * 0);
    --tw-translate-y: calc(var(--spacing) * 0);
    translate: var(--tw-translate-x) var(--tw-translate-y);
  }
  .-translate-x-1\\/2 {
    --tw-translate-x: calc(calc(1/2 * 100%) * -1);
    translate: var(--tw-translate-x) var(--tw-translate-y);
  }
  .-translate-y-1 {
    --tw-translate-y: calc(var(--spacing) * -1);
    translate: var(--tw-translate-x) var(--tw-translate-y);
  }
  .-translate-y-1\\/2 {
    --tw-translate-y: calc(calc(1/2 * 100%) * -1);
    translate: var(--tw-translate-x) var(--tw-translate-y);
  }
  .-translate-y-full {
    --tw-translate-y: -100%;
    translate: var(--tw-translate-x) var(--tw-translate-y);
  }
  .translate-y-0 {
    --tw-translate-y: calc(var(--spacing) * 0);
    translate: var(--tw-translate-x) var(--tw-translate-y);
  }
  .translate-y-1 {
    --tw-translate-y: calc(var(--spacing) * 1);
    translate: var(--tw-translate-x) var(--tw-translate-y);
  }
  .translate-y-1\\/2 {
    --tw-translate-y: calc(1/2 * 100%);
    translate: var(--tw-translate-x) var(--tw-translate-y);
  }
  .translate-y-4 {
    --tw-translate-y: calc(var(--spacing) * 4);
    translate: var(--tw-translate-x) var(--tw-translate-y);
  }
  .scale-95 {
    --tw-scale-x: 95%;
    --tw-scale-y: 95%;
    --tw-scale-z: 95%;
    scale: var(--tw-scale-x) var(--tw-scale-y);
  }
  .scale-100 {
    --tw-scale-x: 100%;
    --tw-scale-y: 100%;
    --tw-scale-z: 100%;
    scale: var(--tw-scale-x) var(--tw-scale-y);
  }
  .-scale-x-100 {
    --tw-scale-x: calc(100% * -1);
    scale: var(--tw-scale-x) var(--tw-scale-y);
  }
  .scale-x-\\[-1\\] {
    --tw-scale-x: -1;
    scale: var(--tw-scale-x) var(--tw-scale-y);
  }
  .scale-y-\\[0\\.5\\] {
    --tw-scale-y: 0.5;
    scale: var(--tw-scale-x) var(--tw-scale-y);
  }
  .scale-\\[0\\.7\\] {
    scale: 0.7;
  }
  .scale-\\[0\\.8\\] {
    scale: 0.8;
  }
  .-rotate-90 {
    rotate: calc(90deg * -1);
  }
  .rotate-180 {
    rotate: 180deg;
  }
  .transform {
    transform: var(--tw-rotate-x,) var(--tw-rotate-y,) var(--tw-rotate-z,) var(--tw-skew-x,) var(--tw-skew-y,);
  }
  .text-fit-shrink {
    @supports (text-fit: shrink) {
      text-fit: shrink 60%;
      white-space: nowrap;
      & .truncate {
        --text-fit-fade-direction: to right;
        overflow-x: auto;
        scrollbar-width: none;
        text-overflow: clip;
        animation: text-fit-scroll-fade linear backwards;
        animation-timeline: scroll(self inline);
        &:dir(rtl) {
          --text-fit-fade-direction: to left;
        }
      }
    }
  }
  .animate-ellipsis {
    &::after {
      content: '';
      animation: var(--animate-ellipsis);
    }
  }
  .animate-ellipsis {
    animation: var(--animate-ellipsis);
  }
  .animate-fade {
    animation: var(--animate-fade);
  }
  .animate-fade-in {
    animation: var(--animate-fade-in);
  }
  .animate-incomingCallPulseLarge {
    animation: var(--animate-incomingCallPulseLarge);
  }
  .animate-ping {
    animation: var(--animate-ping);
  }
  .animate-pulse {
    animation: var(--animate-pulse);
  }
  .animate-slideInDialpad {
    animation: var(--animate-slideInDialpad);
  }
  .animate-slideInFromBottom {
    animation: var(--animate-slideInFromBottom);
  }
  .animate-slideOut {
    animation: var(--animate-slideOut);
  }
  .animate-spin {
    animation: var(--animate-spin);
  }
  .animate-spinSmoothAcceleration {
    animation: var(--animate-spinSmoothAcceleration);
  }
  .cursor-default {
    cursor: default;
  }
  .cursor-ew-resize {
    cursor: ew-resize;
  }
  .cursor-grab {
    cursor: grab;
  }
  .cursor-grabbing {
    cursor: grabbing;
  }
  .cursor-move {
    cursor: move;
  }
  .cursor-not-allowed {
    cursor: not-allowed;
  }
  .cursor-pointer {
    cursor: pointer;
  }
  .resize {
    resize: both;
  }
  .resize-none {
    resize: none;
  }
  .resize-y {
    resize: vertical;
  }
  .scroll-mt-10 {
    scroll-margin-top: calc(var(--spacing) * 10);
  }
  .list-decimal {
    list-style-type: decimal;
  }
  .list-disc {
    list-style-type: disc;
  }
  .list-none {
    list-style-type: none;
  }
  .appearance-none {
    appearance: none;
  }
  .grid-cols-1 {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }
  .grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  .grid-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
  .grid-cols-5 {
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }
  .grid-cols-\\[repeat\\(3\\,3rem\\)\\] {
    grid-template-columns: repeat(3,3rem);
  }
  .grid-rows-\\[0fr\\] {
    grid-template-rows: 0fr;
  }
  .grid-rows-\\[1fr\\] {
    grid-template-rows: 1fr;
  }
  .flex-col {
    flex-direction: column;
  }
  .flex-col-reverse {
    flex-direction: column-reverse;
  }
  .flex-row {
    flex-direction: row;
  }
  .flex-row-reverse {
    flex-direction: row-reverse;
  }
  .flex-nowrap {
    flex-wrap: nowrap;
  }
  .flex-wrap {
    flex-wrap: wrap;
  }
  .content-between {
    align-content: space-between;
  }
  .content-center {
    align-content: center;
  }
  .content-end {
    align-content: flex-end;
  }
  .content-start {
    align-content: flex-start;
  }
  .content-stretch {
    align-content: stretch;
  }
  .items-baseline {
    align-items: baseline;
  }
  .items-center {
    align-items: center;
  }
  .items-end {
    align-items: flex-end;
  }
  .items-start {
    align-items: flex-start;
  }
  .items-stretch {
    align-items: stretch;
  }
  .justify-around {
    justify-content: space-around;
  }
  .justify-between {
    justify-content: space-between;
  }
  .justify-center {
    justify-content: center;
  }
  .justify-center-safe {
    justify-content: safe center;
  }
  .justify-end {
    justify-content: flex-end;
  }
  .justify-evenly {
    justify-content: space-evenly;
  }
  .justify-start {
    justify-content: flex-start;
  }
  .justify-items-center {
    justify-items: center;
  }
  .justify-items-end {
    justify-items: end;
  }
  .justify-items-start {
    justify-items: start;
  }
  .\\!gap-1 {
    gap: calc(var(--spacing) * 1) !important;
  }
  .gap-0\\.5 {
    gap: calc(var(--spacing) * 0.5);
  }
  .gap-1 {
    gap: calc(var(--spacing) * 1);
  }
  .gap-1\\.5 {
    gap: calc(var(--spacing) * 1.5);
  }
  .gap-2 {
    gap: calc(var(--spacing) * 2);
  }
  .gap-2\\.5 {
    gap: calc(var(--spacing) * 2.5);
  }
  .gap-3 {
    gap: calc(var(--spacing) * 3);
  }
  .gap-4 {
    gap: calc(var(--spacing) * 4);
  }
  .gap-5 {
    gap: calc(var(--spacing) * 5);
  }
  .gap-6 {
    gap: calc(var(--spacing) * 6);
  }
  .gap-8 {
    gap: calc(var(--spacing) * 8);
  }
  .gap-9 {
    gap: calc(var(--spacing) * 9);
  }
  .gap-12 {
    gap: calc(var(--spacing) * 12);
  }
  .gap-\\[8px\\] {
    gap: 8px;
  }
  .space-y-2 {
    :where(& > :not(:last-child)) {
      --tw-space-y-reverse: 0;
      margin-block-start: calc(calc(var(--spacing) * 2) * var(--tw-space-y-reverse));
      margin-block-end: calc(calc(var(--spacing) * 2) * calc(1 - var(--tw-space-y-reverse)));
    }
  }
  .space-y-4 {
    :where(& > :not(:last-child)) {
      --tw-space-y-reverse: 0;
      margin-block-start: calc(calc(var(--spacing) * 4) * var(--tw-space-y-reverse));
      margin-block-end: calc(calc(var(--spacing) * 4) * calc(1 - var(--tw-space-y-reverse)));
    }
  }
  .gap-x-1 {
    column-gap: calc(var(--spacing) * 1);
  }
  .gap-x-2 {
    column-gap: calc(var(--spacing) * 2);
  }
  .gap-x-2\\.5 {
    column-gap: calc(var(--spacing) * 2.5);
  }
  .gap-x-3 {
    column-gap: calc(var(--spacing) * 3);
  }
  .gap-x-4 {
    column-gap: calc(var(--spacing) * 4);
  }
  .gap-x-6 {
    column-gap: calc(var(--spacing) * 6);
  }
  .gap-x-7 {
    column-gap: calc(var(--spacing) * 7);
  }
  .gap-x-px {
    column-gap: 1px;
  }
  .gap-y-0\\.5 {
    row-gap: calc(var(--spacing) * 0.5);
  }
  .gap-y-1 {
    row-gap: calc(var(--spacing) * 1);
  }
  .gap-y-1\\.5 {
    row-gap: calc(var(--spacing) * 1.5);
  }
  .gap-y-2 {
    row-gap: calc(var(--spacing) * 2);
  }
  .gap-y-3 {
    row-gap: calc(var(--spacing) * 3);
  }
  .gap-y-4 {
    row-gap: calc(var(--spacing) * 4);
  }
  .gap-y-4\\.5 {
    row-gap: calc(var(--spacing) * 4.5);
  }
  .gap-y-5 {
    row-gap: calc(var(--spacing) * 5);
  }
  .gap-y-6 {
    row-gap: calc(var(--spacing) * 6);
  }
  .gap-y-7 {
    row-gap: calc(var(--spacing) * 7);
  }
  .gap-y-9 {
    row-gap: calc(var(--spacing) * 9);
  }
  .divide-y {
    :where(& > :not(:last-child)) {
      --tw-divide-y-reverse: 0;
      border-bottom-style: var(--tw-border-style);
      border-top-style: var(--tw-border-style);
      border-top-width: calc(1px * var(--tw-divide-y-reverse));
      border-bottom-width: calc(1px * calc(1 - var(--tw-divide-y-reverse)));
    }
  }
  .self-center {
    align-self: center;
  }
  .self-end {
    align-self: flex-end;
  }
  .self-start {
    align-self: flex-start;
  }
  .self-stretch {
    align-self: stretch;
  }
  .truncate {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .\\!overflow-hidden {
    overflow: hidden !important;
  }
  .\\!overflow-visible {
    overflow: visible !important;
  }
  .overflow-auto {
    overflow: auto;
  }
  .overflow-hidden {
    overflow: hidden;
  }
  .overflow-scroll {
    overflow: scroll;
  }
  .overflow-visible {
    overflow: visible;
  }
  .overflow-visible\\! {
    overflow: visible !important;
  }
  .overflow-x-auto {
    overflow-x: auto;
  }
  .overflow-x-hidden {
    overflow-x: hidden;
  }
  .overflow-y-auto {
    overflow-y: auto;
  }
  .overflow-y-hidden {
    overflow-y: hidden;
  }
  .overflow-y-scroll {
    overflow-y: scroll;
  }
  .\\!rounded-lg {
    border-radius: var(--radius-lg) !important;
  }
  .\\!rounded-xl {
    border-radius: var(--radius-xl) !important;
  }
  .rounded {
    border-radius: 0.25rem;
  }
  .rounded-2xl {
    border-radius: var(--radius-2xl);
  }
  .rounded-3xl {
    border-radius: var(--radius-3xl);
  }
  .rounded-4xl {
    border-radius: var(--radius-4xl);
  }
  .rounded-\\[3px\\] {
    border-radius: 3px;
  }
  .rounded-\\[4px\\] {
    border-radius: 4px;
  }
  .rounded-full {
    border-radius: calc(infinity * 1px);
  }
  .rounded-lg {
    border-radius: var(--radius-lg);
  }
  .rounded-md {
    border-radius: var(--radius-md);
  }
  .rounded-none {
    border-radius: 0;
  }
  .rounded-sm {
    border-radius: var(--radius-sm);
  }
  .rounded-xl {
    border-radius: var(--radius-xl);
  }
  .rounded-xs {
    border-radius: var(--radius-xs);
  }
  .rounded-s-none {
    border-start-start-radius: 0;
    border-end-start-radius: 0;
  }
  .rounded-s-sm {
    border-start-start-radius: var(--radius-sm);
    border-end-start-radius: var(--radius-sm);
  }
  .rounded-ss-sm {
    border-start-start-radius: var(--radius-sm);
  }
  .rounded-e-md {
    border-start-end-radius: var(--radius-md);
    border-end-end-radius: var(--radius-md);
  }
  .rounded-e-none {
    border-start-end-radius: 0;
    border-end-end-radius: 0;
  }
  .rounded-e-sm {
    border-start-end-radius: var(--radius-sm);
    border-end-end-radius: var(--radius-sm);
  }
  .rounded-se-sm {
    border-start-end-radius: var(--radius-sm);
  }
  .rounded-t-\\[40px\\] {
    border-top-left-radius: 40px;
    border-top-right-radius: 40px;
  }
  .rounded-t-none {
    border-top-left-radius: 0;
    border-top-right-radius: 0;
  }
  .rounded-t-sm {
    border-top-left-radius: var(--radius-sm);
    border-top-right-radius: var(--radius-sm);
  }
  .rounded-b-\\[80px\\] {
    border-bottom-right-radius: 80px;
    border-bottom-left-radius: 80px;
  }
  .rounded-b-md {
    border-bottom-right-radius: var(--radius-md);
    border-bottom-left-radius: var(--radius-md);
  }
  .rounded-b-none {
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 0;
  }
  .rounded-b-sm {
    border-bottom-right-radius: var(--radius-sm);
    border-bottom-left-radius: var(--radius-sm);
  }
  .border {
    border-style: var(--tw-border-style);
    border-width: 1px;
  }
  .border-0 {
    border-style: var(--tw-border-style);
    border-width: 0px;
  }
  .border-1 {
    border-style: var(--tw-border-style);
    border-width: 1px;
  }
  .border-2 {
    border-style: var(--tw-border-style);
    border-width: 2px;
  }
  .border-4 {
    border-style: var(--tw-border-style);
    border-width: 4px;
  }
  .border-\\[1\\.5px\\] {
    border-style: var(--tw-border-style);
    border-width: 1.5px;
  }
  .border-s {
    border-inline-start-style: var(--tw-border-style);
    border-inline-start-width: 1px;
  }
  .border-s-2 {
    border-inline-start-style: var(--tw-border-style);
    border-inline-start-width: 2px;
  }
  .border-e {
    border-inline-end-style: var(--tw-border-style);
    border-inline-end-width: 1px;
  }
  .border-t {
    border-top-style: var(--tw-border-style);
    border-top-width: 1px;
  }
  .border-b {
    border-bottom-style: var(--tw-border-style);
    border-bottom-width: 1px;
  }
  .border-dashed {
    --tw-border-style: dashed;
    border-style: dashed;
  }
  .border-none {
    --tw-border-style: none;
    border-style: none;
  }
  .border-solid {
    --tw-border-style: solid;
    border-style: solid;
  }
  .border-\\[\\#1D1D1A\\] {
    border-color: #1D1D1A;
  }
  .border-amber-700 {
    border-color: var(--color-amber-700);
  }
  .border-black {
    border-color: var(--color-black);
  }
  .border-current {
    border-color: currentcolor;
  }
  .border-gray-100 {
    border-color: var(--color-gray-100);
  }
  .border-gray-200 {
    border-color: var(--color-gray-200);
  }
  .border-gray-300 {
    border-color: var(--color-gray-300);
  }
  .border-gray-400 {
    border-color: var(--color-gray-400);
  }
  .border-gray-500 {
    border-color: var(--color-gray-500);
  }
  .border-gray-600 {
    border-color: var(--color-gray-600);
  }
  .border-gray-700 {
    border-color: var(--color-gray-700);
  }
  .border-gray-800 {
    border-color: var(--color-gray-800);
  }
  .border-green {
    border-color: var(--color-green);
  }
  .border-red {
    border-color: var(--color-red);
  }
  .border-transparent {
    border-color: transparent;
  }
  .border-white {
    border-color: var(--color-white);
  }
  .border-white\\/10 {
    border-color: var(--color-white);
    @supports (color: color-mix(in lab, red, red)) {
      border-color: color-mix(in oklab, var(--color-white) 10%, transparent);
    }
  }
  .border-yellow {
    border-color: var(--color-yellow);
  }
  .border-t-gray-800 {
    border-top-color: var(--color-gray-800);
  }
  .\\!bg-gray-150 {
    background-color: var(--color-gray-150) !important;
  }
  .\\!bg-gray-700 {
    background-color: var(--color-gray-700) !important;
  }
  .\\!bg-gray-800 {
    background-color: var(--color-gray-800) !important;
  }
  .\\!bg-transparent {
    background-color: transparent !important;
  }
  .bg-\\[\\#0A513A\\] {
    background-color: #0A513A;
  }
  .bg-\\[\\#FCF2D8\\] {
    background-color: #FCF2D8;
  }
  .bg-amber-900\\/40 {
    background-color: color-mix(in srgb, oklch(41.4% 0.112 45.904) 40%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-amber-900) 40%, transparent);
    }
  }
  .bg-black {
    background-color: var(--color-black);
  }
  .bg-black\\/5 {
    background-color: var(--color-black);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-black) 5%, transparent);
    }
  }
  .bg-black\\/40 {
    background-color: var(--color-black);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-black) 40%, transparent);
    }
  }
  .bg-black\\/50 {
    background-color: var(--color-black);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-black) 50%, transparent);
    }
  }
  .bg-black\\/70 {
    background-color: var(--color-black);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-black) 70%, transparent);
    }
  }
  .bg-black\\/80 {
    background-color: var(--color-black);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-black) 80%, transparent);
    }
  }
  .bg-current {
    background-color: currentcolor;
  }
  .bg-flavor-1 {
    background-color: var(--color-flavor-1);
  }
  .bg-flavor-1\\/50 {
    background-color: var(--color-flavor-1);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-flavor-1) 50%, transparent);
    }
  }
  .bg-flavor-2 {
    background-color: var(--color-flavor-2);
  }
  .bg-flavor-2\\/50 {
    background-color: var(--color-flavor-2);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-flavor-2) 50%, transparent);
    }
  }
  .bg-flavor-3 {
    background-color: var(--color-flavor-3);
  }
  .bg-flavor-3\\/50 {
    background-color: var(--color-flavor-3);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-flavor-3) 50%, transparent);
    }
  }
  .bg-flavor-4 {
    background-color: var(--color-flavor-4);
  }
  .bg-flavor-4\\/50 {
    background-color: var(--color-flavor-4);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-flavor-4) 50%, transparent);
    }
  }
  .bg-flavor-5 {
    background-color: var(--color-flavor-5);
  }
  .bg-flavor-5\\/50 {
    background-color: var(--color-flavor-5);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-flavor-5) 50%, transparent);
    }
  }
  .bg-flavor-6 {
    background-color: var(--color-flavor-6);
  }
  .bg-flavor-6\\/50 {
    background-color: var(--color-flavor-6);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-flavor-6) 50%, transparent);
    }
  }
  .bg-flavor-7 {
    background-color: var(--color-flavor-7);
  }
  .bg-flavor-7\\/50 {
    background-color: var(--color-flavor-7);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-flavor-7) 50%, transparent);
    }
  }
  .bg-flavor-8 {
    background-color: var(--color-flavor-8);
  }
  .bg-flavor-8\\/50 {
    background-color: var(--color-flavor-8);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-flavor-8) 50%, transparent);
    }
  }
  .bg-flavor-9 {
    background-color: var(--color-flavor-9);
  }
  .bg-flavor-9\\/50 {
    background-color: var(--color-flavor-9);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-flavor-9) 50%, transparent);
    }
  }
  .bg-gray-50 {
    background-color: var(--color-gray-50);
  }
  .bg-gray-100 {
    background-color: var(--color-gray-100);
  }
  .bg-gray-100\\! {
    background-color: var(--color-gray-100) !important;
  }
  .bg-gray-150 {
    background-color: var(--color-gray-150);
  }
  .bg-gray-200 {
    background-color: var(--color-gray-200);
  }
  .bg-gray-200\\! {
    background-color: var(--color-gray-200) !important;
  }
  .bg-gray-300 {
    background-color: var(--color-gray-300);
  }
  .bg-gray-400 {
    background-color: var(--color-gray-400);
  }
  .bg-gray-400\\/20 {
    background-color: var(--color-gray-400);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-gray-400) 20%, transparent);
    }
  }
  .bg-gray-500 {
    background-color: var(--color-gray-500);
  }
  .bg-gray-600 {
    background-color: var(--color-gray-600);
  }
  .bg-gray-600\\/80 {
    background-color: var(--color-gray-600);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-gray-600) 80%, transparent);
    }
  }
  .bg-gray-700 {
    background-color: var(--color-gray-700);
  }
  .bg-gray-800 {
    background-color: var(--color-gray-800);
  }
  .bg-gray-800\\/70 {
    background-color: var(--color-gray-800);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-gray-800) 70%, transparent);
    }
  }
  .bg-gray-800\\/95 {
    background-color: var(--color-gray-800);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-gray-800) 95%, transparent);
    }
  }
  .bg-gray-900 {
    background-color: var(--color-gray-900);
  }
  .bg-gray-900\\/80 {
    background-color: var(--color-gray-900);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-gray-900) 80%, transparent);
    }
  }
  .bg-green {
    background-color: var(--color-green);
  }
  .bg-green-100 {
    background-color: var(--color-green-100);
  }
  .bg-green-200 {
    background-color: var(--color-green-200);
  }
  .bg-green-500 {
    background-color: var(--color-green-500);
  }
  .bg-green\\/10 {
    background-color: var(--color-green);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-green) 10%, transparent);
    }
  }
  .bg-green\\/15 {
    background-color: var(--color-green);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-green) 15%, transparent);
    }
  }
  .bg-green\\/20 {
    background-color: var(--color-green);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-green) 20%, transparent);
    }
  }
  .bg-green\\/30 {
    background-color: var(--color-green);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-green) 30%, transparent);
    }
  }
  .bg-link {
    background-color: var(--color-link);
  }
  .bg-main {
    background-color: var(--color-main);
  }
  .bg-orange-200 {
    background-color: var(--color-orange-200);
  }
  .bg-pbx-channel {
    background-color: var(--color-pbx-channel);
  }
  .bg-pbx-conference {
    background-color: var(--color-pbx-conference);
  }
  .bg-pbx-connection {
    background-color: var(--color-pbx-connection);
  }
  .bg-pbx-huntgroup {
    background-color: var(--color-pbx-huntgroup);
  }
  .bg-pbx-refer {
    background-color: var(--color-pbx-refer);
  }
  .bg-pbx-voicemail {
    background-color: var(--color-pbx-voicemail);
  }
  .bg-purple-500 {
    background-color: var(--color-purple-500);
  }
  .bg-red {
    background-color: var(--color-red);
  }
  .bg-red-100 {
    background-color: var(--color-red-100);
  }
  .bg-red-500 {
    background-color: var(--color-red-500);
  }
  .bg-red\\/15 {
    background-color: var(--color-red);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-red) 15%, transparent);
    }
  }
  .bg-red\\/20 {
    background-color: var(--color-red);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-red) 20%, transparent);
    }
  }
  .bg-transparent {
    background-color: transparent;
  }
  .bg-transparent\\! {
    background-color: transparent !important;
  }
  .bg-white {
    background-color: var(--color-white);
  }
  .bg-white\\/5 {
    background-color: var(--color-white);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-white) 5%, transparent);
    }
  }
  .bg-white\\/30 {
    background-color: var(--color-white);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-white) 30%, transparent);
    }
  }
  .bg-white\\/50 {
    background-color: var(--color-white);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-white) 50%, transparent);
    }
  }
  .bg-white\\/70 {
    background-color: var(--color-white);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-white) 70%, transparent);
    }
  }
  .bg-white\\/90 {
    background-color: var(--color-white);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-white) 90%, transparent);
    }
  }
  .bg-white\\/100 {
    background-color: var(--color-white);
  }
  .bg-yellow {
    background-color: var(--color-yellow);
  }
  .bg-yellow-100 {
    background-color: var(--color-yellow-100);
  }
  .bg-yellow\\/10 {
    background-color: var(--color-yellow);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-yellow) 10%, transparent);
    }
  }
  .bg-yellow\\/20 {
    background-color: var(--color-yellow);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-yellow) 20%, transparent);
    }
  }
  .bg-yellow\\/40 {
    background-color: var(--color-yellow);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-yellow) 40%, transparent);
    }
  }
  .bg-\\[linear-gradient\\(to_right\\,var\\(--color-main\\)_var\\(--progress\\)\\,rgb\\(0_0_0\\/10\\%\\)_var\\(--progress\\)\\)\\] {
    background-image: linear-gradient(to right,var(--color-main) var(--progress),rgb(0 0 0/10%) var(--progress));
  }
  .bg-none {
    background-image: none;
  }
  .darken-5 {
    background-image: linear-gradient( rgb(0 0 0 / calc(5 * 1%)), rgb(0 0 0 / calc(5 * 1%)) );
  }
  .darken-10 {
    background-image: linear-gradient( rgb(0 0 0 / calc(10 * 1%)), rgb(0 0 0 / calc(10 * 1%)) );
  }
  .bg-\\[length\\:1\\.5em_1\\.5em\\] {
    background-size: 1.5em 1.5em;
  }
  .bg-cover {
    background-size: cover;
  }
  .bg-\\[right_0\\.75rem_center\\] {
    background-position: right 0.75rem center;
  }
  .bg-center {
    background-position: center;
  }
  .bg-no-repeat {
    background-repeat: no-repeat;
  }
  .\\!fill-gray-300 {
    fill: var(--color-gray-300) !important;
  }
  .\\!fill-gray-600 {
    fill: var(--color-gray-600) !important;
  }
  .fill-current {
    fill: currentcolor;
  }
  .fill-gray-200 {
    fill: var(--color-gray-200);
  }
  .fill-gray-300 {
    fill: var(--color-gray-300);
  }
  .fill-gray-400 {
    fill: var(--color-gray-400);
  }
  .fill-gray-500 {
    fill: var(--color-gray-500);
  }
  .fill-gray-600 {
    fill: var(--color-gray-600);
  }
  .fill-green {
    fill: var(--color-green);
  }
  .fill-white {
    fill: var(--color-white);
  }
  .object-contain {
    object-fit: contain;
  }
  .object-cover {
    object-fit: cover;
  }
  .\\!p-0 {
    padding: calc(var(--spacing) * 0) !important;
  }
  .p-0 {
    padding: calc(var(--spacing) * 0);
  }
  .p-0\\! {
    padding: calc(var(--spacing) * 0) !important;
  }
  .p-0\\.5 {
    padding: calc(var(--spacing) * 0.5);
  }
  .p-1 {
    padding: calc(var(--spacing) * 1);
  }
  .p-1\\.5 {
    padding: calc(var(--spacing) * 1.5);
  }
  .p-2 {
    padding: calc(var(--spacing) * 2);
  }
  .p-3 {
    padding: calc(var(--spacing) * 3);
  }
  .p-4 {
    padding: calc(var(--spacing) * 4);
  }
  .p-4\\.5 {
    padding: calc(var(--spacing) * 4.5);
  }
  .p-5 {
    padding: calc(var(--spacing) * 5);
  }
  .p-6 {
    padding: calc(var(--spacing) * 6);
  }
  .p-8 {
    padding: calc(var(--spacing) * 8);
  }
  .p-\\[26px\\] {
    padding: 26px;
  }
  .p-px {
    padding: 1px;
  }
  .px-0 {
    padding-inline: calc(var(--spacing) * 0);
  }
  .px-1 {
    padding-inline: calc(var(--spacing) * 1);
  }
  .px-1\\.5 {
    padding-inline: calc(var(--spacing) * 1.5);
  }
  .px-2 {
    padding-inline: calc(var(--spacing) * 2);
  }
  .px-2\\.5 {
    padding-inline: calc(var(--spacing) * 2.5);
  }
  .px-3 {
    padding-inline: calc(var(--spacing) * 3);
  }
  .px-3\\.75 {
    padding-inline: calc(var(--spacing) * 3.75);
  }
  .px-4 {
    padding-inline: calc(var(--spacing) * 4);
  }
  .px-5 {
    padding-inline: calc(var(--spacing) * 5);
  }
  .px-6 {
    padding-inline: calc(var(--spacing) * 6);
  }
  .px-8 {
    padding-inline: calc(var(--spacing) * 8);
  }
  .px-9 {
    padding-inline: calc(var(--spacing) * 9);
  }
  .px-10 {
    padding-inline: calc(var(--spacing) * 10);
  }
  .px-\\[26px\\] {
    padding-inline: 26px;
  }
  .py-0 {
    padding-block: calc(var(--spacing) * 0);
  }
  .py-0\\.5 {
    padding-block: calc(var(--spacing) * 0.5);
  }
  .py-1 {
    padding-block: calc(var(--spacing) * 1);
  }
  .py-1\\.5 {
    padding-block: calc(var(--spacing) * 1.5);
  }
  .py-2 {
    padding-block: calc(var(--spacing) * 2);
  }
  .py-2\\.5 {
    padding-block: calc(var(--spacing) * 2.5);
  }
  .py-3 {
    padding-block: calc(var(--spacing) * 3);
  }
  .py-3\\.5 {
    padding-block: calc(var(--spacing) * 3.5);
  }
  .py-4 {
    padding-block: calc(var(--spacing) * 4);
  }
  .py-5 {
    padding-block: calc(var(--spacing) * 5);
  }
  .py-6 {
    padding-block: calc(var(--spacing) * 6);
  }
  .py-7 {
    padding-block: calc(var(--spacing) * 7);
  }
  .py-8 {
    padding-block: calc(var(--spacing) * 8);
  }
  .py-9 {
    padding-block: calc(var(--spacing) * 9);
  }
  .py-20 {
    padding-block: calc(var(--spacing) * 20);
  }
  .py-\\[18px\\] {
    padding-block: 18px;
  }
  .ps-1 {
    padding-inline-start: calc(var(--spacing) * 1);
  }
  .ps-1\\.5 {
    padding-inline-start: calc(var(--spacing) * 1.5);
  }
  .ps-2 {
    padding-inline-start: calc(var(--spacing) * 2);
  }
  .ps-3 {
    padding-inline-start: calc(var(--spacing) * 3);
  }
  .ps-4 {
    padding-inline-start: calc(var(--spacing) * 4);
  }
  .ps-5 {
    padding-inline-start: calc(var(--spacing) * 5);
  }
  .ps-6 {
    padding-inline-start: calc(var(--spacing) * 6);
  }
  .ps-8 {
    padding-inline-start: calc(var(--spacing) * 8);
  }
  .ps-10 {
    padding-inline-start: calc(var(--spacing) * 10);
  }
  .ps-11 {
    padding-inline-start: calc(var(--spacing) * 11);
  }
  .ps-15 {
    padding-inline-start: calc(var(--spacing) * 15);
  }
  .pe-0 {
    padding-inline-end: calc(var(--spacing) * 0);
  }
  .pe-0\\.75 {
    padding-inline-end: calc(var(--spacing) * 0.75);
  }
  .pe-1 {
    padding-inline-end: calc(var(--spacing) * 1);
  }
  .pe-1\\.5 {
    padding-inline-end: calc(var(--spacing) * 1.5);
  }
  .pe-2 {
    padding-inline-end: calc(var(--spacing) * 2);
  }
  .pe-3 {
    padding-inline-end: calc(var(--spacing) * 3);
  }
  .pe-4 {
    padding-inline-end: calc(var(--spacing) * 4);
  }
  .pe-7 {
    padding-inline-end: calc(var(--spacing) * 7);
  }
  .pe-8 {
    padding-inline-end: calc(var(--spacing) * 8);
  }
  .pe-9 {
    padding-inline-end: calc(var(--spacing) * 9);
  }
  .pe-10 {
    padding-inline-end: calc(var(--spacing) * 10);
  }
  .pe-12 {
    padding-inline-end: calc(var(--spacing) * 12);
  }
  .pe-16 {
    padding-inline-end: calc(var(--spacing) * 16);
  }
  .pe-18 {
    padding-inline-end: calc(var(--spacing) * 18);
  }
  .pt-0 {
    padding-top: calc(var(--spacing) * 0);
  }
  .pt-0\\.5 {
    padding-top: calc(var(--spacing) * 0.5);
  }
  .pt-1 {
    padding-top: calc(var(--spacing) * 1);
  }
  .pt-2 {
    padding-top: calc(var(--spacing) * 2);
  }
  .pt-3 {
    padding-top: calc(var(--spacing) * 3);
  }
  .pt-4 {
    padding-top: calc(var(--spacing) * 4);
  }
  .pt-6 {
    padding-top: calc(var(--spacing) * 6);
  }
  .pt-8 {
    padding-top: calc(var(--spacing) * 8);
  }
  .pt-16 {
    padding-top: calc(var(--spacing) * 16);
  }
  .pt-\\[0\\.6rem\\] {
    padding-top: 0.6rem;
  }
  .pt-\\[26px\\] {
    padding-top: 26px;
  }
  .pr-2 {
    padding-right: calc(var(--spacing) * 2);
  }
  .pb-0 {
    padding-bottom: calc(var(--spacing) * 0);
  }
  .pb-0\\.5 {
    padding-bottom: calc(var(--spacing) * 0.5);
  }
  .pb-1 {
    padding-bottom: calc(var(--spacing) * 1);
  }
  .pb-1\\.5 {
    padding-bottom: calc(var(--spacing) * 1.5);
  }
  .pb-2 {
    padding-bottom: calc(var(--spacing) * 2);
  }
  .pb-3 {
    padding-bottom: calc(var(--spacing) * 3);
  }
  .pb-4 {
    padding-bottom: calc(var(--spacing) * 4);
  }
  .pb-6 {
    padding-bottom: calc(var(--spacing) * 6);
  }
  .pb-8 {
    padding-bottom: calc(var(--spacing) * 8);
  }
  .pb-9 {
    padding-bottom: calc(var(--spacing) * 9);
  }
  .pb-10 {
    padding-bottom: calc(var(--spacing) * 10);
  }
  .pb-25 {
    padding-bottom: calc(var(--spacing) * 25);
  }
  .pl-1 {
    padding-left: calc(var(--spacing) * 1);
  }
  .pl-2 {
    padding-left: calc(var(--spacing) * 2);
  }
  .pl-4 {
    padding-left: calc(var(--spacing) * 4);
  }
  .pl-5 {
    padding-left: calc(var(--spacing) * 5);
  }
  .text-center {
    text-align: center;
  }
  .text-end {
    text-align: end;
  }
  .text-left {
    text-align: left;
  }
  .text-right {
    text-align: right;
  }
  .text-start {
    text-align: start;
  }
  .align-bottom {
    vertical-align: bottom;
  }
  .align-middle {
    vertical-align: middle;
  }
  .font-mono {
    font-family: var(--font-mono);
  }
  .\\!text-sm {
    font-size: var(--text-sm) !important;
    line-height: var(--tw-leading, var(--text-sm--line-height)) !important;
  }
  .text-2xl {
    font-size: var(--text-2xl);
    line-height: var(--tw-leading, var(--text-2xl--line-height));
  }
  .text-2xl\\/5 {
    font-size: var(--text-2xl);
    line-height: calc(var(--spacing) * 5);
  }
  .text-2xl\\/6 {
    font-size: var(--text-2xl);
    line-height: calc(var(--spacing) * 6);
  }
  .text-2xl\\/10 {
    font-size: var(--text-2xl);
    line-height: calc(var(--spacing) * 10);
  }
  .text-3xl {
    font-size: var(--text-3xl);
    line-height: var(--tw-leading, var(--text-3xl--line-height));
  }
  .text-base {
    font-size: var(--text-base);
    line-height: var(--tw-leading, var(--text-base--line-height));
  }
  .text-base\\/4 {
    font-size: var(--text-base);
    line-height: calc(var(--spacing) * 4);
  }
  .text-base\\/5 {
    font-size: var(--text-base);
    line-height: calc(var(--spacing) * 5);
  }
  .text-base\\/6 {
    font-size: var(--text-base);
    line-height: calc(var(--spacing) * 6);
  }
  .text-lg {
    font-size: var(--text-lg);
    line-height: var(--tw-leading, var(--text-lg--line-height));
  }
  .text-sm {
    font-size: var(--text-sm);
    line-height: var(--tw-leading, var(--text-sm--line-height));
  }
  .text-sm\\/3 {
    font-size: var(--text-sm);
    line-height: calc(var(--spacing) * 3);
  }
  .text-sm\\/4 {
    font-size: var(--text-sm);
    line-height: calc(var(--spacing) * 4);
  }
  .text-sm\\/5 {
    font-size: var(--text-sm);
    line-height: calc(var(--spacing) * 5);
  }
  .text-sm\\/6 {
    font-size: var(--text-sm);
    line-height: calc(var(--spacing) * 6);
  }
  .text-sm\\/none {
    font-size: var(--text-sm);
    line-height: 1;
  }
  .text-xl {
    font-size: var(--text-xl);
    line-height: var(--tw-leading, var(--text-xl--line-height));
  }
  .text-xl\\/5 {
    font-size: var(--text-xl);
    line-height: calc(var(--spacing) * 5);
  }
  .text-xs {
    font-size: var(--text-xs);
    line-height: var(--tw-leading, var(--text-xs--line-height));
  }
  .text-xs\\/3 {
    font-size: var(--text-xs);
    line-height: calc(var(--spacing) * 3);
  }
  .text-xs\\/4 {
    font-size: var(--text-xs);
    line-height: calc(var(--spacing) * 4);
  }
  .text-xs\\/5 {
    font-size: var(--text-xs);
    line-height: calc(var(--spacing) * 5);
  }
  .text-xs\\/6 {
    font-size: var(--text-xs);
    line-height: calc(var(--spacing) * 6);
  }
  .text-2xs {
    font-size: var(--text-2xs);
  }
  .text-\\[0\\.6rem\\] {
    font-size: 0.6rem;
  }
  .text-\\[2rem\\] {
    font-size: 2rem;
  }
  .text-\\[8px\\] {
    font-size: 8px;
  }
  .text-\\[15px\\] {
    font-size: 15px;
  }
  .leading-4 {
    --tw-leading: calc(var(--spacing) * 4);
    line-height: calc(var(--spacing) * 4);
  }
  .leading-5 {
    --tw-leading: calc(var(--spacing) * 5);
    line-height: calc(var(--spacing) * 5);
  }
  .leading-6 {
    --tw-leading: calc(var(--spacing) * 6);
    line-height: calc(var(--spacing) * 6);
  }
  .leading-8 {
    --tw-leading: calc(var(--spacing) * 8);
    line-height: calc(var(--spacing) * 8);
  }
  .leading-none {
    --tw-leading: 1;
    line-height: 1;
  }
  .leading-normal {
    --tw-leading: var(--leading-normal);
    line-height: var(--leading-normal);
  }
  .leading-relaxed {
    --tw-leading: var(--leading-relaxed);
    line-height: var(--leading-relaxed);
  }
  .\\!font-normal {
    --tw-font-weight: var(--font-weight-normal) !important;
    font-weight: var(--font-weight-normal) !important;
  }
  .font-bold {
    --tw-font-weight: var(--font-weight-bold);
    font-weight: var(--font-weight-bold);
  }
  .font-light {
    --tw-font-weight: var(--font-weight-light);
    font-weight: var(--font-weight-light);
  }
  .font-medium {
    --tw-font-weight: var(--font-weight-medium);
    font-weight: var(--font-weight-medium);
  }
  .font-normal {
    --tw-font-weight: var(--font-weight-normal);
    font-weight: var(--font-weight-normal);
  }
  .font-semibold {
    --tw-font-weight: var(--font-weight-semibold);
    font-weight: var(--font-weight-semibold);
  }
  .font-thin {
    --tw-font-weight: var(--font-weight-thin);
    font-weight: var(--font-weight-thin);
  }
  .tracking-normal {
    --tw-tracking: var(--tracking-normal);
    letter-spacing: var(--tracking-normal);
  }
  .tracking-tight {
    --tw-tracking: var(--tracking-tight);
    letter-spacing: var(--tracking-tight);
  }
  .tracking-wide {
    --tw-tracking: var(--tracking-wide);
    letter-spacing: var(--tracking-wide);
  }
  .tracking-wider {
    --tw-tracking: var(--tracking-wider);
    letter-spacing: var(--tracking-wider);
  }
  .text-balance {
    text-wrap: balance;
  }
  .text-nowrap {
    text-wrap: nowrap;
  }
  .text-wrap {
    text-wrap: wrap;
  }
  .break-words {
    overflow-wrap: break-word;
  }
  .wrap-anywhere {
    overflow-wrap: anywhere;
  }
  .wrap-break-word {
    overflow-wrap: break-word;
  }
  .break-all {
    word-break: break-all;
  }
  .text-ellipsis {
    text-overflow: ellipsis;
  }
  .hyphens-auto {
    -webkit-hyphens: auto;
    hyphens: auto;
  }
  .whitespace-break-spaces {
    white-space: break-spaces;
  }
  .whitespace-normal {
    white-space: normal;
  }
  .whitespace-nowrap {
    white-space: nowrap;
  }
  .whitespace-pre {
    white-space: pre;
  }
  .whitespace-pre-line {
    white-space: pre-line;
  }
  .whitespace-pre-wrap {
    white-space: pre-wrap;
  }
  .\\!text-blue-300 {
    color: var(--color-blue-300) !important;
  }
  .\\!text-gray-500 {
    color: var(--color-gray-500) !important;
  }
  .\\!text-gray-800 {
    color: var(--color-gray-800) !important;
  }
  .\\!text-white {
    color: var(--color-white) !important;
  }
  .text-\\[\\#1D1D1A\\] {
    color: #1D1D1A;
  }
  .text-amber-200 {
    color: var(--color-amber-200);
  }
  .text-black {
    color: var(--color-black);
  }
  .text-blue-800 {
    color: var(--color-blue-800);
  }
  .text-chatYou {
    color: var(--color-chatYou);
  }
  .text-gray-100 {
    color: var(--color-gray-100);
  }
  .text-gray-200 {
    color: var(--color-gray-200);
  }
  .text-gray-300 {
    color: var(--color-gray-300);
  }
  .text-gray-400 {
    color: var(--color-gray-400);
  }
  .text-gray-500 {
    color: var(--color-gray-500);
  }
  .text-gray-600 {
    color: var(--color-gray-600);
  }
  .text-gray-700 {
    color: var(--color-gray-700);
  }
  .text-gray-800 {
    color: var(--color-gray-800);
  }
  .text-gray-900 {
    color: var(--color-gray-900);
  }
  .text-green {
    color: var(--color-green);
  }
  .text-green-500 {
    color: var(--color-green-500);
  }
  .text-green-600 {
    color: var(--color-green-600);
  }
  .text-green-700 {
    color: var(--color-green-700);
  }
  .text-iconOnBrand {
    color: var(--color-iconOnBrand);
  }
  .text-link {
    color: var(--color-link);
  }
  .text-main {
    color: var(--color-main);
  }
  .text-pbx-channel {
    color: var(--color-pbx-channel);
  }
  .text-pbx-conference {
    color: var(--color-pbx-conference);
  }
  .text-pbx-huntgroup {
    color: var(--color-pbx-huntgroup);
  }
  .text-red {
    color: var(--color-red);
  }
  .text-red-500 {
    color: var(--color-red-500);
  }
  .text-red-600 {
    color: var(--color-red-600);
  }
  .text-textOnBrand {
    color: var(--color-textOnBrand);
  }
  .text-transparent {
    color: transparent;
  }
  .text-white {
    color: var(--color-white);
  }
  .text-yellow {
    color: var(--color-yellow);
  }
  .text-yellow-400 {
    color: var(--color-yellow-400);
  }
  .text-yellow-800 {
    color: var(--color-yellow-800);
  }
  .capitalize {
    text-transform: capitalize;
  }
  .lowercase {
    text-transform: lowercase;
  }
  .uppercase {
    text-transform: uppercase;
  }
  .italic {
    font-style: italic;
  }
  .tabular-nums {
    --tw-numeric-spacing: tabular-nums;
    font-variant-numeric: var(--tw-ordinal,) var(--tw-slashed-zero,) var(--tw-numeric-figure,) var(--tw-numeric-spacing,) var(--tw-numeric-fraction,);
  }
  .no-underline {
    text-decoration-line: none;
  }
  .underline {
    text-decoration-line: underline;
  }
  .antialiased {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
  .caret-gray-800 {
    caret-color: var(--color-gray-800);
  }
  .opacity-0 {
    opacity: 0%;
  }
  .opacity-25 {
    opacity: 25%;
  }
  .opacity-30 {
    opacity: 30%;
  }
  .opacity-40 {
    opacity: 40%;
  }
  .opacity-50 {
    opacity: 50%;
  }
  .opacity-70 {
    opacity: 70%;
  }
  .opacity-100 {
    opacity: 100%;
  }
  .shadow-\\[0_16px_48px_rgba\\(0\\,0\\,0\\,0\\.06\\)\\] {
    --tw-shadow: 0 16px 48px var(--tw-shadow-color, rgba(0,0,0,0.06));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .shadow-base {
    --tw-shadow: 0 6px 12px var(--tw-shadow-color, var(--shadow-color-base));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .shadow-lg {
    --tw-shadow: 0 6px 12px var(--tw-shadow-color, var(--shadow-color-lg));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .shadow-md {
    --tw-shadow: 0 4px 6px -1px var(--tw-shadow-color, var(--shadow-color-md)), 0 2px 4px -2px var(--tw-shadow-color, var(--shadow-color-md));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .shadow-sm {
    --tw-shadow: 0 1px 3px 0 var(--tw-shadow-color, rgb(0 0 0 / 0.1)), 0 1px 2px -1px var(--tw-shadow-color, rgb(0 0 0 / 0.1));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .shadow-soft {
    --tw-shadow: 0 5px 10px 5px var(--tw-shadow-color, var(--shadow-color-xs));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .shadow-xs {
    --tw-shadow: 0 1px 2px 0 var(--tw-shadow-color, var(--shadow-color-xs));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .\\!ring-0 {
    --tw-ring-shadow: var(--tw-ring-inset,) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor) !important;
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow) !important;
  }
  .ring {
    --tw-ring-shadow: var(--tw-ring-inset,) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor);
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .ring-0 {
    --tw-ring-shadow: var(--tw-ring-inset,) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor);
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .ring-1 {
    --tw-ring-shadow: var(--tw-ring-inset,) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor);
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .ring-2 {
    --tw-ring-shadow: var(--tw-ring-inset,) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor);
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .ring-4 {
    --tw-ring-shadow: var(--tw-ring-inset,) 0 0 0 calc(4px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor);
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .ring-6 {
    --tw-ring-shadow: var(--tw-ring-inset,) 0 0 0 calc(6px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor);
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .ring-12 {
    --tw-ring-shadow: var(--tw-ring-inset,) 0 0 0 calc(12px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor);
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .shadow-black\\/5 {
    --tw-shadow-color: var(--color-black);
    @supports (color: color-mix(in lab, red, red)) {
      --tw-shadow-color: color-mix(in oklab, color-mix(in oklab, var(--color-black) 5%, transparent) var(--tw-shadow-alpha), transparent);
    }
  }
  .ring-black\\/5 {
    --tw-ring-color: var(--color-black);
    @supports (color: color-mix(in lab, red, red)) {
      --tw-ring-color: color-mix(in oklab, var(--color-black) 5%, transparent);
    }
  }
  .ring-blue-600 {
    --tw-ring-color: var(--color-blue-600);
  }
  .ring-gray-200 {
    --tw-ring-color: var(--color-gray-200);
  }
  .ring-gray-300 {
    --tw-ring-color: var(--color-gray-300);
  }
  .ring-gray-400 {
    --tw-ring-color: var(--color-gray-400);
  }
  .ring-gray-600 {
    --tw-ring-color: var(--color-gray-600);
  }
  .ring-gray-800 {
    --tw-ring-color: var(--color-gray-800);
  }
  .ring-main {
    --tw-ring-color: var(--color-main);
  }
  .ring-red {
    --tw-ring-color: var(--color-red);
  }
  .ring-white {
    --tw-ring-color: var(--color-white);
  }
  .ring-yellow {
    --tw-ring-color: var(--color-yellow);
  }
  .focus-ring {
    outline-color: -webkit-focus-ring-color;
    &:focus-visible:focus-visible {
      outline: revert;
      outline-offset: 2px;
    }
  }
  .focus-ring-inset {
    outline-color: -webkit-focus-ring-color;
    &:focus-visible:focus-visible {
      outline: revert;
      outline-offset: -3px;
    }
  }
  .outline-hidden {
    --tw-outline-style: none;
    outline-style: none;
    @media (forced-colors: active) {
      outline: 2px solid transparent;
      outline-offset: 2px;
    }
  }
  .outline {
    outline-style: var(--tw-outline-style);
    outline-width: 1px;
  }
  .outline-1 {
    outline-style: var(--tw-outline-style);
    outline-width: 1px;
  }
  .outline-gray-100 {
    outline-color: var(--color-gray-100);
  }
  .outline-gray-300 {
    outline-color: var(--color-gray-300);
  }
  .outline-green {
    outline-color: var(--color-green);
  }
  .blur {
    --tw-blur: blur(8px);
    filter: var(--tw-blur,) var(--tw-brightness,) var(--tw-contrast,) var(--tw-grayscale,) var(--tw-hue-rotate,) var(--tw-invert,) var(--tw-saturate,) var(--tw-sepia,) var(--tw-drop-shadow,);
  }
  .invert {
    --tw-invert: invert(100%);
    filter: var(--tw-blur,) var(--tw-brightness,) var(--tw-contrast,) var(--tw-grayscale,) var(--tw-hue-rotate,) var(--tw-invert,) var(--tw-saturate,) var(--tw-sepia,) var(--tw-drop-shadow,);
  }
  .filter {
    filter: var(--tw-blur,) var(--tw-brightness,) var(--tw-contrast,) var(--tw-grayscale,) var(--tw-hue-rotate,) var(--tw-invert,) var(--tw-saturate,) var(--tw-sepia,) var(--tw-drop-shadow,);
  }
  .backdrop-blur-sm {
    --tw-backdrop-blur: blur(var(--blur-sm));
    -webkit-backdrop-filter: var(--tw-backdrop-blur,) var(--tw-backdrop-brightness,) var(--tw-backdrop-contrast,) var(--tw-backdrop-grayscale,) var(--tw-backdrop-hue-rotate,) var(--tw-backdrop-invert,) var(--tw-backdrop-opacity,) var(--tw-backdrop-saturate,) var(--tw-backdrop-sepia,);
    backdrop-filter: var(--tw-backdrop-blur,) var(--tw-backdrop-brightness,) var(--tw-backdrop-contrast,) var(--tw-backdrop-grayscale,) var(--tw-backdrop-hue-rotate,) var(--tw-backdrop-invert,) var(--tw-backdrop-opacity,) var(--tw-backdrop-saturate,) var(--tw-backdrop-sepia,);
  }
  .meeting-panel-transition {
    transition-property: flex-basis, inset-inline-end;
    transition-duration: 300ms;
    transition-timing-function: ease-out;
  }
  .transition {
    transition-property: color, background-color, border-color, outline-color, text-decoration-color, fill, stroke, --tw-gradient-from, --tw-gradient-via, --tw-gradient-to, opacity, box-shadow, transform, translate, scale, rotate, filter, -webkit-backdrop-filter, backdrop-filter, display, content-visibility, overlay, pointer-events;
    transition-timing-function: var(--tw-ease, var(--default-transition-timing-function));
    transition-duration: var(--tw-duration, var(--default-transition-duration));
  }
  .transition-all {
    transition-property: all;
    transition-timing-function: var(--tw-ease, var(--default-transition-timing-function));
    transition-duration: var(--tw-duration, var(--default-transition-duration));
  }
  .transition-colors {
    transition-property: color, background-color, border-color, outline-color, text-decoration-color, fill, stroke, --tw-gradient-from, --tw-gradient-via, --tw-gradient-to;
    transition-timing-function: var(--tw-ease, var(--default-transition-timing-function));
    transition-duration: var(--tw-duration, var(--default-transition-duration));
  }
  .transition-opacity {
    transition-property: opacity;
    transition-timing-function: var(--tw-ease, var(--default-transition-timing-function));
    transition-duration: var(--tw-duration, var(--default-transition-duration));
  }
  .transition-shadow {
    transition-property: box-shadow;
    transition-timing-function: var(--tw-ease, var(--default-transition-timing-function));
    transition-duration: var(--tw-duration, var(--default-transition-duration));
  }
  .delay-\\[50ms\\] {
    transition-delay: 50ms;
  }
  .duration-100 {
    --tw-duration: 100ms;
    transition-duration: 100ms;
  }
  .duration-150 {
    --tw-duration: 150ms;
    transition-duration: 150ms;
  }
  .duration-200 {
    --tw-duration: 200ms;
    transition-duration: 200ms;
  }
  .duration-300 {
    --tw-duration: 300ms;
    transition-duration: 300ms;
  }
  .ease-in {
    --tw-ease: var(--ease-in);
    transition-timing-function: var(--ease-in);
  }
  .ease-in-out {
    --tw-ease: var(--ease-in-out);
    transition-timing-function: var(--ease-in-out);
  }
  .ease-out {
    --tw-ease: var(--ease-out);
    transition-timing-function: var(--ease-out);
  }
  .outline-none {
    --tw-outline-style: none;
    outline-style: none;
  }
  .select-none {
    -webkit-user-select: none;
    user-select: none;
  }
  .\\[--anchor-max-height\\:18rem\\] {
    --anchor-max-height: 18rem;
  }
  .ring-inset {
    --tw-ring-inset: inset;
  }
  .scrollbar-gutter-stable {
    scrollbar-gutter: stable;
  }
  .scrollbar-gutter-stable-both {
    scrollbar-gutter: stable both-edges;
  }
  .\\*\\*\\:scroll-mt-9 {
    :is(& *) {
      scroll-margin-top: calc(var(--spacing) * 9);
    }
  }
  .group-hover\\:\\!hidden {
    &:is(:where(.group):hover *) {
      @media (hover: hover) {
        display: none !important;
      }
    }
  }
  .group-hover\\:flex {
    &:is(:where(.group):hover *) {
      @media (hover: hover) {
        display: flex;
      }
    }
  }
  .group-hover\\:hidden {
    &:is(:where(.group):hover *) {
      @media (hover: hover) {
        display: none;
      }
    }
  }
  .group-hover\\:scale-110 {
    &:is(:where(.group):hover *) {
      @media (hover: hover) {
        --tw-scale-x: 110%;
        --tw-scale-y: 110%;
        --tw-scale-z: 110%;
        scale: var(--tw-scale-x) var(--tw-scale-y);
      }
    }
  }
  .group-hover\\:bg-gray-200 {
    &:is(:where(.group):hover *) {
      @media (hover: hover) {
        background-color: var(--color-gray-200);
      }
    }
  }
  .group-hover\\:bg-gray-300 {
    &:is(:where(.group):hover *) {
      @media (hover: hover) {
        background-color: var(--color-gray-300);
      }
    }
  }
  .group-hover\\:bg-green {
    &:is(:where(.group):hover *) {
      @media (hover: hover) {
        background-color: var(--color-green);
      }
    }
  }
  .group-hover\\:text-gray-500 {
    &:is(:where(.group):hover *) {
      @media (hover: hover) {
        color: var(--color-gray-500);
      }
    }
  }
  .group-hover\\:text-gray-700 {
    &:is(:where(.group):hover *) {
      @media (hover: hover) {
        color: var(--color-gray-700);
      }
    }
  }
  .group-hover\\:text-gray-800 {
    &:is(:where(.group):hover *) {
      @media (hover: hover) {
        color: var(--color-gray-800);
      }
    }
  }
  .group-hover\\:text-link {
    &:is(:where(.group):hover *) {
      @media (hover: hover) {
        color: var(--color-link);
      }
    }
  }
  .group-hover\\:text-main {
    &:is(:where(.group):hover *) {
      @media (hover: hover) {
        color: var(--color-main);
      }
    }
  }
  .group-hover\\:text-white {
    &:is(:where(.group):hover *) {
      @media (hover: hover) {
        color: var(--color-white);
      }
    }
  }
  .group-hover\\:opacity-100 {
    &:is(:where(.group):hover *) {
      @media (hover: hover) {
        opacity: 100%;
      }
    }
  }
  .group-hover\\/copy\\:block {
    &:is(:where(.group\\/copy):hover *) {
      @media (hover: hover) {
        display: block;
      }
    }
  }
  .group-hover\\/copy\\:opacity-100 {
    &:is(:where(.group\\/copy):hover *) {
      @media (hover: hover) {
        opacity: 100%;
      }
    }
  }
  .group-hover\\/submenu\\:visible {
    &:is(:where(.group\\/submenu):hover *) {
      @media (hover: hover) {
        visibility: visible;
      }
    }
  }
  .group-hover\\/wg\\:font-bold {
    &:is(:where(.group\\/wg):hover *) {
      @media (hover: hover) {
        --tw-font-weight: var(--font-weight-bold);
        font-weight: var(--font-weight-bold);
      }
    }
  }
  .group-\\[\\.active\\]\\:bg-gray-300 {
    &:is(:where(.group):is(.active) *) {
      background-color: var(--color-gray-300);
    }
  }
  .peer-checked\\:block {
    &:is(:where(.peer):checked ~ *) {
      display: block;
    }
  }
  .peer-checked\\:hidden {
    &:is(:where(.peer):checked ~ *) {
      display: none;
    }
  }
  .first-letter\\:uppercase {
    &::first-letter {
      text-transform: uppercase;
    }
  }
  .placeholder\\:truncate {
    &::placeholder {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
  .placeholder\\:text-gray-400 {
    &::placeholder {
      color: var(--color-gray-400);
    }
  }
  .placeholder\\:text-gray-500 {
    &::placeholder {
      color: var(--color-gray-500);
    }
  }
  .backdrop\\:bg-black\\/70 {
    &::backdrop {
      background-color: var(--color-black);
      @supports (color: color-mix(in lab, red, red)) {
        background-color: color-mix(in oklab, var(--color-black) 70%, transparent);
      }
    }
  }
  .first\\:rounded-s-sm {
    &:first-child {
      border-start-start-radius: var(--radius-sm);
      border-end-start-radius: var(--radius-sm);
    }
  }
  .first\\:rounded-t-sm {
    &:first-child {
      border-top-left-radius: var(--radius-sm);
      border-top-right-radius: var(--radius-sm);
    }
  }
  .last\\:mb-0 {
    &:last-child {
      margin-bottom: calc(var(--spacing) * 0);
    }
  }
  .last\\:rounded-e-sm {
    &:last-child {
      border-start-end-radius: var(--radius-sm);
      border-end-end-radius: var(--radius-sm);
    }
  }
  .last\\:rounded-b-sm {
    &:last-child {
      border-bottom-right-radius: var(--radius-sm);
      border-bottom-left-radius: var(--radius-sm);
    }
  }
  .read-only\\:bg-gray-100 {
    &:read-only {
      background-color: var(--color-gray-100);
    }
  }
  .empty\\:m-0 {
    &:empty {
      margin: calc(var(--spacing) * 0);
    }
  }
  .empty\\:p-0 {
    &:empty {
      padding: calc(var(--spacing) * 0);
    }
  }
  .hover\\:h-4 {
    &:hover {
      @media (hover: hover) {
        height: calc(var(--spacing) * 4);
      }
    }
  }
  .hover\\:w-3 {
    &:hover {
      @media (hover: hover) {
        width: calc(var(--spacing) * 3);
      }
    }
  }
  .hover\\:cursor-default {
    &:hover {
      @media (hover: hover) {
        cursor: default;
      }
    }
  }
  .hover\\:cursor-pointer {
    &:hover {
      @media (hover: hover) {
        cursor: pointer;
      }
    }
  }
  .hover\\:rounded {
    &:hover {
      @media (hover: hover) {
        border-radius: 0.25rem;
      }
    }
  }
  .hover\\:rounded-sm {
    &:hover {
      @media (hover: hover) {
        border-radius: var(--radius-sm);
      }
    }
  }
  .hover\\:border-gray-400 {
    &:hover {
      @media (hover: hover) {
        border-color: var(--color-gray-400);
      }
    }
  }
  .hover\\:border-main {
    &:hover {
      @media (hover: hover) {
        border-color: var(--color-main);
      }
    }
  }
  .hover\\:\\!bg-gray-200 {
    &:hover {
      @media (hover: hover) {
        background-color: var(--color-gray-200) !important;
      }
    }
  }
  .hover\\:\\!bg-gray-600 {
    &:hover {
      @media (hover: hover) {
        background-color: var(--color-gray-600) !important;
      }
    }
  }
  .hover\\:\\!bg-gray-700 {
    &:hover {
      @media (hover: hover) {
        background-color: var(--color-gray-700) !important;
      }
    }
  }
  .hover\\:bg-\\[\\#00965A\\] {
    &:hover {
      @media (hover: hover) {
        background-color: #00965A;
      }
    }
  }
  .hover\\:bg-black {
    &:hover {
      @media (hover: hover) {
        background-color: var(--color-black);
      }
    }
  }
  .hover\\:bg-black\\/10 {
    &:hover {
      @media (hover: hover) {
        background-color: var(--color-black);
        @supports (color: color-mix(in lab, red, red)) {
          background-color: color-mix(in oklab, var(--color-black) 10%, transparent);
        }
      }
    }
  }
  .hover\\:bg-black\\/70 {
    &:hover {
      @media (hover: hover) {
        background-color: var(--color-black);
        @supports (color: color-mix(in lab, red, red)) {
          background-color: color-mix(in oklab, var(--color-black) 70%, transparent);
        }
      }
    }
  }
  .hover\\:bg-gray-50 {
    &:hover {
      @media (hover: hover) {
        background-color: var(--color-gray-50);
      }
    }
  }
  .hover\\:bg-gray-100 {
    &:hover {
      @media (hover: hover) {
        background-color: var(--color-gray-100);
      }
    }
  }
  .hover\\:bg-gray-200 {
    &:hover {
      @media (hover: hover) {
        background-color: var(--color-gray-200);
      }
    }
  }
  .hover\\:bg-gray-300 {
    &:hover {
      @media (hover: hover) {
        background-color: var(--color-gray-300);
      }
    }
  }
  .hover\\:bg-gray-400 {
    &:hover {
      @media (hover: hover) {
        background-color: var(--color-gray-400);
      }
    }
  }
  .hover\\:bg-gray-500 {
    &:hover {
      @media (hover: hover) {
        background-color: var(--color-gray-500);
      }
    }
  }
  .hover\\:bg-gray-600 {
    &:hover {
      @media (hover: hover) {
        background-color: var(--color-gray-600);
      }
    }
  }
  .hover\\:bg-gray-700 {
    &:hover {
      @media (hover: hover) {
        background-color: var(--color-gray-700);
      }
    }
  }
  .hover\\:bg-gray-900 {
    &:hover {
      @media (hover: hover) {
        background-color: var(--color-gray-900);
      }
    }
  }
  .hover\\:bg-green {
    &:hover {
      @media (hover: hover) {
        background-color: var(--color-green);
      }
    }
  }
  .hover\\:bg-green\\/20 {
    &:hover {
      @media (hover: hover) {
        background-color: var(--color-green);
        @supports (color: color-mix(in lab, red, red)) {
          background-color: color-mix(in oklab, var(--color-green) 20%, transparent);
        }
      }
    }
  }
  .hover\\:bg-main {
    &:hover {
      @media (hover: hover) {
        background-color: var(--color-main);
      }
    }
  }
  .hover\\:bg-red {
    &:hover {
      @media (hover: hover) {
        background-color: var(--color-red);
      }
    }
  }
  .hover\\:bg-transparent {
    &:hover {
      @media (hover: hover) {
        background-color: transparent;
      }
    }
  }
  .hover\\:bg-white {
    &:hover {
      @media (hover: hover) {
        background-color: var(--color-white);
      }
    }
  }
  .hover\\:bg-white\\/10 {
    &:hover {
      @media (hover: hover) {
        background-color: var(--color-white);
        @supports (color: color-mix(in lab, red, red)) {
          background-color: color-mix(in oklab, var(--color-white) 10%, transparent);
        }
      }
    }
  }
  .hover\\:bg-white\\/80 {
    &:hover {
      @media (hover: hover) {
        background-color: var(--color-white);
        @supports (color: color-mix(in lab, red, red)) {
          background-color: color-mix(in oklab, var(--color-white) 80%, transparent);
        }
      }
    }
  }
  .hover\\:\\!bg-none {
    &:hover {
      @media (hover: hover) {
        background-image: none !important;
      }
    }
  }
  .hover\\:\\!brighten-10 {
    &:hover {
      @media (hover: hover) {
        background-image: linear-gradient( rgb(255 255 255 / calc(10 * 1%)), rgb(255 255 255 / calc(10 * 1%)) ) !important;
      }
    }
  }
  .hover\\:brighten-10 {
    &:hover {
      @media (hover: hover) {
        background-image: linear-gradient( rgb(255 255 255 / calc(10 * 1%)), rgb(255 255 255 / calc(10 * 1%)) );
      }
    }
  }
  .hover\\:darken-0 {
    &:hover {
      @media (hover: hover) {
        background-image: linear-gradient( rgb(0 0 0 / calc(0 * 1%)), rgb(0 0 0 / calc(0 * 1%)) );
      }
    }
  }
  .hover\\:darken-2 {
    &:hover {
      @media (hover: hover) {
        background-image: linear-gradient( rgb(0 0 0 / calc(2 * 1%)), rgb(0 0 0 / calc(2 * 1%)) );
      }
    }
  }
  .hover\\:darken-5 {
    &:hover {
      @media (hover: hover) {
        background-image: linear-gradient( rgb(0 0 0 / calc(5 * 1%)), rgb(0 0 0 / calc(5 * 1%)) );
      }
    }
  }
  .hover\\:darken-10 {
    &:hover {
      @media (hover: hover) {
        background-image: linear-gradient( rgb(0 0 0 / calc(10 * 1%)), rgb(0 0 0 / calc(10 * 1%)) );
      }
    }
  }
  .hover\\:darken-20 {
    &:hover {
      @media (hover: hover) {
        background-image: linear-gradient( rgb(0 0 0 / calc(20 * 1%)), rgb(0 0 0 / calc(20 * 1%)) );
      }
    }
  }
  .hover\\:text-amber-100 {
    &:hover {
      @media (hover: hover) {
        color: var(--color-amber-100);
      }
    }
  }
  .hover\\:text-gray-300 {
    &:hover {
      @media (hover: hover) {
        color: var(--color-gray-300);
      }
    }
  }
  .hover\\:text-gray-500 {
    &:hover {
      @media (hover: hover) {
        color: var(--color-gray-500);
      }
    }
  }
  .hover\\:text-gray-600 {
    &:hover {
      @media (hover: hover) {
        color: var(--color-gray-600);
      }
    }
  }
  .hover\\:text-gray-700 {
    &:hover {
      @media (hover: hover) {
        color: var(--color-gray-700);
      }
    }
  }
  .hover\\:text-gray-800 {
    &:hover {
      @media (hover: hover) {
        color: var(--color-gray-800);
      }
    }
  }
  .hover\\:text-gray-900 {
    &:hover {
      @media (hover: hover) {
        color: var(--color-gray-900);
      }
    }
  }
  .hover\\:text-link {
    &:hover {
      @media (hover: hover) {
        color: var(--color-link);
      }
    }
  }
  .hover\\:text-main {
    &:hover {
      @media (hover: hover) {
        color: var(--color-main);
      }
    }
  }
  .hover\\:text-white {
    &:hover {
      @media (hover: hover) {
        color: var(--color-white);
      }
    }
  }
  .hover\\:underline {
    &:hover {
      @media (hover: hover) {
        text-decoration-line: underline;
      }
    }
  }
  .hover\\:opacity-60 {
    &:hover {
      @media (hover: hover) {
        opacity: 60%;
      }
    }
  }
  .hover\\:opacity-80 {
    &:hover {
      @media (hover: hover) {
        opacity: 80%;
      }
    }
  }
  .hover\\:opacity-90 {
    &:hover {
      @media (hover: hover) {
        opacity: 90%;
      }
    }
  }
  .hover\\:opacity-100 {
    &:hover {
      @media (hover: hover) {
        opacity: 100%;
      }
    }
  }
  .hover\\:shadow-\\[0_4px_24px_rgba\\(10\\,81\\,58\\,0\\.25\\)\\] {
    &:hover {
      @media (hover: hover) {
        --tw-shadow: 0 4px 24px var(--tw-shadow-color, rgba(10,81,58,0.25));
        box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
      }
    }
  }
  .hover\\:shadow-base {
    &:hover {
      @media (hover: hover) {
        --tw-shadow: 0 6px 12px var(--tw-shadow-color, var(--shadow-color-base));
        box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
      }
    }
  }
  .hover\\:shadow-lg {
    &:hover {
      @media (hover: hover) {
        --tw-shadow: 0 6px 12px var(--tw-shadow-color, var(--shadow-color-lg));
        box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
      }
    }
  }
  .hover\\:shadow-md {
    &:hover {
      @media (hover: hover) {
        --tw-shadow: 0 4px 6px -1px var(--tw-shadow-color, var(--shadow-color-md)), 0 2px 4px -2px var(--tw-shadow-color, var(--shadow-color-md));
        box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
      }
    }
  }
  .hover\\:ring-2 {
    &:hover {
      @media (hover: hover) {
        --tw-ring-shadow: var(--tw-ring-inset,) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor);
        box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
      }
    }
  }
  .hover\\:ring-black\\/20 {
    &:hover {
      @media (hover: hover) {
        --tw-ring-color: var(--color-black);
        @supports (color: color-mix(in lab, red, red)) {
          --tw-ring-color: color-mix(in oklab, var(--color-black) 20%, transparent);
        }
      }
    }
  }
  .hover\\:ring-white\\/60 {
    &:hover {
      @media (hover: hover) {
        --tw-ring-color: var(--color-white);
        @supports (color: color-mix(in lab, red, red)) {
          --tw-ring-color: color-mix(in oklab, var(--color-white) 60%, transparent);
        }
      }
    }
  }
  .hover\\:brightness-90 {
    &:hover {
      @media (hover: hover) {
        --tw-brightness: brightness(90%);
        filter: var(--tw-blur,) var(--tw-brightness,) var(--tw-contrast,) var(--tw-grayscale,) var(--tw-hue-rotate,) var(--tw-invert,) var(--tw-saturate,) var(--tw-sepia,) var(--tw-drop-shadow,);
      }
    }
  }
  .not-data-selected\\:hover\\:darken-10 {
    &:not(*[data-selected]) {
      &:hover {
        @media (hover: hover) {
          background-image: linear-gradient( rgb(0 0 0 / calc(10 * 1%)), rgb(0 0 0 / calc(10 * 1%)) );
        }
      }
    }
  }
  .not-data-selected\\:hover\\:text-gray-600 {
    &:not(*[data-selected]) {
      &:hover {
        @media (hover: hover) {
          color: var(--color-gray-600);
        }
      }
    }
  }
  .focus\\:border {
    &:focus {
      border-style: var(--tw-border-style);
      border-width: 1px;
    }
  }
  .focus\\:border-transparent {
    &:focus {
      border-color: transparent;
    }
  }
  .focus\\:bg-gray-200 {
    &:focus {
      background-color: var(--color-gray-200);
    }
  }
  .focus\\:opacity-100 {
    &:focus {
      opacity: 100%;
    }
  }
  .focus\\:ring-0 {
    &:focus {
      --tw-ring-shadow: var(--tw-ring-inset,) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor);
      box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
    }
  }
  .focus\\:ring-offset-0 {
    &:focus {
      --tw-ring-offset-width: 0px;
      --tw-ring-offset-shadow: var(--tw-ring-inset,) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
    }
  }
  .focus\\:outline-hidden {
    &:focus {
      --tw-outline-style: none;
      outline-style: none;
      @media (forced-colors: active) {
        outline: 2px solid transparent;
        outline-offset: 2px;
      }
    }
  }
  .focus\\:outline {
    &:focus {
      outline-style: var(--tw-outline-style);
      outline-width: 1px;
    }
  }
  .focus\\:outline-none {
    &:focus {
      --tw-outline-style: none;
      outline-style: none;
    }
  }
  .focus-visible\\:z-10 {
    &:focus-visible {
      z-index: 10;
    }
  }
  .focus-visible\\:opacity-100 {
    &:focus-visible {
      opacity: 100%;
    }
  }
  .active\\:cursor-grabbing {
    &:active {
      cursor: grabbing;
    }
  }
  .active\\:darken-20 {
    &:active {
      background-image: linear-gradient( rgb(0 0 0 / calc(20 * 1%)), rgb(0 0 0 / calc(20 * 1%)) );
    }
  }
  .enabled\\:cursor-pointer {
    &:enabled {
      cursor: pointer;
    }
  }
  .disabled\\:pointer-events-none {
    &:disabled {
      pointer-events: none;
    }
  }
  .disabled\\:cursor-not-allowed {
    &:disabled {
      cursor: not-allowed;
    }
  }
  .disabled\\:\\!bg-transparent {
    &:disabled {
      background-color: transparent !important;
    }
  }
  .disabled\\:bg-gray-100 {
    &:disabled {
      background-color: var(--color-gray-100);
    }
  }
  .disabled\\:bg-gray-300 {
    &:disabled {
      background-color: var(--color-gray-300);
    }
  }
  .disabled\\:\\!text-gray-500 {
    &:disabled {
      color: var(--color-gray-500) !important;
    }
  }
  .disabled\\:text-gray-400 {
    &:disabled {
      color: var(--color-gray-400);
    }
  }
  .disabled\\:text-gray-500 {
    &:disabled {
      color: var(--color-gray-500);
    }
  }
  .disabled\\:opacity-30 {
    &:disabled {
      opacity: 30%;
    }
  }
  .disabled\\:opacity-50 {
    &:disabled {
      opacity: 50%;
    }
  }
  .disabled\\:ring-gray-400 {
    &:disabled {
      --tw-ring-color: var(--color-gray-400);
    }
  }
  .disabled\\:hover\\:bg-transparent {
    &:disabled {
      &:hover {
        @media (hover: hover) {
          background-color: transparent;
        }
      }
    }
  }
  .has-\\[\\:focus-visible\\]\\:bg-gray-200 {
    &:has(*:is(:focus-visible)) {
      background-color: var(--color-gray-200);
    }
  }
  .has-\\[button\\:enabled\\]\\:cursor-pointer {
    &:has(*:is(button:enabled)) {
      cursor: pointer;
    }
  }
  .has-\\[button\\:enabled\\]\\:hover\\:text-link {
    &:has(*:is(button:enabled)) {
      &:hover {
        @media (hover: hover) {
          color: var(--color-link);
        }
      }
    }
  }
  .aria-disabled\\:opacity-50 {
    &[aria-disabled="true"] {
      opacity: 50%;
    }
  }
  .data-disabled\\:cursor-not-allowed {
    &[data-disabled] {
      cursor: not-allowed;
    }
  }
  .data-disabled\\:text-gray-500 {
    &[data-disabled] {
      color: var(--color-gray-500);
    }
  }
  .data-disabled\\:hover\\:brightness-100 {
    &[data-disabled] {
      &:hover {
        @media (hover: hover) {
          --tw-brightness: brightness(100%);
          filter: var(--tw-blur,) var(--tw-brightness,) var(--tw-contrast,) var(--tw-grayscale,) var(--tw-hue-rotate,) var(--tw-invert,) var(--tw-saturate,) var(--tw-sepia,) var(--tw-drop-shadow,);
        }
      }
    }
  }
  .data-selected\\:bg-main {
    &[data-selected] {
      background-color: var(--color-main);
    }
  }
  .data-selected\\:text-white {
    &[data-selected] {
      color: var(--color-white);
    }
  }
  .max-md\\:mx-auto {
    @media (width < 48rem) {
      margin-inline: auto;
    }
  }
  .max-md\\:mt-4 {
    @media (width < 48rem) {
      margin-top: calc(var(--spacing) * 4);
    }
  }
  .max-md\\:max-w-\\[220px\\] {
    @media (width < 48rem) {
      max-width: 220px;
    }
  }
  .max-md\\:grid-cols-1 {
    @media (width < 48rem) {
      grid-template-columns: repeat(1, minmax(0, 1fr));
    }
  }
  .max-md\\:text-center {
    @media (width < 48rem) {
      text-align: center;
    }
  }
  .max-sm\\:sr-only-until-hover-or-focus {
    @media (width < 40rem) {
      &:not(:where(.group):is(:hover, :focus-visible, :has(:focus-visible)) *) {
        position: absolute;
        width: 1px;
        height: 1px;
        padding: 0;
        margin: -1px;
        overflow: hidden;
        clip-path: inset(50%);
        white-space: nowrap;
        border-width: 0;
      }
    }
  }
  .xs\\:flex-nowrap {
    @media (width >= 480px) {
      flex-wrap: nowrap;
    }
  }
  .panel\\:w-\\[360px\\] {
    @media (width >= 720px) {
      width: 360px;
    }
  }
  .sm\\:block {
    @media (width >= 40rem) {
      display: block;
    }
  }
  .sm\\:min-h-16 {
    @media (width >= 40rem) {
      min-height: calc(var(--spacing) * 16);
    }
  }
  .sm\\:min-w-\\[120px\\] {
    @media (width >= 40rem) {
      min-width: 120px;
    }
  }
  .sm\\:min-w-\\[640px\\] {
    @media (width >= 40rem) {
      min-width: 640px;
    }
  }
  .sm\\:translate-y-0 {
    @media (width >= 40rem) {
      --tw-translate-y: calc(var(--spacing) * 0);
      translate: var(--tw-translate-x) var(--tw-translate-y);
    }
  }
  .sm\\:scale-95 {
    @media (width >= 40rem) {
      --tw-scale-x: 95%;
      --tw-scale-y: 95%;
      --tw-scale-z: 95%;
      scale: var(--tw-scale-x) var(--tw-scale-y);
    }
  }
  .sm\\:scale-100 {
    @media (width >= 40rem) {
      --tw-scale-x: 100%;
      --tw-scale-y: 100%;
      --tw-scale-z: 100%;
      scale: var(--tw-scale-x) var(--tw-scale-y);
    }
  }
  .sm\\:grid-cols-2 {
    @media (width >= 40rem) {
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }
  }
  .sm\\:flex-row {
    @media (width >= 40rem) {
      flex-direction: row;
    }
  }
  .sm\\:items-center {
    @media (width >= 40rem) {
      align-items: center;
    }
  }
  .sm\\:gap-x-2 {
    @media (width >= 40rem) {
      column-gap: calc(var(--spacing) * 2);
    }
  }
  .sm\\:gap-x-3 {
    @media (width >= 40rem) {
      column-gap: calc(var(--spacing) * 3);
    }
  }
  .sm\\:gap-x-4 {
    @media (width >= 40rem) {
      column-gap: calc(var(--spacing) * 4);
    }
  }
  .sm\\:p-0 {
    @media (width >= 40rem) {
      padding: calc(var(--spacing) * 0);
    }
  }
  .sm\\:p-3 {
    @media (width >= 40rem) {
      padding: calc(var(--spacing) * 3);
    }
  }
  .sm\\:py-0 {
    @media (width >= 40rem) {
      padding-block: calc(var(--spacing) * 0);
    }
  }
  .sm\\:pt-24 {
    @media (width >= 40rem) {
      padding-top: calc(var(--spacing) * 24);
    }
  }
  .sm\\:group-hover\\:\\!flex {
    @media (width >= 40rem) {
      &:is(:where(.group):hover *) {
        @media (hover: hover) {
          display: flex !important;
        }
      }
    }
  }
  .md\\:ms-0 {
    @media (width >= 48rem) {
      margin-inline-start: calc(var(--spacing) * 0);
    }
  }
  .md\\:flex {
    @media (width >= 48rem) {
      display: flex;
    }
  }
  .md\\:inline-flex {
    @media (width >= 48rem) {
      display: inline-flex;
    }
  }
  .md\\:aspect-auto {
    @media (width >= 48rem) {
      aspect-ratio: auto;
    }
  }
  .md\\:size-28 {
    @media (width >= 48rem) {
      width: calc(var(--spacing) * 28);
      height: calc(var(--spacing) * 28);
    }
  }
  .md\\:h-\\[360px\\] {
    @media (width >= 48rem) {
      height: 360px;
    }
  }
  .md\\:max-h-\\[520px\\] {
    @media (width >= 48rem) {
      max-height: 520px;
    }
  }
  .md\\:max-h-\\[calc\\(100\\%-140px\\)\\] {
    @media (width >= 48rem) {
      max-height: calc(100% - 140px);
    }
  }
  .md\\:w-\\[640px\\] {
    @media (width >= 48rem) {
      width: 640px;
    }
  }
  .md\\:grid-cols-1 {
    @media (width >= 48rem) {
      grid-template-columns: repeat(1, minmax(0, 1fr));
    }
  }
  .md\\:grid-cols-3 {
    @media (width >= 48rem) {
      grid-template-columns: repeat(3, minmax(0, 1fr));
    }
  }
  .md\\:flex-row {
    @media (width >= 48rem) {
      flex-direction: row;
    }
  }
  .md\\:justify-between {
    @media (width >= 48rem) {
      justify-content: space-between;
    }
  }
  .md\\:rounded-2xl {
    @media (width >= 48rem) {
      border-radius: var(--radius-2xl);
    }
  }
  .md\\:border-s {
    @media (width >= 48rem) {
      border-inline-start-style: var(--tw-border-style);
      border-inline-start-width: 1px;
    }
  }
  .md\\:px-6 {
    @media (width >= 48rem) {
      padding-inline: calc(var(--spacing) * 6);
    }
  }
  .md\\:px-12 {
    @media (width >= 48rem) {
      padding-inline: calc(var(--spacing) * 12);
    }
  }
  .md\\:px-15 {
    @media (width >= 48rem) {
      padding-inline: calc(var(--spacing) * 15);
    }
  }
  .md\\:py-10 {
    @media (width >= 48rem) {
      padding-block: calc(var(--spacing) * 10);
    }
  }
  .md\\:py-16 {
    @media (width >= 48rem) {
      padding-block: calc(var(--spacing) * 16);
    }
  }
  .md\\:pe-5 {
    @media (width >= 48rem) {
      padding-inline-end: calc(var(--spacing) * 5);
    }
  }
  .lg\\:block {
    @media (width >= 64rem) {
      display: block;
    }
  }
  .lg\\:grid-cols-2 {
    @media (width >= 64rem) {
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }
  }
  .lg\\:flex-row {
    @media (width >= 64rem) {
      flex-direction: row;
    }
  }
  .lg\\:items-center {
    @media (width >= 64rem) {
      align-items: center;
    }
  }
  .lg\\:justify-end {
    @media (width >= 64rem) {
      justify-content: flex-end;
    }
  }
  .lg\\:justify-start {
    @media (width >= 64rem) {
      justify-content: flex-start;
    }
  }
  .lg\\:text-left {
    @media (width >= 64rem) {
      text-align: left;
    }
  }
  .\\@max-\\[720px\\]\\/meeting-footer\\:flex {
    @container meeting-footer (width < 720px) {
      display: flex;
    }
  }
  .\\@max-\\[720px\\]\\/meeting-footer\\:hidden {
    @container meeting-footer (width < 720px) {
      display: none;
    }
  }
  .\\@max-\\[500px\\]\\:hidden {
    @container (width < 500px) {
      display: none;
    }
  }
  .\\@max-\\[500px\\]\\:inline-flex {
    @container (width < 500px) {
      display: inline-flex;
    }
  }
  .\\@\\[360px\\]\\:inset-auto {
    @container (width >= 360px) {
      inset: auto;
    }
  }
  .\\@\\[360px\\]\\:end-0 {
    @container (width >= 360px) {
      inset-inline-end: calc(var(--spacing) * 0);
    }
  }
  .\\@\\[360px\\]\\:w-\\[320px\\] {
    @container (width >= 360px) {
      width: 320px;
    }
  }
  .\\@\\[360px\\]\\:max-w-\\[280px\\] {
    @container (width >= 360px) {
      max-width: 280px;
    }
  }
  .\\@\\[406px\\]\\:w-\\[calc\\(100\\%-70px\\)\\] {
    @container (width >= 406px) {
      width: calc(100% - 70px);
    }
  }
  .\\@\\[440px\\]\\:w-full {
    @container (width >= 440px) {
      width: 100%;
    }
  }
  .\\@sm\\:hidden {
    @container (width >= 24rem) {
      display: none;
    }
  }
  .\\@sm\\:inline {
    @container (width >= 24rem) {
      display: inline;
    }
  }
  .\\@sm\\/messages\\:min-w-3 {
    @container messages (width >= 24rem) {
      min-width: calc(var(--spacing) * 3);
    }
  }
  .\\@sm\\:p-0 {
    @container (width >= 24rem) {
      padding: calc(var(--spacing) * 0);
    }
  }
  .\\@sm\\:px-1 {
    @container (width >= 24rem) {
      padding-inline: calc(var(--spacing) * 1);
    }
  }
  .\\@sm\\:py-0 {
    @container (width >= 24rem) {
      padding-block: calc(var(--spacing) * 0);
    }
  }
  .\\@lg\\:flex-row {
    @container (width >= 32rem) {
      flex-direction: row;
    }
  }
  .\\@2xl\\:block {
    @container (width >= 42rem) {
      display: block;
    }
  }
  .\\@2xl\\:hidden {
    @container (width >= 42rem) {
      display: none;
    }
  }
  .\\@2xl\\:\\!w-auto {
    @container (width >= 42rem) {
      width: auto !important;
    }
  }
  .\\@2xl\\:w-auto {
    @container (width >= 42rem) {
      width: auto;
    }
  }
  .\\@2xl\\:flex-row {
    @container (width >= 42rem) {
      flex-direction: row;
    }
  }
  .\\@3xl\\:whitespace-nowrap {
    @container (width >= 48rem) {
      white-space: nowrap;
    }
  }
  .rtl\\:origin-top-left {
    &:where(:dir(rtl), [dir="rtl"], [dir="rtl"] *) {
      transform-origin: 0 0;
    }
  }
  .rtl\\:translate-x-3 {
    &:where(:dir(rtl), [dir="rtl"], [dir="rtl"] *) {
      --tw-translate-x: calc(var(--spacing) * 3);
      translate: var(--tw-translate-x) var(--tw-translate-y);
    }
  }
  .rtl\\:-scale-x-100 {
    &:where(:dir(rtl), [dir="rtl"], [dir="rtl"] *) {
      --tw-scale-x: calc(100% * -1);
      scale: var(--tw-scale-x) var(--tw-scale-y);
    }
  }
  .rtl\\:scale-x-\\[-1\\] {
    &:where(:dir(rtl), [dir="rtl"], [dir="rtl"] *) {
      --tw-scale-x: -1;
      scale: var(--tw-scale-x) var(--tw-scale-y);
    }
  }
  .rtl\\:bg-\\[left_0\\.75rem_center\\] {
    &:where(:dir(rtl), [dir="rtl"], [dir="rtl"] *) {
      background-position: left 0.75rem center;
    }
  }
  .rtl\\:text-end {
    &:where(:dir(rtl), [dir="rtl"], [dir="rtl"] *) {
      text-align: end;
    }
  }
  .dark\\:border-none {
    &:where(.dark):not(.no-dark, .no-dark *), &:where(.dark *):not(.no-dark, .no-dark *) {
      --tw-border-style: none;
      border-style: none;
    }
  }
  .dark\\:border-gray-300 {
    &:where(.dark):not(.no-dark, .no-dark *), &:where(.dark *):not(.no-dark, .no-dark *) {
      border-color: var(--color-gray-300);
    }
  }
  .dark\\:border-gray-500 {
    &:where(.dark):not(.no-dark, .no-dark *), &:where(.dark *):not(.no-dark, .no-dark *) {
      border-color: var(--color-gray-500);
    }
  }
  .dark\\:border-gray-600 {
    &:where(.dark):not(.no-dark, .no-dark *), &:where(.dark *):not(.no-dark, .no-dark *) {
      border-color: var(--color-gray-600);
    }
  }
  .dark\\:border-white {
    &:where(.dark):not(.no-dark, .no-dark *), &:where(.dark *):not(.no-dark, .no-dark *) {
      border-color: var(--color-white);
    }
  }
  .dark\\:\\!bg-gray-100 {
    &:where(.dark):not(.no-dark, .no-dark *), &:where(.dark *):not(.no-dark, .no-dark *) {
      background-color: var(--color-gray-100) !important;
    }
  }
  .dark\\:\\!bg-gray-300 {
    &:where(.dark):not(.no-dark, .no-dark *), &:where(.dark *):not(.no-dark, .no-dark *) {
      background-color: var(--color-gray-300) !important;
    }
  }
  .dark\\:\\!bg-white {
    &:where(.dark):not(.no-dark, .no-dark *), &:where(.dark *):not(.no-dark, .no-dark *) {
      background-color: var(--color-white) !important;
    }
  }
  .dark\\:bg-\\[\\#1D1D1A\\] {
    &:where(.dark):not(.no-dark, .no-dark *), &:where(.dark *):not(.no-dark, .no-dark *) {
      background-color: #1D1D1A;
    }
  }
  .dark\\:bg-\\[\\#1e1e1e\\] {
    &:where(.dark):not(.no-dark, .no-dark *), &:where(.dark *):not(.no-dark, .no-dark *) {
      background-color: #1e1e1e;
    }
  }
  .dark\\:bg-\\[\\#332E1A\\] {
    &:where(.dark):not(.no-dark, .no-dark *), &:where(.dark *):not(.no-dark, .no-dark *) {
      background-color: #332E1A;
    }
  }
  .dark\\:bg-gray-100 {
    &:where(.dark):not(.no-dark, .no-dark *), &:where(.dark *):not(.no-dark, .no-dark *) {
      background-color: var(--color-gray-100);
    }
  }
  .dark\\:bg-gray-100\\! {
    &:where(.dark):not(.no-dark, .no-dark *), &:where(.dark *):not(.no-dark, .no-dark *) {
      background-color: var(--color-gray-100) !important;
    }
  }
  .dark\\:bg-gray-100\\/90 {
    &:where(.dark):not(.no-dark, .no-dark *), &:where(.dark *):not(.no-dark, .no-dark *) {
      background-color: var(--color-gray-100);
      @supports (color: color-mix(in lab, red, red)) {
        background-color: color-mix(in oklab, var(--color-gray-100) 90%, transparent);
      }
    }
  }
  .dark\\:bg-gray-150 {
    &:where(.dark):not(.no-dark, .no-dark *), &:where(.dark *):not(.no-dark, .no-dark *) {
      background-color: var(--color-gray-150);
    }
  }
  .dark\\:bg-gray-200 {
    &:where(.dark):not(.no-dark, .no-dark *), &:where(.dark *):not(.no-dark, .no-dark *) {
      background-color: var(--color-gray-200);
    }
  }
  .dark\\:bg-gray-300 {
    &:where(.dark):not(.no-dark, .no-dark *), &:where(.dark *):not(.no-dark, .no-dark *) {
      background-color: var(--color-gray-300);
    }
  }
  .dark\\:bg-gray-400 {
    &:where(.dark):not(.no-dark, .no-dark *), &:where(.dark *):not(.no-dark, .no-dark *) {
      background-color: var(--color-gray-400);
    }
  }
  .dark\\:bg-gray-500 {
    &:where(.dark):not(.no-dark, .no-dark *), &:where(.dark *):not(.no-dark, .no-dark *) {
      background-color: var(--color-gray-500);
    }
  }
  .dark\\:bg-gray-700 {
    &:where(.dark):not(.no-dark, .no-dark *), &:where(.dark *):not(.no-dark, .no-dark *) {
      background-color: var(--color-gray-700);
    }
  }
  .dark\\:bg-green-200 {
    &:where(.dark):not(.no-dark, .no-dark *), &:where(.dark *):not(.no-dark, .no-dark *) {
      background-color: var(--color-green-200);
    }
  }
  .dark\\:bg-green-900 {
    &:where(.dark):not(.no-dark, .no-dark *), &:where(.dark *):not(.no-dark, .no-dark *) {
      background-color: var(--color-green-900);
    }
  }
  .dark\\:bg-orange-900 {
    &:where(.dark):not(.no-dark, .no-dark *), &:where(.dark *):not(.no-dark, .no-dark *) {
      background-color: var(--color-orange-900);
    }
  }
  .dark\\:bg-white {
    &:where(.dark):not(.no-dark, .no-dark *), &:where(.dark *):not(.no-dark, .no-dark *) {
      background-color: var(--color-white);
    }
  }
  .dark\\:darken-25 {
    &:where(.dark):not(.no-dark, .no-dark *), &:where(.dark *):not(.no-dark, .no-dark *) {
      background-image: linear-gradient( rgb(0 0 0 / calc(25 * 1%)), rgb(0 0 0 / calc(25 * 1%)) );
    }
  }
  .dark\\:p-0 {
    &:where(.dark):not(.no-dark, .no-dark *), &:where(.dark *):not(.no-dark, .no-dark *) {
      padding: calc(var(--spacing) * 0);
    }
  }
  .dark\\:\\!text-white {
    &:where(.dark):not(.no-dark, .no-dark *), &:where(.dark *):not(.no-dark, .no-dark *) {
      color: var(--color-white) !important;
    }
  }
  .dark\\:text-\\[\\#d4d4d4\\] {
    &:where(.dark):not(.no-dark, .no-dark *), &:where(.dark *):not(.no-dark, .no-dark *) {
      color: #d4d4d4;
    }
  }
  .dark\\:text-black {
    &:where(.dark):not(.no-dark, .no-dark *), &:where(.dark *):not(.no-dark, .no-dark *) {
      color: var(--color-black);
    }
  }
  .dark\\:text-blue-500 {
    &:where(.dark):not(.no-dark, .no-dark *), &:where(.dark *):not(.no-dark, .no-dark *) {
      color: var(--color-blue-500);
    }
  }
  .dark\\:text-gray-100 {
    &:where(.dark):not(.no-dark, .no-dark *), &:where(.dark *):not(.no-dark, .no-dark *) {
      color: var(--color-gray-100);
    }
  }
  .dark\\:text-gray-200 {
    &:where(.dark):not(.no-dark, .no-dark *), &:where(.dark *):not(.no-dark, .no-dark *) {
      color: var(--color-gray-200);
    }
  }
  .dark\\:text-gray-500 {
    &:where(.dark):not(.no-dark, .no-dark *), &:where(.dark *):not(.no-dark, .no-dark *) {
      color: var(--color-gray-500);
    }
  }
  .dark\\:text-gray-700 {
    &:where(.dark):not(.no-dark, .no-dark *), &:where(.dark *):not(.no-dark, .no-dark *) {
      color: var(--color-gray-700);
    }
  }
  .dark\\:text-gray-800 {
    &:where(.dark):not(.no-dark, .no-dark *), &:where(.dark *):not(.no-dark, .no-dark *) {
      color: var(--color-gray-800);
    }
  }
  .dark\\:text-white {
    &:where(.dark):not(.no-dark, .no-dark *), &:where(.dark *):not(.no-dark, .no-dark *) {
      color: var(--color-white);
    }
  }
  .dark\\:caret-white {
    &:where(.dark):not(.no-dark, .no-dark *), &:where(.dark *):not(.no-dark, .no-dark *) {
      caret-color: var(--color-white);
    }
  }
  .dark\\:shadow-base {
    &:where(.dark):not(.no-dark, .no-dark *), &:where(.dark *):not(.no-dark, .no-dark *) {
      --tw-shadow: 0 6px 12px var(--tw-shadow-color, var(--shadow-color-base));
      box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
    }
  }
  .dark\\:placeholder\\:text-gray-500 {
    &:where(.dark):not(.no-dark, .no-dark *), &:where(.dark *):not(.no-dark, .no-dark *) {
      &::placeholder {
        color: var(--color-gray-500);
      }
    }
  }
  .dark\\:hover\\:bg-gray-200 {
    &:where(.dark):not(.no-dark, .no-dark *), &:where(.dark *):not(.no-dark, .no-dark *) {
      &:hover {
        @media (hover: hover) {
          background-color: var(--color-gray-200);
        }
      }
    }
  }
  .dark\\:hover\\:bg-gray-300 {
    &:where(.dark):not(.no-dark, .no-dark *), &:where(.dark *):not(.no-dark, .no-dark *) {
      &:hover {
        @media (hover: hover) {
          background-color: var(--color-gray-300);
        }
      }
    }
  }
  .dark\\:hover\\:bg-gray-400 {
    &:where(.dark):not(.no-dark, .no-dark *), &:where(.dark *):not(.no-dark, .no-dark *) {
      &:hover {
        @media (hover: hover) {
          background-color: var(--color-gray-400);
        }
      }
    }
  }
  .dark\\:hover\\:brighten-10 {
    &:where(.dark):not(.no-dark, .no-dark *), &:where(.dark *):not(.no-dark, .no-dark *) {
      &:hover {
        @media (hover: hover) {
          background-image: linear-gradient( rgb(255 255 255 / calc(10 * 1%)), rgb(255 255 255 / calc(10 * 1%)) );
        }
      }
    }
  }
  .dark\\:hover\\:\\!text-gray-800 {
    &:where(.dark):not(.no-dark, .no-dark *), &:where(.dark *):not(.no-dark, .no-dark *) {
      &:hover {
        @media (hover: hover) {
          color: var(--color-gray-800) !important;
        }
      }
    }
  }
  .dark\\:hover\\:text-gray-300 {
    &:where(.dark):not(.no-dark, .no-dark *), &:where(.dark *):not(.no-dark, .no-dark *) {
      &:hover {
        @media (hover: hover) {
          color: var(--color-gray-300);
        }
      }
    }
  }
  .dark\\:active\\:brighten-20 {
    &:where(.dark):not(.no-dark, .no-dark *), &:where(.dark *):not(.no-dark, .no-dark *) {
      &:active {
        background-image: linear-gradient( rgb(255 255 255 / calc(20 * 1%)), rgb(255 255 255 / calc(20 * 1%)) );
      }
    }
  }
  .dark\\:disabled\\:text-gray-600 {
    &:where(.dark):not(.no-dark, .no-dark *), &:where(.dark *):not(.no-dark, .no-dark *) {
      &:disabled {
        color: var(--color-gray-600);
      }
    }
  }
  .dark\\:has-\\[\\:focus-visible\\]\\:bg-gray-300 {
    &:where(.dark):not(.no-dark, .no-dark *), &:where(.dark *):not(.no-dark, .no-dark *) {
      &:has(*:is(:focus-visible)) {
        background-color: var(--color-gray-300);
      }
    }
  }
  .forced-colors\\:outline-0 {
    @media (forced-colors: active) {
      outline-style: var(--tw-outline-style);
      outline-width: 0px;
    }
  }
  .forced-colors\\:outline-1 {
    @media (forced-colors: active) {
      outline-style: var(--tw-outline-style);
      outline-width: 1px;
    }
  }
  .group-focus-visible-within\\:hidden {
    &:is(:where(.group):is(:focus-visible, :has(:focus-visible)) *) {
      display: none;
    }
  }
  .group-focus-visible-within\\:opacity-100 {
    &:is(:where(.group):is(:focus-visible, :has(:focus-visible)) *) {
      opacity: 100%;
    }
  }
  .progress-unfilled\\:rounded-sm {
    &::-webkit-progress-bar, & {
      border-radius: var(--radius-sm);
    }
  }
  .progress-unfilled\\:bg-gray-200 {
    &::-webkit-progress-bar, & {
      background-color: var(--color-gray-200);
    }
  }
  .progress-filled\\:rounded-s-sm {
    &::-webkit-progress-value, &::-moz-progress-bar {
      border-start-start-radius: var(--radius-sm);
      border-end-start-radius: var(--radius-sm);
    }
  }
  .progress-filled\\:bg-main {
    &::-webkit-progress-value, &::-moz-progress-bar {
      background-color: var(--color-main);
    }
  }
  .\\[\\&_a\\]\\:text-blue-700 {
    & a {
      color: var(--color-blue-700);
    }
  }
  .\\[\\&_a\\]\\:underline {
    & a {
      text-decoration-line: underline;
    }
  }
  .\\[\\&_b\\]\\:font-semibold {
    & b {
      --tw-font-weight: var(--font-weight-semibold);
      font-weight: var(--font-weight-semibold);
    }
  }
  .\\[\\&_blockquote\\]\\:my-4 {
    & blockquote {
      margin-block: calc(var(--spacing) * 4);
    }
  }
  .\\[\\&_blockquote\\]\\:border-l-2 {
    & blockquote {
      border-left-style: var(--tw-border-style);
      border-left-width: 2px;
    }
  }
  .\\[\\&_blockquote\\]\\:border-gray-300 {
    & blockquote {
      border-color: var(--color-gray-300);
    }
  }
  .\\[\\&_blockquote\\]\\:ps-4 {
    & blockquote {
      padding-inline-start: calc(var(--spacing) * 4);
    }
  }
  .\\[\\&_button\\]\\:pointer-events-auto {
    & button {
      pointer-events: auto;
    }
  }
  .\\[\\&_button\\]\\:rounded-lg {
    & button {
      border-radius: var(--radius-lg);
    }
  }
  .\\[\\&_button\\]\\:bg-main {
    & button {
      background-color: var(--color-main);
    }
  }
  .\\[\\&_button\\]\\:font-bold {
    & button {
      --tw-font-weight: var(--font-weight-bold);
      font-weight: var(--font-weight-bold);
    }
  }
  .\\[\\&_button\\]\\:text-iconOnBrand {
    & button {
      color: var(--color-iconOnBrand);
    }
  }
  .\\[\\&_button\\]\\:hover\\:darken-10 {
    & button {
      &:hover {
        @media (hover: hover) {
          background-image: linear-gradient( rgb(0 0 0 / calc(10 * 1%)), rgb(0 0 0 / calc(10 * 1%)) );
        }
      }
    }
  }
  .\\[\\&_h1\\]\\:my-6 {
    & h1 {
      margin-block: calc(var(--spacing) * 6);
    }
  }
  .\\[\\&_h2\\]\\:my-5 {
    & h2 {
      margin-block: calc(var(--spacing) * 5);
    }
  }
  .\\[\\&_h3\\]\\:my-4 {
    & h3 {
      margin-block: calc(var(--spacing) * 4);
    }
  }
  .\\[\\&_li\\]\\:mb-1 {
    & li {
      margin-bottom: calc(var(--spacing) * 1);
    }
  }
  .\\[\\&_ol\\]\\:my-4 {
    & ol {
      margin-block: calc(var(--spacing) * 4);
    }
  }
  .\\[\\&_ol\\]\\:list-decimal {
    & ol {
      list-style-type: decimal;
    }
  }
  .\\[\\&_ol\\]\\:ps-6 {
    & ol {
      padding-inline-start: calc(var(--spacing) * 6);
    }
  }
  .\\[\\&_ol\\]\\:pl-6 {
    & ol {
      padding-left: calc(var(--spacing) * 6);
    }
  }
  .\\[\\&_p\\]\\:my-6 {
    & p {
      margin-block: calc(var(--spacing) * 6);
    }
  }
  .\\[\\&_p\\]\\:mb-3 {
    & p {
      margin-bottom: calc(var(--spacing) * 3);
    }
  }
  .\\[\\&_strong\\]\\:font-normal {
    & strong {
      --tw-font-weight: var(--font-weight-normal);
      font-weight: var(--font-weight-normal);
    }
  }
  .\\[\\&_strong\\]\\:font-semibold {
    & strong {
      --tw-font-weight: var(--font-weight-semibold);
      font-weight: var(--font-weight-semibold);
    }
  }
  .\\[\\&_table\\]\\:w-auto {
    & table {
      width: auto;
    }
  }
  .\\[\\&_td\\]\\:align-top {
    & td {
      vertical-align: top;
    }
  }
  .\\[\\&_ul\\]\\:my-4 {
    & ul {
      margin-block: calc(var(--spacing) * 4);
    }
  }
  .\\[\\&_ul\\]\\:list-disc {
    & ul {
      list-style-type: disc;
    }
  }
  .\\[\\&_ul\\]\\:ps-6 {
    & ul {
      padding-inline-start: calc(var(--spacing) * 6);
    }
  }
  .\\[\\&_ul\\]\\:pl-6 {
    & ul {
      padding-left: calc(var(--spacing) * 6);
    }
  }
  .\\[\\&\\:\\:-moz-range-thumb\\]\\:size-0 {
    &::-moz-range-thumb {
      width: calc(var(--spacing) * 0);
      height: calc(var(--spacing) * 0);
    }
  }
  .\\[\\&\\:\\:-moz-range-thumb\\]\\:border-0 {
    &::-moz-range-thumb {
      border-style: var(--tw-border-style);
      border-width: 0px;
    }
  }
  .\\[\\&\\:\\:-moz-range-track\\]\\:bg-transparent {
    &::-moz-range-track {
      background-color: transparent;
    }
  }
  .\\[\\&\\:\\:-webkit-scrollbar\\]\\:hidden {
    &::-webkit-scrollbar {
      display: none;
    }
  }
  .\\[\\&\\:\\:-webkit-slider-thumb\\]\\:size-0 {
    &::-webkit-slider-thumb {
      width: calc(var(--spacing) * 0);
      height: calc(var(--spacing) * 0);
    }
  }
  .\\[\\&\\:\\:-webkit-slider-thumb\\]\\:appearance-none {
    &::-webkit-slider-thumb {
      appearance: none;
    }
  }
  .\\[\\&\\>code\\]\\:bg-transparent {
    &>code {
      background-color: transparent;
    }
  }
  .\\[\\&\\>code\\]\\:p-0 {
    &>code {
      padding: calc(var(--spacing) * 0);
    }
  }
  .\\[\\&\\>div\\]\\:\\!items-start {
    &>div {
      align-items: flex-start !important;
    }
  }
  .\\[\\&\\>div\\]\\:\\!self-start {
    &>div {
      align-self: flex-start !important;
    }
  }
  .\\[\\&\\>header\\]\\:h-16 {
    &>header {
      height: calc(var(--spacing) * 16);
    }
  }
  .\\[\\&\\>header\\]\\:px-6 {
    &>header {
      padding-inline: calc(var(--spacing) * 6);
    }
  }
  .\\[\\&\\>header\\>button\\]\\:-me-1 {
    &>header>button {
      margin-inline-end: calc(var(--spacing) * -1);
    }
  }
  .\\[\\&\\>svg\\]\\:size-5\\! {
    &>svg {
      width: calc(var(--spacing) * 5) !important;
      height: calc(var(--spacing) * 5) !important;
    }
  }
}
@layer theme, base, components, utilities;
@layer theme;
@layer base {
  *, ::after, ::before, ::backdrop, ::file-selector-button {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
    border: 0 solid;
  }
  html, :host {
    line-height: 1.5;
    -webkit-text-size-adjust: 100%;
    tab-size: 4;
    font-family: var(--default-font-family, ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji");
    font-feature-settings: var(--default-font-feature-settings, normal);
    font-variation-settings: var(--default-font-variation-settings, normal);
    -webkit-tap-highlight-color: transparent;
  }
  hr {
    height: 0;
    color: inherit;
    border-top-width: 1px;
  }
  abbr:where([title]) {
    -webkit-text-decoration: underline dotted;
    text-decoration: underline dotted;
  }
  h1, h2, h3, h4, h5, h6 {
    font-size: inherit;
    font-weight: inherit;
  }
  a {
    color: inherit;
    -webkit-text-decoration: inherit;
    text-decoration: inherit;
  }
  b, strong {
    font-weight: bolder;
  }
  code, kbd, samp, pre {
    font-family: var(--default-mono-font-family, ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace);
    font-feature-settings: var(--default-mono-font-feature-settings, normal);
    font-variation-settings: var(--default-mono-font-variation-settings, normal);
    font-size: 1em;
  }
  small {
    font-size: 80%;
  }
  sub, sup {
    font-size: 75%;
    line-height: 0;
    position: relative;
    vertical-align: baseline;
  }
  sub {
    bottom: -0.25em;
  }
  sup {
    top: -0.5em;
  }
  table {
    text-indent: 0;
    border-color: inherit;
    border-collapse: collapse;
  }
  :-moz-focusring {
    outline: auto;
  }
  progress {
    vertical-align: baseline;
  }
  summary {
    display: list-item;
  }
  ol, ul, menu {
    list-style: none;
  }
  img, svg, video, canvas, audio, iframe, embed, object {
    display: block;
    vertical-align: middle;
  }
  img, video {
    max-width: 100%;
    height: auto;
  }
  button, input, select, optgroup, textarea, ::file-selector-button {
    font: inherit;
    font-feature-settings: inherit;
    font-variation-settings: inherit;
    letter-spacing: inherit;
    color: inherit;
    border-radius: 0;
    background-color: transparent;
    opacity: 1;
  }
  :where(select:is([multiple], [size])) optgroup {
    font-weight: bolder;
  }
  :where(select:is([multiple], [size])) optgroup option {
    padding-inline-start: 20px;
  }
  ::file-selector-button {
    margin-inline-end: 4px;
  }
  ::placeholder {
    opacity: 1;
  }
  @supports (not (-webkit-appearance: -apple-pay-button))  or (contain-intrinsic-size: 1px) {
    ::placeholder {
      color: currentcolor;
      @supports (color: color-mix(in lab, red, red)) {
        color: color-mix(in oklab, currentcolor 50%, transparent);
      }
    }
  }
  textarea {
    resize: vertical;
  }
  ::-webkit-search-decoration {
    -webkit-appearance: none;
  }
  ::-webkit-date-and-time-value {
    min-height: 1lh;
    text-align: inherit;
  }
  ::-webkit-datetime-edit {
    display: inline-flex;
  }
  ::-webkit-datetime-edit-fields-wrapper {
    padding: 0;
  }
  ::-webkit-datetime-edit, ::-webkit-datetime-edit-year-field, ::-webkit-datetime-edit-month-field, ::-webkit-datetime-edit-day-field, ::-webkit-datetime-edit-hour-field, ::-webkit-datetime-edit-minute-field, ::-webkit-datetime-edit-second-field, ::-webkit-datetime-edit-millisecond-field, ::-webkit-datetime-edit-meridiem-field {
    padding-block: 0;
  }
  ::-webkit-calendar-picker-indicator {
    line-height: 1;
  }
  :-moz-ui-invalid {
    box-shadow: none;
  }
  button, input:where([type="button"], [type="reset"], [type="submit"]), ::file-selector-button {
    appearance: button;
  }
  ::-webkit-inner-spin-button, ::-webkit-outer-spin-button {
    height: auto;
  }
  [hidden]:where(:not([hidden="until-found"])) {
    display: none !important;
  }
}
@layer utilities;
@keyframes text-fit-scroll-fade {
  0% {
    mask-image: linear-gradient( var(--text-fit-fade-direction), black calc(100% - 0.9em), transparent );
  }
  1%, 99% {
    mask-image: linear-gradient( var(--text-fit-fade-direction), transparent, black 0.9em, black calc(100% - 0.9em), transparent );
  }
  100% {
    mask-image: linear-gradient( var(--text-fit-fade-direction), transparent, black 0.9em );
  }
}
@keyframes summary-reveal-appear {
  to {
    opacity: 1;
  }
}
@keyframes summary-reveal-caret {
  from {
    opacity: 1;
  }
  99% {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}
.summary-reveal {
  --reveal-tick-duration: 16ms;
}
.summary-reveal .reveal-chunk {
  position: relative;
  opacity: 0;
  animation: summary-reveal-appear 1ms linear forwards;
  animation-delay: calc(var(--reveal-tick) * var(--reveal-tick-duration));
}
.summary-reveal .reveal-chunk::after {
  content: '';
  position: absolute;
  inset-inline-end: -3px;
  width: 2px;
  height: 1em;
  transform: translateY(2px);
  background-color: currentColor;
  opacity: 0;
  animation: summary-reveal-caret var(--reveal-tick-duration) linear forwards;
  animation-delay: calc(var(--reveal-tick) * var(--reveal-tick-duration));
}
@media (prefers-reduced-motion: reduce) {
  .summary-reveal .reveal-chunk {
    opacity: 1;
    animation: none;
  }
  .summary-reveal .reveal-chunk::after {
    content: none;
  }
}
@layer base {
  *,
    ::after,
    ::before,
    ::backdrop,
    ::file-selector-button {
    border-color: var(--color-gray-200, currentColor);
  }
}
@layer base {
  input::placeholder,
    textarea::placeholder {
    color: var(--color-gray-400);
  }
}
@layer base {
  button:not(:disabled),
    [role='button']:not(:disabled) {
    cursor: pointer;
  }
}
@supports (-webkit-touch-callout: none) {
  @layer base {
    input,
        textarea,
        select,
        [contenteditable='true'] {
      font-size: max(16px, 1em);
    }
  }
  input,
    textarea,
    select,
    [contenteditable='true'] {
    --text-2xs: 1rem;
    --text-xs: 1rem;
    --text-sm: 1rem;
  }
}
html,
.no-dark {
  --color-white: #fff;
  --color-black: #000;
  --color-super-light-grey: #f8f8f8;
  --color-light-background: #f5f5f5;
  --color-dark-background: #ececec;
  --color-ornament: #d7d7d7;
  --color-light-grey: #adadad;
  --color-mid-grey: #727272;
  --color-icon: #474747;
  --color-dark-icon: #3f4142;
  --color-dark-grey: #242424;
  --color-super-dark-grey: #121212;
  --color-yellow-light: #fef698;
  --color-link: #2c70b5;
  --shadow-color-xs: rgb(0 0 0 / 0.05);
  --shadow-color-md: rgb(0 0 0 / 0.1);
  --shadow-color-base: rgba(0, 0, 0, 0.05);
  --shadow-color-lg: rgba(0, 0, 0, 0.2);
}
@layer utilities {
  .no-dark {
    color-scheme: light !important;
  }
  .no-dark * {
    color-scheme: light !important;
  }
  html.dark .no-dark,
    html.dark .no-dark *,
    .dark .no-dark,
    .dark .no-dark * {
    --color-white: #fff !important;
    --color-black: #000 !important;
    --color-overlay: rgba(0, 0, 0, 0.5) !important;
    --color-super-light-grey: #f8f8f8 !important;
    --color-light-background: #f5f5f5 !important;
    --color-dark-background: #ececec !important;
    --color-ornament: #d7d7d7 !important;
    --color-light-grey: #adadad !important;
    --color-mid-grey: #727272 !important;
    --color-icon: #474747 !important;
    --color-dark-icon: #3f4142 !important;
    --color-dark-grey: #242424 !important;
    --color-super-dark-grey: #121212 !important;
    --color-yellow-light: #fef698 !important;
    --color-link: #2c70b5 !important;
    --shadow-color-xs: rgb(0 0 0 / 0.05) !important;
    --shadow-color-md: rgb(0 0 0 / 0.1) !important;
    --shadow-color-base: rgba(0, 0, 0, 0.05) !important;
    --shadow-color-lg: rgba(0, 0, 0, 0.2) !important;
    --color-gray-100: #f8f8f8 !important;
    --color-gray-150: #f5f5f5 !important;
    --color-gray-200: #ececec !important;
    --color-gray-300: #d7d7d7 !important;
    --color-gray-400: #adadad !important;
    --color-gray-500: #727272 !important;
    --color-gray-600: #474747 !important;
    --color-gray-700: #3f4142 !important;
    --color-gray-800: #242424 !important;
    --color-gray-900: #121212 !important;
    color-scheme: light !important;
  }
}
html.dark {
  --color-white: #0e0e0e;
  --color-overlay: rgba(0, 0, 0, 0.5);
  --color-black: #ffffff;
  --color-super-light-grey: #1a1a1a;
  --color-light-background: #232323;
  --color-dark-background: #2c2c2c;
  --color-ornament: #3a3a3a;
  --color-light-grey: #505050;
  --color-mid-grey: #898989;
  --color-icon: #bcbcbc;
  --color-dark-icon: #c9c9c9;
  --color-dark-grey: #d9d9d9;
  --color-super-dark-grey: #e9e9e9;
  --color-yellow-light: #524f31;
  --color-link: #25a6d1;
  --shadow-color-xs: rgba(0, 0, 0, 0.5);
  --shadow-color-md: rgba(0, 0, 0, 0.5);
  --shadow-color-base: rgba(0, 0, 0, 0.5);
  --shadow-color-lg: rgba(0, 0, 0, 0.5);
}
html.dark,
html.dark body {
  background-color: var(--color-super-light-grey);
}
.dark\\:bg-gray-200:is(.dark *) > .divider > .bg-gray-200 {
  background-color: var(--color-ornament) !important;
}
html {
  --color-main: #2c3551;
  --color-green: #2dc659;
  --color-red: #fd5234;
  --color-yellow: #fcd41e;
  --color-chat-you: #2dc659;
  --color-conference: #f17b3b;
  --color-refer: #2c3551;
  --color-huntgroup: #2dc659;
  --color-channel: #25a6d1;
  --color-voicemail: #37ba9b;
  --color-connection: #2c70b5;
  --color-iconOnBrand: #fff;
  --color-textOnBrand: #fff;
  --color-flavor-1: #f17b3b;
  --color-flavor-2: #e6bd03;
  --color-flavor-3: #89cb55;
  --color-flavor-4: #37ba9b;
  --color-flavor-5: #25a6d1;
  --color-flavor-6: #2c70b5;
  --color-flavor-7: #79438c;
  --color-flavor-8: #d54f8c;
  --color-flavor-9: #dc5e5e;
}
body {
  color: var(--color-dark-grey) !important;
  font: 400 16px/1.5 'Roboto',
        'Noto Sans Arabic',
        sans-serif !important;
}
@font-face {
  font-family: 'Gotham Bold';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___})
            format('embedded-opentype'),
        
            url(${___CSS_LOADER_URL_REPLACEMENT_3___})
            format('woff2'),
        
            url(${___CSS_LOADER_URL_REPLACEMENT_4___})
            format('woff'),
        
            url(${___CSS_LOADER_URL_REPLACEMENT_5___})
            format('truetype'),
        
            url(${___CSS_LOADER_URL_REPLACEMENT_6___});
  font-weight: normal;
  font-style: normal;
}
@font-face {
  font-family: 'Gotham Bold';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
  font-style: italic;
}
@font-face {
  font-family: 'Gotham Book';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_9___})
            format('embedded-opentype'),
        
            url(${___CSS_LOADER_URL_REPLACEMENT_10___})
            format('woff2'),
        
            url(${___CSS_LOADER_URL_REPLACEMENT_11___})
            format('woff'),
        
            url(${___CSS_LOADER_URL_REPLACEMENT_12___})
            format('truetype'),
        
            url(${___CSS_LOADER_URL_REPLACEMENT_13___});
  font-weight: normal;
  font-style: normal;
}
@font-face {
  font-family: 'Gotham Book';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_14___});
  font-style: italic;
}
@font-face {
  font-family: 'Gotham Light';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_15___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_16___})
            format('embedded-opentype'),
        
            url(${___CSS_LOADER_URL_REPLACEMENT_17___})
            format('woff2'),
        
            url(${___CSS_LOADER_URL_REPLACEMENT_18___})
            format('woff'),
        
            url(${___CSS_LOADER_URL_REPLACEMENT_19___})
            format('truetype'),
        
            url(${___CSS_LOADER_URL_REPLACEMENT_20___});
  font-weight: normal;
  font-style: normal;
}
@font-face {
  font-family: 'Gotham Light';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_21___});
  font-style: italic;
}
@font-face {
  font-family: 'Gotham Medium';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_22___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_23___})
            format('embedded-opentype'),
        
            url(${___CSS_LOADER_URL_REPLACEMENT_24___})
            format('woff2'),
        
            url(${___CSS_LOADER_URL_REPLACEMENT_25___})
            format('woff'),
        
            url(${___CSS_LOADER_URL_REPLACEMENT_26___})
            format('truetype'),
        
            url(${___CSS_LOADER_URL_REPLACEMENT_27___});
  font-weight: normal;
  font-style: normal;
}
@font-face {
  font-family: 'Gotham Medium';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_28___});
  font-style: italic;
}
@font-face {
  font-family: 'Roboto-Regular';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_29___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_30___})
            format('embedded-opentype'),
        url(${___CSS_LOADER_URL_REPLACEMENT_31___})
            format('svg'),
        url(${___CSS_LOADER_URL_REPLACEMENT_32___})
            format('truetype'),
        url(${___CSS_LOADER_URL_REPLACEMENT_33___})
            format('woff'),
        url(${___CSS_LOADER_URL_REPLACEMENT_34___})
            format('woff2');
  font-weight: normal;
  font-style: normal;
}
@font-face {
  font-family: 'Roboto-Bold';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_35___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_36___})
            format('embedded-opentype'),
        url(${___CSS_LOADER_URL_REPLACEMENT_37___})
            format('svg'),
        url(${___CSS_LOADER_URL_REPLACEMENT_38___})
            format('truetype'),
        url(${___CSS_LOADER_URL_REPLACEMENT_39___})
            format('woff'),
        url(${___CSS_LOADER_URL_REPLACEMENT_40___})
            format('woff2');
  font-weight: normal;
  font-style: normal;
}
@font-face {
  font-family: 'Roboto-Medium';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_41___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_42___})
            format('embedded-opentype'),
        url(${___CSS_LOADER_URL_REPLACEMENT_43___})
            format('svg'),
        url(${___CSS_LOADER_URL_REPLACEMENT_44___})
            format('truetype'),
        url(${___CSS_LOADER_URL_REPLACEMENT_45___})
            format('woff'),
        url(${___CSS_LOADER_URL_REPLACEMENT_46___})
            format('woff2');
  font-weight: normal;
  font-style: normal;
}
@font-face {
  font-family: 'Roboto-Light';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_47___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_48___})
            format('embedded-opentype'),
        url(${___CSS_LOADER_URL_REPLACEMENT_49___})
            format('svg'),
        url(${___CSS_LOADER_URL_REPLACEMENT_50___})
            format('truetype'),
        url(${___CSS_LOADER_URL_REPLACEMENT_51___})
            format('woff'),
        url(${___CSS_LOADER_URL_REPLACEMENT_52___})
            format('woff2');
  font-weight: normal;
  font-style: normal;
}
@font-face {
  font-family: 'RobotoMono';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_53___});
  font-weight: 500;
  font-style: normal;
}
@font-face {
  font-family: 'Roboto';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_52___})
        format('woff2');
  font-weight: 300;
  font-style: normal;
}
@font-face {
  font-family: 'Roboto';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_34___})
        format('woff2');
  font-weight: 400;
  font-style: normal;
}
@font-face {
  font-family: 'Roboto';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_46___})
        format('woff2');
  font-weight: 500;
  font-style: normal;
}
@font-face {
  font-family: 'Roboto';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_40___})
        format('woff2');
  font-weight: 700;
  font-style: normal;
}
@font-face {
  font-family: 'RobotoMono';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_53___})
        format('ttf');
  font-weight: 500;
  font-style: normal;
}
@font-face {
  font-family: 'Noto Sans Arabic';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_54___})
        format('woff2');
  font-weight: 400;
  font-style: normal;
}
@font-face {
  font-family: 'Noto Sans Arabic';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_55___})
        format('woff2');
  font-weight: 500;
  font-style: normal;
}
@font-face {
  font-family: 'Noto Sans Arabic';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_56___})
        format('woff2');
  font-weight: 700;
  font-style: normal;
}
.badge-bg.bg-white .badge {
  --tw-ring-color: var(--color-white);
}
.badge-bg.bg-white .group:hover .badge {
  --tw-ring-color: var(--color-gray-100);
}
.badge-bg.bg-gray-150 .badge {
  --tw-ring-color: var(--color-gray-150);
}
.badge-bg.bg-gray-200 .badge {
  --tw-ring-color: var(--color-gray-200);
}
.badge-bg.bg-gray-200 .group:hover .badge {
  --tw-ring-color: var(--color-gray-300);
}
.badge-bg.bg-gray-800 .badge {
  --tw-ring-color: var(--color-gray-800);
}
.badge-bg.bg-gray-800 .group:hover .badge {
  --tw-ring-color: var(--color-gray-700);
}
.badge {
  --tw-ring-color: var(--color-gray-100);
}
.group:hover .badge {
  --tw-ring-color: var(--color-gray-200);
}
@layer utilities {
  .scrollbar {
    overflow-y: auto;
  }
  .scrollbar::-webkit-scrollbar {
    display: block;
  }
  .scrollbar::-webkit-scrollbar-track {
    background-color: transparent;
  }
  .scrollbar::-webkit-scrollbar-thumb {
    display: block;
    background-color: var(--color-gray-300);
  }
  .scrollbar.scrollbar-deferred::-webkit-scrollbar-thumb {
    background-color: transparent;
  }
  .scrollbar.scrollbar-deferred.scrollbar-ready::-webkit-scrollbar-thumb {
    background-color: var(--color-gray-300);
  }
  html.dark
        .scrollbar.scrollbar-contrast:not(
            .no-dark,
            .no-dark *
        )::-webkit-scrollbar-thumb {
    background-color: var(--color-gray-400);
  }
  .hide-scrollbar {
    scrollbar-width: none;
    -ms-overflow-style: none;
  }
  .hide-scrollbar::-webkit-scrollbar {
    display: none;
  }
  [type='search']::-webkit-search-cancel-button {
    width: calc(var(--spacing) * 4);
    height: calc(var(--spacing) * 4);
    cursor: pointer;
    appearance: none;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_57___});
  }
  .dark [type='search']::-webkit-search-cancel-button {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_58___});
  }
}
em-emoji-picker {
  --border-radius: 0.25rem;
  --color-border-over: none;
}
.no-select {
  user-select: none;
}
.no-select::selection {
  background: none;
}
.override-hover:hover {
  background-image: none !important;
}
.markdown h1 {
  font-size: var(--text-3xl);
  line-height: var(--tw-leading, var(--text-3xl--line-height));
  --tw-font-weight: var(--font-weight-bold);
  font-weight: var(--font-weight-bold);
}
.markdown h2 {
  font-size: var(--text-2xl);
  line-height: var(--tw-leading, var(--text-2xl--line-height));
  --tw-font-weight: var(--font-weight-semibold);
  font-weight: var(--font-weight-semibold);
}
.markdown h3 {
  font-size: var(--text-xl);
  line-height: var(--tw-leading, var(--text-xl--line-height));
  --tw-font-weight: var(--font-weight-semibold);
  font-weight: var(--font-weight-semibold);
}
.markdown ul {
  list-style-type: disc;
  padding-inline-start: calc(var(--spacing) * 6);
}
.markdown ol {
  list-style-type: decimal;
  padding-inline-start: calc(var(--spacing) * 6);
}
.markdown blockquote {
  border-inline-start-style: var(--tw-border-style);
  border-inline-start-width: 4px;
  border-color: var(--color-gray-300);
  padding-block: calc(var(--spacing) * 2);
  padding-inline-start: calc(var(--spacing) * 4);
  color: var(--color-gray-600);
  font-style: italic;
}
.markdown table {
  margin-block: calc(var(--spacing) * 2);
  width: 100%;
  border-collapse: collapse;
}
.markdown th,
.markdown td {
  border-style: var(--tw-border-style);
  border-width: 1px;
  border-color: var(--color-gray-300);
  padding-inline: calc(var(--spacing) * 4);
  padding-block: calc(var(--spacing) * 2);
  text-align: start;
}
.markdown hr {
  margin-block: calc(var(--spacing) * 4);
  border-top-style: var(--tw-border-style);
  border-top-width: 1px;
  border-color: var(--color-gray-300);
}
.markdown a {
  color: var(--color-link);
  &:hover {
    @media (hover: hover) {
      text-decoration-line: underline;
    }
  }
}
.dark .transfer-modal .left-nav-scroll-wrapper {
  --color-gray-200: var(--color-ornament);
}
@property --tw-content {
  syntax: "*";
  initial-value: "";
  inherits: false;
}
@property --tw-translate-x {
  syntax: "*";
  inherits: false;
  initial-value: 0;
}
@property --tw-translate-y {
  syntax: "*";
  inherits: false;
  initial-value: 0;
}
@property --tw-translate-z {
  syntax: "*";
  inherits: false;
  initial-value: 0;
}
@property --tw-scale-x {
  syntax: "*";
  inherits: false;
  initial-value: 1;
}
@property --tw-scale-y {
  syntax: "*";
  inherits: false;
  initial-value: 1;
}
@property --tw-scale-z {
  syntax: "*";
  inherits: false;
  initial-value: 1;
}
@property --tw-rotate-x {
  syntax: "*";
  inherits: false;
}
@property --tw-rotate-y {
  syntax: "*";
  inherits: false;
}
@property --tw-rotate-z {
  syntax: "*";
  inherits: false;
}
@property --tw-skew-x {
  syntax: "*";
  inherits: false;
}
@property --tw-skew-y {
  syntax: "*";
  inherits: false;
}
@property --tw-space-y-reverse {
  syntax: "*";
  inherits: false;
  initial-value: 0;
}
@property --tw-divide-y-reverse {
  syntax: "*";
  inherits: false;
  initial-value: 0;
}
@property --tw-border-style {
  syntax: "*";
  inherits: false;
  initial-value: solid;
}
@property --tw-leading {
  syntax: "*";
  inherits: false;
}
@property --tw-font-weight {
  syntax: "*";
  inherits: false;
}
@property --tw-tracking {
  syntax: "*";
  inherits: false;
}
@property --tw-ordinal {
  syntax: "*";
  inherits: false;
}
@property --tw-slashed-zero {
  syntax: "*";
  inherits: false;
}
@property --tw-numeric-figure {
  syntax: "*";
  inherits: false;
}
@property --tw-numeric-spacing {
  syntax: "*";
  inherits: false;
}
@property --tw-numeric-fraction {
  syntax: "*";
  inherits: false;
}
@property --tw-shadow {
  syntax: "*";
  inherits: false;
  initial-value: 0 0 #0000;
}
@property --tw-shadow-color {
  syntax: "*";
  inherits: false;
}
@property --tw-shadow-alpha {
  syntax: "<percentage>";
  inherits: false;
  initial-value: 100%;
}
@property --tw-inset-shadow {
  syntax: "*";
  inherits: false;
  initial-value: 0 0 #0000;
}
@property --tw-inset-shadow-color {
  syntax: "*";
  inherits: false;
}
@property --tw-inset-shadow-alpha {
  syntax: "<percentage>";
  inherits: false;
  initial-value: 100%;
}
@property --tw-ring-color {
  syntax: "*";
  inherits: false;
}
@property --tw-ring-shadow {
  syntax: "*";
  inherits: false;
  initial-value: 0 0 #0000;
}
@property --tw-inset-ring-color {
  syntax: "*";
  inherits: false;
}
@property --tw-inset-ring-shadow {
  syntax: "*";
  inherits: false;
  initial-value: 0 0 #0000;
}
@property --tw-ring-inset {
  syntax: "*";
  inherits: false;
}
@property --tw-ring-offset-width {
  syntax: "<length>";
  inherits: false;
  initial-value: 0px;
}
@property --tw-ring-offset-color {
  syntax: "*";
  inherits: false;
  initial-value: #fff;
}
@property --tw-ring-offset-shadow {
  syntax: "*";
  inherits: false;
  initial-value: 0 0 #0000;
}
@property --tw-outline-style {
  syntax: "*";
  inherits: false;
  initial-value: solid;
}
@property --tw-blur {
  syntax: "*";
  inherits: false;
}
@property --tw-brightness {
  syntax: "*";
  inherits: false;
}
@property --tw-contrast {
  syntax: "*";
  inherits: false;
}
@property --tw-grayscale {
  syntax: "*";
  inherits: false;
}
@property --tw-hue-rotate {
  syntax: "*";
  inherits: false;
}
@property --tw-invert {
  syntax: "*";
  inherits: false;
}
@property --tw-opacity {
  syntax: "*";
  inherits: false;
}
@property --tw-saturate {
  syntax: "*";
  inherits: false;
}
@property --tw-sepia {
  syntax: "*";
  inherits: false;
}
@property --tw-drop-shadow {
  syntax: "*";
  inherits: false;
}
@property --tw-drop-shadow-color {
  syntax: "*";
  inherits: false;
}
@property --tw-drop-shadow-alpha {
  syntax: "<percentage>";
  inherits: false;
  initial-value: 100%;
}
@property --tw-drop-shadow-size {
  syntax: "*";
  inherits: false;
}
@property --tw-backdrop-blur {
  syntax: "*";
  inherits: false;
}
@property --tw-backdrop-brightness {
  syntax: "*";
  inherits: false;
}
@property --tw-backdrop-contrast {
  syntax: "*";
  inherits: false;
}
@property --tw-backdrop-grayscale {
  syntax: "*";
  inherits: false;
}
@property --tw-backdrop-hue-rotate {
  syntax: "*";
  inherits: false;
}
@property --tw-backdrop-invert {
  syntax: "*";
  inherits: false;
}
@property --tw-backdrop-opacity {
  syntax: "*";
  inherits: false;
}
@property --tw-backdrop-saturate {
  syntax: "*";
  inherits: false;
}
@property --tw-backdrop-sepia {
  syntax: "*";
  inherits: false;
}
@property --tw-duration {
  syntax: "*";
  inherits: false;
}
@property --tw-ease {
  syntax: "*";
  inherits: false;
}
@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
@keyframes ping {
  75%, 100% {
    transform: scale(2);
    opacity: 0;
  }
}
@keyframes pulse {
  50% {
    opacity: 0.5;
  }
}
@keyframes ellipsis {
  0% {
    content: '';
  }
  25% {
    content: '.';
  }
  50% {
    content: '..';
  }
  75% {
    content: '...';
  }
}
@keyframes fade {
  50% {
    opacity: 50%;
  }
}
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes slideInDialpad {
  0% {
    transform: translateX(100%);
    width: 0;
    min-width: 0;
  }
  100% {
    transform: translateX(0);
    width: 360px;
    min-width: 360px;
  }
}
@keyframes slideInFromBottom {
  0% {
    opacity: 0;
    transform: translateY(20px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes slideOut {
  0% {
    transform: translateX(0);
    width: 360px;
    min-width: 360px;
  }
  100% {
    transform: translateX(100%);
    width: 0;
    min-width: 0;
  }
}
@keyframes incomingCallPulseLarge {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.75;
  }
  100% {
    opacity: 0.5;
    border-width: 10px;
    transform: scale(1.2);
  }
}
@keyframes spinSmoothAcceleration {
  0% {
    transform: rotate(0deg);
  }
  50% {
    transform: rotate(360deg);
    animation-timing-function: cubic-bezier(0.4, 0, 1, 1);
  }
  100% {
    transform: rotate(720deg);
    animation-timing-function: cubic-bezier(0.4, 1, 1, 0);
  }
}
@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
@keyframes ping {
  75%, 100% {
    transform: scale(2);
    opacity: 0;
  }
}
@keyframes pulse {
  50% {
    opacity: 0.5;
  }
}
@layer properties {
  @supports ((-webkit-hyphens: none) and (not (margin-trim: inline))) or ((-moz-orient: inline) and (not (color:rgb(from red r g b)))) {
    *, ::before, ::after, ::backdrop {
      --tw-content: "";
      --tw-translate-x: 0;
      --tw-translate-y: 0;
      --tw-translate-z: 0;
      --tw-scale-x: 1;
      --tw-scale-y: 1;
      --tw-scale-z: 1;
      --tw-rotate-x: initial;
      --tw-rotate-y: initial;
      --tw-rotate-z: initial;
      --tw-skew-x: initial;
      --tw-skew-y: initial;
      --tw-space-y-reverse: 0;
      --tw-divide-y-reverse: 0;
      --tw-border-style: solid;
      --tw-leading: initial;
      --tw-font-weight: initial;
      --tw-tracking: initial;
      --tw-ordinal: initial;
      --tw-slashed-zero: initial;
      --tw-numeric-figure: initial;
      --tw-numeric-spacing: initial;
      --tw-numeric-fraction: initial;
      --tw-shadow: 0 0 #0000;
      --tw-shadow-color: initial;
      --tw-shadow-alpha: 100%;
      --tw-inset-shadow: 0 0 #0000;
      --tw-inset-shadow-color: initial;
      --tw-inset-shadow-alpha: 100%;
      --tw-ring-color: initial;
      --tw-ring-shadow: 0 0 #0000;
      --tw-inset-ring-color: initial;
      --tw-inset-ring-shadow: 0 0 #0000;
      --tw-ring-inset: initial;
      --tw-ring-offset-width: 0px;
      --tw-ring-offset-color: #fff;
      --tw-ring-offset-shadow: 0 0 #0000;
      --tw-outline-style: solid;
      --tw-blur: initial;
      --tw-brightness: initial;
      --tw-contrast: initial;
      --tw-grayscale: initial;
      --tw-hue-rotate: initial;
      --tw-invert: initial;
      --tw-opacity: initial;
      --tw-saturate: initial;
      --tw-sepia: initial;
      --tw-drop-shadow: initial;
      --tw-drop-shadow-color: initial;
      --tw-drop-shadow-alpha: 100%;
      --tw-drop-shadow-size: initial;
      --tw-backdrop-blur: initial;
      --tw-backdrop-brightness: initial;
      --tw-backdrop-contrast: initial;
      --tw-backdrop-grayscale: initial;
      --tw-backdrop-hue-rotate: initial;
      --tw-backdrop-invert: initial;
      --tw-backdrop-opacity: initial;
      --tw-backdrop-saturate: initial;
      --tw-backdrop-sepia: initial;
      --tw-duration: initial;
      --tw-ease: initial;
    }
  }
}
`, "",{"version":3,"sources":["<no source>","webpack://./src/app/css/tailwind.plugin.css","webpack://./../node_modules/tailwindcss/index.css","webpack://./src/app/css/tailwind.config.css","webpack://./src/app/css/main.css"],"names":[],"mappings":"AAAA,kEAAA;ACsIW,iBAAc;ACtIzB,yCAAyC;AAEzC;EACE;ICCE,mBAAmB;IACnB,uBAAuB;IDQvB,0CAA0C;IAI1C,0CAA0C;IAC1C,0CAA0C;IAQ1C,6CAA6C;IAO7C,6CAA6C;IAI7C,4CAA4C;IAC5C,2CAA2C;IAK3C,4CAA4C;IAE5C,4CAA4C;IClC5C,6CAA6C;IDyC7C,6CAA6C;IAI7C,6CAA6C;IAiB7C,6CAA6C;IAC7C,6CAA6C;IAG7C,6CAA6C;IAC7C,6CAA6C;IAC7C,6CAA6C;IAE7C,6CAA6C;IAsD7C,4CAA4C;IAE5C,4CAA4C;IAC5C,4CAA4C;IAC5C,4CAA4C;IAC5C,4CAA4C;IAiC5C,4CAA4C;IAuD5C,2CAA2C;IC/L3C,+CAA+C;IAE/C,8CAA8C;IAC9C,uCAAuC;IACvC,yCAAyC;IACzC,uCAAuC;IACvC,mCAAmC;IACnC,wCAAwC;IACxC,wCAAwC;IACxC,8CAA8C;IAhC9C,iCAAiC;IADjC,iCAAiC;ID0QjC,kBAAkB;IAElB,sBAAsB;IACtB,sBAAsB;IAOtB,qBAAqB;IACrB,qBAAqB;IACrB,qBAAqB;IAErB,qBAAqB;IACrB,sBAAsB;IACtB,sBAAsB;IAMtB,kBAAkB;IAClB,sCAAsC;IACtC,mBAAmB;IACnB,0CAA0C;IAC1C,iBAAiB;IACjB,uCAAuC;IACvC,mBAAmB;IACnB,0CAA0C;IAC1C,kBAAkB;IAClB,yCAAyC;IACzC,kBAAkB;IAClB,sCAAsC;IACtC,oBAAoB;IACpB,2CAA2C;IAc3C,uBAAuB;IAEvB,wBAAwB;IACxB,yBAAyB;IACzB,yBAAyB;IACzB,2BAA2B;IAC3B,uBAAuB;IAKvB,0BAA0B;IAC1B,sBAAsB;IACtB,wBAAwB;IACxB,wBAAwB;IAKxB,qBAAqB;IACrB,wBAAwB;IAGxB,qBAAqB;IACrB,oBAAoB;IACpB,qBAAqB;IACrB,mBAAmB;IACnB,oBAAoB;IACpB,kBAAkB;IAClB,oBAAoB;IACpB,kBAAkB;IAoClB,qCAAqC;IACrC,sCAAsC;IACtC,2CAA2C;IAE3C,uCAAuC;IACvC,2DAA2D;IAC3D,+DAA+D;IAqC/D,cAAc;IAad,sBAAsB;IAEtB,oCAAoC;IACpC,kEAAkE;IAClE,uCAAoD;IASpD,4CAAyD;ICxczD,+BAA+B;IAC/B,iCAAiC;IACjC,6BAA6B;IAC7B,mCAAmC;IAKnC,sCAAsC;IACtC,+BAA+B;IAE/B,+CAA+C;IAC/C,qCAAqC;IACrC,6CAA6C;IAC7C,yCAAyC;IACzC,6CAA6C;IAC7C,+CAA+C;IAC/C,6CAA6C;IAC7C,6CAA6C;IAE7C,uCAAuC;IACvC,uCAAuC;IACvC,uCAAuC;IACvC,uCAAuC;IACvC,uCAAuC;IACvC,uCAAuC;IACvC,uCAAuC;IACvC,uCAAuC;IACvC,uCAAuC;IAGvC,+CAA+C;IAiB/C,8BAA8B;IAK9B,8BAA8B;IAQ9B,mCAAmC;IAEnC,oBAAoB;IAUpB,6DAA6D;IAC7D,wCAAwC;IACxC,+DAA+D;IAC/D,mDAAmD;IACnD,sEAAsE;IACtE,oEAAoE;IACpE,4DAA4D;IAC5D,wDAAwD;EDpF3C;AADJ;AAmeb;EAOE;IAKE,sBAAsB;IACtB,SAAS;IACT,UAAU;IACV,eAAe;EAJM;EAiBvB;IAEE,gBAAgB;IAChB,8BAA8B;IAC9B,WAAW;IACX,2JASC;IACD,mEAGC;IACD,uEAGC;IACD,wCAAwC;EAtBpC;EA+BN;IACE,SAAS;IACT,cAAc;IACd,qBAAqB;EAHpB;EAUH;IACE,yCAAyC;IACzC,iCAAiC;EAFf;EASpB;IAME,kBAAkB;IAClB,oBAAoB;EAFnB;EASH;IACE,cAAc;IACd,gCAAgC;IAChC,wBAAwB;EAHxB;EAUF;IAEE,mBAAmB;EADd;EAWP;IAIE,gJAUC;IACD,wEAGC;IACD,4EAGC;IACD,cAAc;EApBZ;EA2BJ;IACE,cAAc;EADV;EAQN;IAEE,cAAc;IACd,cAAc;IACd,kBAAkB;IAClB,wBAAwB;EAJtB;EAOJ;IACE,eAAe;EADb;EAIJ;IACE,WAAW;EADT;EAUJ;IACE,cAAc;IACd,qBAAqB;IACrB,yBAAyB;EAHrB;EAUN;IACE,aAAa;EADC;EAQhB;IACE,wBAAwB;EADjB;EAQT;IACE,kBAAkB;EADZ;EAQR;IAGE,gBAAgB;EADb;EAUL;IAQE,cAAc;IACd,sBAAsB;EAFjB;EASP;IAEE,eAAe;IACf,YAAY;EAFR;EAYN;IAME,aAAa;IACb,8BAA8B;IAC9B,gCAAgC;IAChC,uBAAuB;IACvB,cAAc;IACd,gBAAgB;IAChB,6BAA6B;IAC7B,UAAU;EARW;EAevB;IACE,mBAAmB;EAD0B;EAQ/C;IACE,0BAA0B;EAD0B;EAQtD;IACE,sBAAsB;EADD;EAQvB;IACE,UAAU;EADE;EASd;IAEE;MACE,mBAAyD;MAAzD;QAAA,yDAAyD;MAAA;IAD7C;EADiC;EAUjD;IACE,gBAAgB;EADT;EAQT;IACE,wBAAwB;EADE;EAS5B;IACE,eAAe;IACf,mBAAmB;EAFS;EAS9B;IACE,oBAAoB;EADE;EAQxB;IACE,UAAU;EAD2B;EAIvC;IASE,gBAAgB;EADqB;EAQvC;IACE,cAAc;EADoB;EAQpC;IACE,gBAAgB;EADD;EAQjB;IAGE,kBAAkB;EADG;EAQvB;IAEE,YAAY;EADc;EAQ5B;IACE,wBAAwB;EADmB;AAnZnC;AAwZZ;EACE;IAAA,2BAAmB;IAAnB,8BAAmB;EAAA;EAAnB;IAAA,2BAAmB;IAAnB,wBAAmB;EAAA;EAAnB;IAAA,2BAAmB;EAAA;EAAnB;IDnuBE,oBAAoB;ECmuBH;EAAnB;ID10BE,UAAU;IACV,oBAAoB;IAEpB;MAEI,UAAU;MACV,oBAAoB;IAFkC;ECs0BzC;EAAnB;IAAA,oBAAmB;EAAA;EAAnB;IAAA,oBAAmB;EAAA;EAAnB;IAAA,oBAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IDxvBS;MAAA,0BAAc;MAAd,kBAAc;IAAA;IAAC;MAAA,0BAAa;MAAb,+BAAa;IAAA;IAAC;MAAA,0BAAgB;MAAhB,+BAAgB;IAAA;IACpD,mBAAmB;IAMnB;MACI,mBAAmB;IADkB;IAIzC;MACI,iBAAiB;MACjB,sBAAsB;MACtB,oBAAoB;IAHD;EC6uBN;EAAnB;IAAA,kBAAmB;IAAnB,UAAmB;IAAnB,WAAmB;IAAnB,UAAmB;IAAnB,YAAmB;IAAnB,gBAAmB;IAAnB,qBAAmB;IAAnB,mBAAmB;IAAnB,eAAmB;EAAA;EAAnB;IDxzBE;MACI,kBAAkB;MAClB,UAAU;MACV,WAAW;MACX,UAAU;MACV,YAAY;MACZ,gBAAgB;MAChB,qBAAqB;MACrB,mBAAmB;MACnB,eAAe;IATsD;ECwzBxD;EAAnB;IAAA,0BAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,4CAAmB;EAAA;EAAnB;IAAA,4CAAmB;EAAA;EAAnB;IAAA,8CAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,4CAAmB;EAAA;EAAnB;IAAA,4CAAmB;EAAA;EAAnB;IAAA,4CAAmB;EAAA;EAAnB;IAAA,6CAAmB;EAAA;EAAnB;IAAA,2CAAmB;EAAA;EAAnB;IAAA,6CAAmB;EAAA;EAAnB;IAAA,2CAAmB;EAAA;EAAnB;IAAA,2CAAmB;EAAA;EAAnB;IAAA,4CAAmB;EAAA;EAAnB;IAAA,0CAAmB;EAAA;EAAnB;IAAA,4CAAmB;EAAA;EAAnB;IAAA,0CAAmB;EAAA;EAAnB;IAAA,4CAAmB;EAAA;EAAnB;IAAA,0CAAmB;EAAA;EAAnB;IAAA,0CAAmB;EAAA;EAAnB;IAAA,0CAAmB;EAAA;EAAnB;IAAA,0CAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,gEAAmB;EAAA;EAAnB;IAAA,kEAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,kCAAmB;EAAA;EAAnB;IAAA,SAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,kCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,wBAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,iDAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,sBAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,UAAmB;EAAA;EAAnB;IAAA,UAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,UAAmB;EAAA;EAAnB;IAAA,UAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,oBAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,WAAmB;IAAnB;MAAA,gBAAmB;IAAA;IAAnB;MAAA,gBAAmB;IAAA;IAAnB;MAAA,gBAAmB;IAAA;IAAnB;MAAA,gBAAmB;IAAA;IAAnB;MAAA,gBAAmB;IAAA;IAAnB;MAAA,gBAAmB;IAAA;IAAnB;MAAA,gBAAmB;IAAA;IAAnB;MAAA,gBAAmB;IAAA;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,kCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,8CAAmB;EAAA;EAAnB;IAAA,8CAAmB;EAAA;EAAnB;IAAA,8CAAmB;EAAA;EAAnB;IAAA,+CAAmB;EAAA;EAAnB;IAAA,6CAAmB;EAAA;EAAnB;IAAA,+CAAmB;EAAA;EAAnB;IAAA,6CAAmB;EAAA;EAAnB;IAAA,6CAAmB;EAAA;EAAnB;IAAA,6CAAmB;EAAA;EAAnB;IAAA,6CAAmB;EAAA;EAAnB;IAAA,6CAAmB;EAAA;EAAnB;IAAA,6CAAmB;EAAA;EAAnB;IAAA,6CAAmB;EAAA;EAAnB;IAAA,8CAAmB;EAAA;EAAnB;IAAA,8CAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,sDAAmB;EAAA;EAAnB;IAAA,4CAAmB;EAAA;EAAnB;IAAA,8CAAmB;EAAA;EAAnB;IAAA,4CAAmB;EAAA;EAAnB;IAAA,2CAAmB;EAAA;EAAnB;IAAA,2CAAmB;EAAA;EAAnB;IAAA,6CAAmB;EAAA;EAAnB;IAAA,2CAAmB;EAAA;EAAnB;IAAA,2CAAmB;EAAA;EAAnB;IAAA,8CAAmB;EAAA;EAAnB;IAAA,2CAAmB;EAAA;EAAnB;IAAA,2CAAmB;EAAA;EAAnB;IAAA,2CAAmB;EAAA;EAAnB;IAAA,uBAAmB;EAAA;EAAnB;IAAA,sBAAmB;EAAA;EAAnB;IAAA,gDAAmB;EAAA;EAAnB;IAAA,gDAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,sBAAmB;EAAA;EAAnB;IAAA,uBAAmB;EAAA;EAAnB;IAAA,gBAAmB;IAAnB,UAAmB;IAAnB,yBAAmB;IAAnB,qBAAmB;IAAnB,sBAAmB;IAAnB,6BAAmB;IAAnB,iBAAmB;IAAnB,cAAmB;IAAnB,YAAmB;IAAnB,WAAmB;IAAnB,iCAAmB;IAAnB,sBAAmB;IAAnB,mCAAmB;IAAnB,iBAAmB;IAAnB,sBAAmB;IAAnB,mBAAmB;IAAnB;MAAA,8BAAmB;MAAnB,mBAAmB;MAAnB,4CAAmB;MAAnB,2BAAmB;MAAnB,4BAAmB;MAAnB,2CAAmB;MAAnB,2GAAmB;MAAnB,yGAAmB;MAAnB,iFAAmB;IAAA;IAAnB;MAAA,yBAAmB;MAAnB,8BAAmB;MAAnB,0BAAmB;MAAnB,2BAAmB;MAAnB,4BAAmB;IAAA;IAAnB;MAAA,yDAAmB;MAAnB;QAAA,gBAAmB;MAAA;IAAA;IAAnB;MAAA,yBAAmB;MAAnB,8BAAmB;IAAA;IAAnB;MAAA,yBAAmB;MAAnB,8BAAmB;IAAA;EAAA;EAAnB;IAAA,gBAAmB;IAAnB,sBAAmB;IAAnB,mCAAmB;IAAnB,iBAAmB;IAAnB,kBAAmB;IAAnB,mBAAmB;IAAnB,sBAAmB;IAAnB,sBAAmB;IAAnB,qBAAmB;IAAnB,eAAmB;IAAnB,mBAAmB;IAAnB,sBAAmB;IAAnB;MAAA,8BAAmB;MAAnB,mBAAmB;MAAnB,4CAAmB;MAAnB,2BAAmB;MAAnB,4BAAmB;MAAnB,2CAAmB;MAAnB,2GAAmB;MAAnB,yGAAmB;MAAnB,iFAAmB;MAAnB,wCAAmB;IAAA;IAAnB;MAAA,4BAAmB;MAAnB,UAAmB;IAAA;IAAnB;MAAA,UAAmB;IAAA;IAAnB;MAAA,iBAAmB;IAAA;IAAnB;MAAA,mBAAmB;IAAA;IAAnB;MAAA,oBAAmB;IAAA;IAAnB;MAAA,cAAmB;MAAnB,iBAAmB;IAAA;IAAnB;MAAA,cAAmB;MAAnB,iBAAmB;IAAA;IAAnB;MAAA,cAAmB;MAAnB,iBAAmB;IAAA;IAAnB;MAAA,cAAmB;MAAnB,iBAAmB;IAAA;IAAnB;MAAA,cAAmB;MAAnB,iBAAmB;IAAA;IAAnB;MAAA,cAAmB;MAAnB,iBAAmB;IAAA;IAAnB;MAAA,cAAmB;MAAnB,iBAAmB;IAAA;IAAnB;MAAA,cAAmB;MAAnB,iBAAmB;IAAA;IAAnB;MAAA,cAAmB;MAAnB,iBAAmB;IAAA;EAAA;EAAnB;IAAA,gBAAmB;IAAnB,oBAAmB;IAAnB,4BAAmB;IAAnB,qBAAmB;EAAA;EAAnB;IAAA,gBAAmB;IAAnB,oBAAmB;IAAnB,4BAAmB;IAAnB,qBAAmB;EAAA;EAAnB;IAAA,gBAAmB;IAAnB,oBAAmB;IAAnB,4BAAmB;IAAnB,qBAAmB;EAAA;EAAnB;IAAA,gBAAmB;IAAnB,oBAAmB;IAAnB,4BAAmB;IAAnB,qBAAmB;EAAA;EAAnB;IAAA,wBAAmB;EAAA;EAAnB;IAAA,wBAAmB;EAAA;EAAnB;IAAA,0BAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,oBAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;ID3tBE,qEAAqE;IACrE,sCAAsC;IACtC,uCAAuC;IAEvC,wDAAwD;ECutBvC;EAAnB;IAAA,0CAAmB;IAAnB,2CAAmB;EAAA;EAAnB;IAAA,sBAAmB;IAAnB,uBAAmB;EAAA;EAAnB;IAAA,+BAAmB;IAAnB,gCAAmB;EAAA;EAAnB;IAAA,iCAAmB;IAAnB,kCAAmB;EAAA;EAAnB;IAAA,+BAAmB;IAAnB,gCAAmB;EAAA;EAAnB;IAAA,iCAAmB;IAAnB,kCAAmB;EAAA;EAAnB;IAAA,+BAAmB;IAAnB,gCAAmB;EAAA;EAAnB;IAAA,+BAAmB;IAAnB,gCAAmB;EAAA;EAAnB;IAAA,iCAAmB;IAAnB,kCAAmB;EAAA;EAAnB;IAAA,+BAAmB;IAAnB,gCAAmB;EAAA;EAAnB;IAAA,+BAAmB;IAAnB,gCAAmB;EAAA;EAAnB;IAAA,+BAAmB;IAAnB,gCAAmB;EAAA;EAAnB;IAAA,+BAAmB;IAAnB,gCAAmB;EAAA;EAAnB;IAAA,0CAAmB;IAAnB,2CAAmB;EAAA;EAAnB;IAAA,+BAAmB;IAAnB,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;IAAnB,iCAAmB;EAAA;EAAnB;IAAA,2CAAmB;IAAnB,4CAAmB;EAAA;EAAnB;IAAA,gCAAmB;IAAnB,iCAAmB;EAAA;EAAnB;IAAA,gCAAmB;IAAnB,iCAAmB;EAAA;EAAnB;IAAA,gCAAmB;IAAnB,iCAAmB;EAAA;EAAnB;IAAA,gCAAmB;IAAnB,iCAAmB;EAAA;EAAnB;IAAA,gCAAmB;IAAnB,iCAAmB;EAAA;EAAnB;IAAA,WAAmB;IAAnB,YAAmB;EAAA;EAAnB;IAAA,sBAAmB;IAAnB,uBAAmB;EAAA;EAAnB;IAAA,WAAmB;IAAnB,YAAmB;EAAA;EAAnB;IAAA,2CAAmB;EAAA;EAAnB;IAAA,4CAAmB;EAAA;EAAnB;IAAA,4CAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,kCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,kCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,kCAAmB;EAAA;EAAnB;IAAA,wBAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,kCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA,0BAAmB;EAAA;EAAnB;IAAA,0BAAmB;EAAA;EAAnB;IAAA,mFAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA,gDAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,0CAAmB;EAAA;EAAnB;IAAA,0CAAmB;EAAA;EAAnB;IAAA,2CAAmB;EAAA;EAAnB;IAAA,uBAAmB;EAAA;EAAnB;IAAA,sBAAmB;EAAA;EAAnB;IAAA,0BAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,uBAAmB;EAAA;EAAnB;IAAA,uBAAmB;EAAA;EAAnB;IAAA,2BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,uBAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,uBAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,uBAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,wBAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,wBAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,UAAmB;EAAA;EAAnB;IAAA,UAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,UAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,2BAAmB;EAAA;EAAnB;IAAA,2BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,2BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,yDAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,sBAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,8CAAmB;EAAA;EAAnB;IAAA,8CAAmB;EAAA;EAAnB;IAAA,0BAAmB;EAAA;EAAnB;IAAA,0BAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,2BAAmB;EAAA;EAAnB;IAAA,2BAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,sBAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,sBAAmB;EAAA;EAAnB;IAAA,OAAmB;EAAA;EAAnB;IAAA,OAAmB;EAAA;EAAnB;IAAA,OAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,UAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,6CAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,2BAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,wBAAmB;EAAA;EAAnB;IAAA,0CAAmB;IAAnB,0CAAmB;IAAnB,sDAAmB;EAAA;EAAnB;IAAA,6CAAmB;IAAnB,sDAAmB;EAAA;EAAnB;IAAA,2CAAmB;IAAnB,sDAAmB;EAAA;EAAnB;IAAA,6CAAmB;IAAnB,sDAAmB;EAAA;EAAnB;IAAA,uBAAmB;IAAnB,sDAAmB;EAAA;EAAnB;IAAA,0CAAmB;IAAnB,sDAAmB;EAAA;EAAnB;IAAA,0CAAmB;IAAnB,sDAAmB;EAAA;EAAnB;IAAA,kCAAmB;IAAnB,sDAAmB;EAAA;EAAnB;IAAA,0CAAmB;IAAnB,sDAAmB;EAAA;EAAnB;IAAA,iBAAmB;IAAnB,iBAAmB;IAAnB,iBAAmB;IAAnB,0CAAmB;EAAA;EAAnB;IAAA,kBAAmB;IAAnB,kBAAmB;IAAnB,kBAAmB;IAAnB,0CAAmB;EAAA;EAAnB;IAAA,6BAAmB;IAAnB,0CAAmB;EAAA;EAAnB;IAAA,gBAAmB;IAAnB,0CAAmB;EAAA;EAAnB;IAAA,iBAAmB;IAAnB,0CAAmB;EAAA;EAAnB;IAAA,UAAmB;EAAA;EAAnB;IAAA,UAAmB;EAAA;EAAnB;IAAA,wBAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,0GAAmB;EAAA;EAAnB;ID3sBE;MACI,oBAAoB;MACpB,mBAAmB;MAEnB;QACI,mCAAmC;QACnC,gBAAgB;QAChB,qBAAqB;QACrB,mBAAmB;QACnB,gDAAgD;QAChD,uCAAuC;QAEvC;UACI,kCAAkC;QAD3B;MARH;IAJa;EC2sBZ;EAAnB;ID5pBE;MACI,WAAW;MACX,kCAAkC;IAF7B;EC4pBQ;EAAnB;IAAA,kCAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,gDAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,2CAAmB;EAAA;EAAnB;IAAA,kCAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,gDAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,4CAAmB;EAAA;EAAnB;IAAA,wBAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,gDAAmB;EAAA;EAAnB;IAAA,gDAAmB;EAAA;EAAnB;IAAA,gDAAmB;EAAA;EAAnB;IAAA,gDAAmB;EAAA;EAAnB;IAAA,gDAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,uBAAmB;EAAA;EAAnB;IAAA,uBAAmB;EAAA;EAAnB;IAAA,sBAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,2BAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,uBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,sBAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,uBAAmB;EAAA;EAAnB;IAAA,oBAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,uBAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,2BAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,oBAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,QAAmB;EAAA;EAAnB;IAAA;MAAA,uBAAmB;MAAnB,8EAAmB;MAAnB,sFAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,uBAAmB;MAAnB,8EAAmB;MAAnB,sFAAmB;IAAA;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA;MAAA,wBAAmB;MAAnB,2CAAmB;MAAnB,wCAAmB;MAAnB,wDAAmB;MAAnB,qEAAmB;IAAA;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,oBAAmB;EAAA;EAAnB;IAAA,sBAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,gBAAmB;IAAnB,uBAAmB;IAAnB,mBAAmB;EAAA;EAAnB;IAAA,2BAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,0CAAmB;EAAA;EAAnB;IAAA,0CAAmB;EAAA;EAAnB;IAAA,sBAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,4BAAmB;IAAnB,0BAAmB;EAAA;EAAnB;IAAA,2CAAmB;IAAnB,yCAAmB;EAAA;EAAnB;IAAA,2CAAmB;EAAA;EAAnB;IAAA,yCAAmB;IAAnB,uCAAmB;EAAA;EAAnB;IAAA,0BAAmB;IAAnB,wBAAmB;EAAA;EAAnB;IAAA,yCAAmB;IAAnB,uCAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,4BAAmB;IAAnB,6BAAmB;EAAA;EAAnB;IAAA,yBAAmB;IAAnB,0BAAmB;EAAA;EAAnB;IAAA,wCAAmB;IAAnB,yCAAmB;EAAA;EAAnB;IAAA,gCAAmB;IAAnB,+BAAmB;EAAA;EAAnB;IAAA,4CAAmB;IAAnB,2CAAmB;EAAA;EAAnB;IAAA,6BAAmB;IAAnB,4BAAmB;EAAA;EAAnB;IAAA,4CAAmB;IAAnB,2CAAmB;EAAA;EAAnB;IAAA,oCAAmB;IAAnB,iBAAmB;EAAA;EAAnB;IAAA,oCAAmB;IAAnB,iBAAmB;EAAA;EAAnB;IAAA,oCAAmB;IAAnB,iBAAmB;EAAA;EAAnB;IAAA,oCAAmB;IAAnB,iBAAmB;EAAA;EAAnB;IAAA,oCAAmB;IAAnB,iBAAmB;EAAA;EAAnB;IAAA,oCAAmB;IAAnB,mBAAmB;EAAA;EAAnB;IAAA,iDAAmB;IAAnB,8BAAmB;EAAA;EAAnB;IAAA,iDAAmB;IAAnB,8BAAmB;EAAA;EAAnB;IAAA,+CAAmB;IAAnB,4BAAmB;EAAA;EAAnB;IAAA,wCAAmB;IAAnB,qBAAmB;EAAA;EAAnB;IAAA,2CAAmB;IAAnB,wBAAmB;EAAA;EAAnB;IAAA,yBAAmB;IAAnB,oBAAmB;EAAA;EAAnB;IAAA,uBAAmB;IAAnB,kBAAmB;EAAA;EAAnB;IAAA,wBAAmB;IAAnB,mBAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,0BAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;IAAnB;MAAA,sEAAmB;IAAA;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,kDAAmB;EAAA;EAAnB;IAAA,kDAAmB;EAAA;EAAnB;IAAA,kDAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,gFAAmB;IAAnB;MAAA,8EAAmB;IAAA;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,oCAAmB;IAAnB;MAAA,yEAAmB;IAAA;EAAA;EAAnB;IAAA,oCAAmB;IAAnB;MAAA,0EAAmB;IAAA;EAAA;EAAnB;IAAA,oCAAmB;IAAnB;MAAA,0EAAmB;IAAA;EAAA;EAAnB;IAAA,oCAAmB;IAAnB;MAAA,0EAAmB;IAAA;EAAA;EAAnB;IAAA,oCAAmB;IAAnB;MAAA,0EAAmB;IAAA;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;IAAnB;MAAA,6EAAmB;IAAA;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;IAAnB;MAAA,6EAAmB;IAAA;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;IAAnB;MAAA,6EAAmB;IAAA;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;IAAnB;MAAA,6EAAmB;IAAA;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;IAAnB;MAAA,6EAAmB;IAAA;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;IAAnB;MAAA,6EAAmB;IAAA;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;IAAnB;MAAA,6EAAmB;IAAA;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;IAAnB;MAAA,6EAAmB;IAAA;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;IAAnB;MAAA,6EAAmB;IAAA;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,kDAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,kDAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;IAAnB;MAAA,6EAAmB;IAAA;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;IAAnB;MAAA,6EAAmB;IAAA;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;IAAnB;MAAA,6EAAmB;IAAA;EAAA;EAAnB;IAAA,uCAAmB;IAAnB;MAAA,6EAAmB;IAAA;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;IAAnB;MAAA,6EAAmB;IAAA;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,oCAAmB;IAAnB;MAAA,0EAAmB;IAAA;EAAA;EAAnB;IAAA,oCAAmB;IAAnB;MAAA,0EAAmB;IAAA;EAAA;EAAnB;IAAA,oCAAmB;IAAnB;MAAA,0EAAmB;IAAA;EAAA;EAAnB;IAAA,oCAAmB;IAAnB;MAAA,0EAAmB;IAAA;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,0CAAmB;EAAA;EAAnB;IAAA,6CAAmB;EAAA;EAAnB;IAAA,6CAAmB;EAAA;EAAnB;IAAA,4CAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,4CAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,kCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,kCAAmB;IAAnB;MAAA,wEAAmB;IAAA;EAAA;EAAnB;IAAA,kCAAmB;IAAnB;MAAA,wEAAmB;IAAA;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,oCAAmB;IAAnB;MAAA,yEAAmB;IAAA;EAAA;EAAnB;IAAA,oCAAmB;IAAnB;MAAA,0EAAmB;IAAA;EAAA;EAAnB;IAAA,oCAAmB;IAAnB;MAAA,0EAAmB;IAAA;EAAA;EAAnB;IAAA,oCAAmB;IAAnB;MAAA,0EAAmB;IAAA;EAAA;EAAnB;IAAA,oCAAmB;IAAnB;MAAA,0EAAmB;IAAA;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,qCAAmB;IAAnB;MAAA,2EAAmB;IAAA;EAAA;EAAnB;IAAA,qCAAmB;IAAnB;MAAA,2EAAmB;IAAA;EAAA;EAAnB;IAAA,qCAAmB;IAAnB;MAAA,2EAAmB;IAAA;EAAA;EAAnB;IAAA,4GAAmB;EAAA;EAAnB;IAAA,sBAAmB;EAAA;EAAnB;IDt3BE,yFAGC;ECm3BgB;EAAnB;IDt3BE,2FAGC;ECm3BgB;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,sBAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,2BAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,2BAAmB;EAAA;EAAnB;IAAA,2BAAmB;EAAA;EAAnB;IAAA,2BAAmB;EAAA;EAAnB;IAAA,2BAAmB;EAAA;EAAnB;IAAA,2BAAmB;EAAA;EAAnB;IAAA,wBAAmB;EAAA;EAAnB;IAAA,wBAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,4CAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,4CAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,0CAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,0CAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,2CAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,oBAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,8CAAmB;EAAA;EAAnB;IAAA,gDAAmB;EAAA;EAAnB;IAAA,8CAAmB;EAAA;EAAnB;IAAA,8CAAmB;EAAA;EAAnB;IAAA,8CAAmB;EAAA;EAAnB;IAAA,8CAAmB;EAAA;EAAnB;IAAA,8CAAmB;EAAA;EAAnB;IAAA,8CAAmB;EAAA;EAAnB;IAAA,+CAAmB;EAAA;EAAnB;IAAA,+CAAmB;EAAA;EAAnB;IAAA,+CAAmB;EAAA;EAAnB;IAAA,4CAAmB;EAAA;EAAnB;IAAA,+CAAmB;EAAA;EAAnB;IAAA,4CAAmB;EAAA;EAAnB;IAAA,8CAAmB;EAAA;EAAnB;IAAA,4CAAmB;EAAA;EAAnB;IAAA,4CAAmB;EAAA;EAAnB;IAAA,4CAAmB;EAAA;EAAnB;IAAA,4CAAmB;EAAA;EAAnB;IAAA,4CAAmB;EAAA;EAAnB;IAAA,4CAAmB;EAAA;EAAnB;IAAA,6CAAmB;EAAA;EAAnB;IAAA,6CAAmB;EAAA;EAAnB;IAAA,6CAAmB;EAAA;EAAnB;IAAA,6CAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,0CAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,0CAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,sBAAmB;EAAA;EAAnB;IAAA,sBAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,oCAAmB;IAAnB,sEAAmB;EAAA;EAAnB;IAAA,0BAAmB;IAAnB,4DAAmB;EAAA;EAAnB;IAAA,0BAAmB;IAAnB,qCAAmB;EAAA;EAAnB;IAAA,0BAAmB;IAAnB,qCAAmB;EAAA;EAAnB;IAAA,0BAAmB;IAAnB,sCAAmB;EAAA;EAAnB;IAAA,0BAAmB;IAAnB,4DAAmB;EAAA;EAAnB;IAAA,2BAAmB;IAAnB,6DAAmB;EAAA;EAAnB;IAAA,2BAAmB;IAAnB,qCAAmB;EAAA;EAAnB;IAAA,2BAAmB;IAAnB,qCAAmB;EAAA;EAAnB;IAAA,2BAAmB;IAAnB,qCAAmB;EAAA;EAAnB;IAAA,yBAAmB;IAAnB,2DAAmB;EAAA;EAAnB;IAAA,yBAAmB;IAAnB,2DAAmB;EAAA;EAAnB;IAAA,yBAAmB;IAAnB,qCAAmB;EAAA;EAAnB;IAAA,yBAAmB;IAAnB,qCAAmB;EAAA;EAAnB;IAAA,yBAAmB;IAAnB,qCAAmB;EAAA;EAAnB;IAAA,yBAAmB;IAAnB,qCAAmB;EAAA;EAAnB;IAAA,yBAAmB;IAAnB,cAAmB;EAAA;EAAnB;IAAA,yBAAmB;IAAnB,2DAAmB;EAAA;EAAnB;IAAA,yBAAmB;IAAnB,qCAAmB;EAAA;EAAnB;IAAA,yBAAmB;IAAnB,2DAAmB;EAAA;EAAnB;IAAA,yBAAmB;IAAnB,qCAAmB;EAAA;EAAnB;IAAA,yBAAmB;IAAnB,qCAAmB;EAAA;EAAnB;IAAA,yBAAmB;IAAnB,qCAAmB;EAAA;EAAnB;IAAA,yBAAmB;IAAnB,qCAAmB;EAAA;EAAnB;IAAA,0BAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,sCAAmB;IAAnB,qCAAmB;EAAA;EAAnB;IAAA,sCAAmB;IAAnB,qCAAmB;EAAA;EAAnB;IAAA,sCAAmB;IAAnB,qCAAmB;EAAA;EAAnB;IAAA,sCAAmB;IAAnB,qCAAmB;EAAA;EAAnB;IAAA,eAAmB;IAAnB,cAAmB;EAAA;EAAnB;IAAA,mCAAmB;IAAnB,kCAAmB;EAAA;EAAnB;IAAA,oCAAmB;IAAnB,mCAAmB;EAAA;EAAnB;IAAA,sDAAmB;IAAnB,iDAAmB;EAAA;EAAnB;IAAA,yCAAmB;IAAnB,oCAAmB;EAAA;EAAnB;IAAA,0CAAmB;IAAnB,qCAAmB;EAAA;EAAnB;IAAA,2CAAmB;IAAnB,sCAAmB;EAAA;EAAnB;IAAA,2CAAmB;IAAnB,sCAAmB;EAAA;EAAnB;IAAA,6CAAmB;IAAnB,wCAAmB;EAAA;EAAnB;IAAA,yCAAmB;IAAnB,oCAAmB;EAAA;EAAnB;IAAA,qCAAmB;IAAnB,sCAAmB;EAAA;EAAnB;IAAA,oCAAmB;IAAnB,qCAAmB;EAAA;EAAnB;IAAA,mCAAmB;IAAnB,oCAAmB;EAAA;EAAnB;IAAA,oCAAmB;IAAnB,qCAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,uBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,uBAAmB;EAAA;EAAnB;IAAA,qBAAmB;IAAnB,aAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,2BAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,wBAAmB;EAAA;EAAnB;IAAA,wBAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,kCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,uBAAmB;EAAA;EAAnB;IAAA,2BAAmB;EAAA;EAAnB;IAAA,2BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,0BAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,0BAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,kCAAmB;IAAnB,iJAAmB;EAAA;EAAnB;IAAA,0BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,mCAAmB;IAAnB,kCAAmB;EAAA;EAAnB;IAAA,kCAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA,iEAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,wEAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,sEAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,yIAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,0HAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,0EAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,uEAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,mIAAmB;IAAnB,iJAAmB;EAAA;EAAnB;IAAA,wHAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,wHAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,wHAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,wHAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,wHAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,wHAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,yHAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,qCAAmB;IAAnB;MAAA,mIAAmB;IAAA;EAAA;EAAnB;IAAA,mCAAmB;IAAnB;MAAA,wEAAmB;IAAA;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,kCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IDxxBE,uCAAuC;IAEvC;MACI,eAAe;MACf,mBAAmB;IAFO;ECsxBb;EAAnB;ID3wBE,uCAAuC;IAEvC;MACI,eAAe;MACf,oBAAoB;IAFM;ECywBb;EAAnB;IAAA,wBAAmB;IAAnB,mBAAmB;IAAnB;MAAA,8BAAmB;MAAnB,mBAAmB;IAAA;EAAA;EAAnB;IAAA,sCAAmB;IAAnB,kBAAmB;EAAA;EAAnB;IAAA,sCAAmB;IAAnB,kBAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,oBAAmB;IAAnB,0LAAmB;EAAA;EAAnB;IAAA,yBAAmB;IAAnB,0LAAmB;EAAA;EAAnB;IAAA,0LAAmB;EAAA;EAAnB;IAAA,wCAAmB;IAAnB,wRAAmB;IAAnB,gRAAmB;EAAA;EAAnB;IDx1BE,iDAAiD;IACjD,0BAA0B;IAC1B,oCAAoC;ECs1BnB;EAAnB;IAAA,yUAAmB;IAAnB,qFAAmB;IAAnB,2EAAmB;EAAA;EAAnB;IAAA,wBAAmB;IAAnB,qFAAmB;IAAnB,2EAAmB;EAAA;EAAnB;IAAA,uKAAmB;IAAnB,qFAAmB;IAAnB,2EAAmB;EAAA;EAAnB;IAAA,4BAAmB;IAAnB,qFAAmB;IAAnB,2EAAmB;EAAA;EAAnB;IAAA,+BAAmB;IAAnB,qFAAmB;IAAnB,2EAAmB;EAAA;EAAnB;IAAA,sBAAmB;EAAA;EAAnB;IAAA,oBAAmB;IAAnB,0BAAmB;EAAA;EAAnB;IAAA,oBAAmB;IAAnB,0BAAmB;EAAA;EAAnB;IAAA,oBAAmB;IAAnB,0BAAmB;EAAA;EAAnB;IAAA,oBAAmB;IAAnB,0BAAmB;EAAA;EAAnB;IAAA,yBAAmB;IAAnB,0CAAmB;EAAA;EAAnB;IAAA,6BAAmB;IAAnB,8CAAmB;EAAA;EAAnB;IAAA,0BAAmB;IAAnB,2CAAmB;EAAA;EAAnB;IAAA,wBAAmB;IAAnB,mBAAmB;EAAA;EAAnB;IAAA,yBAAmB;IAAnB,iBAAmB;EAAA;EAAnB;IAAA,0BAAmB;EAAA;EAAnB;IAAA,sBAAmB;EAAA;EAAnB;IDx2BE,wBAAwB;ECw2BP;EAAnB;IDj2BE,mCAAmC;ECi2BlB;EAAnB;IAAA;MAAA,2CAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,wBAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,aAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,aAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,kBAAmB;QAAnB,kBAAmB;QAAnB,kBAAmB;QAAnB,0CAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,uCAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,uCAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,oCAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,4BAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,4BAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,4BAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,wBAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,wBAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,yBAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,aAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,cAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,aAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,mBAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,yCAAmB;QAAnB,oCAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA,uCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,cAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,aAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,yBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,gBAAmB;MAAnB,uBAAmB;MAAnB,mBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,4BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,4BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,oCAAmB;MAAnB;QAAA,0EAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA,2CAAmB;MAAnB,yCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,wCAAmB;MAAnB,yCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,uCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,yCAAmB;MAAnB,uCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,4CAAmB;MAAnB,2CAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,uCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,gCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,iCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,gCAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,+BAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,eAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,eAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,sBAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,+BAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,mCAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,+BAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,kDAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,kDAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,kDAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,yBAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,oCAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,oCAAmB;QAAnB;UAAA,0EAAmB;QAAA;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,oCAAmB;QAAnB;UAAA,0EAAmB;QAAA;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,sCAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,uCAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,uCAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,uCAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,uCAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,uCAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,uCAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,uCAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,uCAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,oCAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,oCAAmB;QAAnB;UAAA,0EAAmB;QAAA;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,mCAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,kCAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,6BAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,oCAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,oCAAmB;QAAnB;UAAA,0EAAmB;QAAA;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,oCAAmB;QAAnB;UAAA,0EAAmB;QAAA;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,iCAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QD/2BE,kHAGC;MC42BgB;IAAA;EAAA;EAAnB;IAAA;MAAA;QD/2BE,uGAGC;MC42BgB;IAAA;EAAA;EAAnB;IAAA;MAAA;QDt3BE,yFAGC;MCm3BgB;IAAA;EAAA;EAAnB;IAAA;MAAA;QDt3BE,yFAGC;MCm3BgB;IAAA;EAAA;EAAnB;IAAA;MAAA;QDt3BE,yFAGC;MCm3BgB;IAAA;EAAA;EAAnB;IAAA;MAAA;QDt3BE,2FAGC;MCm3BgB;IAAA;EAAA;EAAnB;IAAA;MAAA;QDt3BE,2FAGC;MCm3BgB;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,6BAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,4BAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,4BAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,4BAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,4BAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,4BAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,4BAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,wBAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,wBAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,yBAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,+BAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,YAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,YAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,YAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,aAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,mEAAmB;QAAnB,sIAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,wEAAmB;QAAnB,sIAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,sEAAmB;QAAnB,sIAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,yIAAmB;QAAnB,sIAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,wHAAmB;QAAnB,sIAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,mCAAmB;QAAnB;UAAA,yEAAmB;QAAA;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,mCAAmB;QAAnB;UAAA,yEAAmB;QAAA;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,gCAAmB;QAAnB,0LAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA;UDt3BE,2FAGC;QCm3BgB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA;UAAA,4BAAmB;QAAA;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA,oCAAmB;MAAnB,iBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,yBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,uCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,aAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,wHAAmB;MAAnB,sIAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,2BAAmB;MAAnB,4GAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,wBAAmB;MAAnB,mBAAmB;MAAnB;QAAA,8BAAmB;QAAnB,mBAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA,sCAAmB;MAAnB,kBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,wBAAmB;MAAnB,mBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,WAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,aAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,gBAAmB;IAAA;EAAA;EAAnB;IAAA;MDt3BE,2FAGC;ICm3BgB;EAAA;EAAnB;IAAA;MAAA,eAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,oBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,mBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,wCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,uCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,uCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,uCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,4BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,4BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,YAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,YAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,sCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA;UAAA,6BAAmB;QAAA;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA,uCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,eAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA;UAAA,wBAAmB;QAAA;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA,YAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,mBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,4BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA;UAAA,iCAAmB;UAAnB,0LAAmB;QAAA;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA,mCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,yBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,mBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,oCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,gBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,gDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,kBAAmB;IAAA;EAAA;EAAnB;IAAA;MDxzBE;QACI,kBAAkB;QAClB,UAAU;QACV,WAAW;QACX,UAAU;QACV,YAAY;QACZ,gBAAgB;QAChB,qBAAqB;QACrB,mBAAmB;QACnB,eAAe;MATsD;ICwzBxD;EAAA;EAAnB;IAAA;MAAA,iBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,YAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,cAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,qCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,gBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,gBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,0CAAmB;MAAnB,sDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,iBAAmB;MAAnB,iBAAmB;MAAnB,iBAAmB;MAAnB,0CAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,kBAAmB;MAAnB,kBAAmB;MAAnB,kBAAmB;MAAnB,0CAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,gDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,mBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,mBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,oCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,oCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,oCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,iCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,iCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,uCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,sCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA;UAAA,wBAAmB;QAAA;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA,6CAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,aAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,oBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,kBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,gCAAmB;MAAnB,iCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,aAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,iBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,8BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,YAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,gDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,gDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,mBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,8BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,gCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,iDAAmB;MAAnB,8BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,wCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,yCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,yCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,wCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,wCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,4CAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,cAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,gDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,mBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,mBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,yBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,2BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,gBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,aAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,aAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,aAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,oBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,WAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,0CAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,YAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,gBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,wBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,WAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,aAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,eAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,mCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,iCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,wCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,uCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,mBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,cAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,aAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,sBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,WAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,mBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,mBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,qBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,0CAAmB;MAAnB,sDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,6BAAmB;MAAnB,0CAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,gBAAmB;MAAnB,0CAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,wCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,eAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,uBAAmB;MAAnB,kBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,mCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,mCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,mCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,gCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,kDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,kDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,+CAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,yBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,yBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,yBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,uCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,kDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,uCAAmB;MAAnB;QAAA,6EAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA,uCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,uCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,uCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,uCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,uCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,uCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,wCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,wCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,yCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,oCAAmB;IAAA;EAAA;EAAnB;IAAA;MDt3BE,2FAGC;ICm3BgB;EAAA;EAAnB;IAAA;MAAA,iCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,oCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,cAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,yBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,4BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,4BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,4BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,4BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,4BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,4BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,yBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,+BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,wEAAmB;MAAnB,sIAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,4BAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA;UAAA,uCAAmB;QAAA;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA;UAAA,uCAAmB;QAAA;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA;UAAA,uCAAmB;QAAA;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA;UD/2BE,uGAGC;QC42BgB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA;UAAA,uCAAmB;QAAA;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA;UAAA,4BAAmB;QAAA;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QD/2BE,uGAGC;MC42BgB;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,4BAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,uCAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA,sCAAmB;MAAnB,kBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,sCAAmB;MAAnB,kBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,aAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,aAAmB;IAAA;EAAA;EAAnB;ID9oBE;MC8oBF,+BAAmB;ID7oBf;EC6oBe;EAAnB;ID9oBE;MC8oBF,uCAAmB;ID7oBf;EC6oBe;EAAnB;IDvoBE;MCuoBF,2CAAmB;MAAnB,yCAAmB;IDtoBI;ECsoBJ;EAAnB;IDvoBE;MCuoBF,mCAAmB;IDtoBI;ECsoBJ;EAAnB;IAAA;MAAA,4BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,+BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,6CAAmB;MAAnB,wCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,sCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,yCAAmB;MAAnB,sBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,mCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,8CAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,oBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,+BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,mCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,yCAAmB;MAAnB,oCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,+BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA;UDt3BE,2FAGC;QCm3BgB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA,sCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,sCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,sCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,uCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,sCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,wBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,8CAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,sCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,sCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,uCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,2CAAmB;MAAnB,sCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,6CAAmB;MAAnB,wCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,WAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,mBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,sCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,qBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,8CAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,sCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,+BAAmB;MAAnB,gCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,oCAAmB;MAAnB,iBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,6BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,aAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,+BAAmB;MAAnB,gCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,gBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,6BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,iCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,kCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,iCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,iCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,wCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,4CAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,0CAAmB;MAAnB,2CAAmB;IAAA;EAAA;AADJ;AA73BjB,yCAAyC;AAEzC,YAAa;AAmeb;EAOE;IAKE,sBAAsB;IACtB,SAAS;IACT,UAAU;IACV,eAAe;EAJM;EAiBvB;IAEE,gBAAgB;IAChB,8BAA8B;IAC9B,WAAW;IACX,2JASC;IACD,mEAGC;IACD,uEAGC;IACD,wCAAwC;EAtBpC;EA+BN;IACE,SAAS;IACT,cAAc;IACd,qBAAqB;EAHpB;EAUH;IACE,yCAAyC;IACzC,iCAAiC;EAFf;EASpB;IAME,kBAAkB;IAClB,oBAAoB;EAFnB;EASH;IACE,cAAc;IACd,gCAAgC;IAChC,wBAAwB;EAHxB;EAUF;IAEE,mBAAmB;EADd;EAWP;IAIE,gJAUC;IACD,wEAGC;IACD,4EAGC;IACD,cAAc;EApBZ;EA2BJ;IACE,cAAc;EADV;EAQN;IAEE,cAAc;IACd,cAAc;IACd,kBAAkB;IAClB,wBAAwB;EAJtB;EAOJ;IACE,eAAe;EADb;EAIJ;IACE,WAAW;EADT;EAUJ;IACE,cAAc;IACd,qBAAqB;IACrB,yBAAyB;EAHrB;EAUN;IACE,aAAa;EADC;EAQhB;IACE,wBAAwB;EADjB;EAQT;IACE,kBAAkB;EADZ;EAQR;IAGE,gBAAgB;EADb;EAUL;IAQE,cAAc;IACd,sBAAsB;EAFjB;EASP;IAEE,eAAe;IACf,YAAY;EAFR;EAYN;IAME,aAAa;IACb,8BAA8B;IAC9B,gCAAgC;IAChC,uBAAuB;IACvB,cAAc;IACd,gBAAgB;IAChB,6BAA6B;IAC7B,UAAU;EARW;EAevB;IACE,mBAAmB;EAD0B;EAQ/C;IACE,0BAA0B;EAD0B;EAQtD;IACE,sBAAsB;EADD;EAQvB;IACE,UAAU;EADE;EASd;IAEE;MACE,mBAAyD;MAAzD;QAAA,yDAAyD;MAAA;IAD7C;EADiC;EAUjD;IACE,gBAAgB;EADT;EAQT;IACE,wBAAwB;EADE;EAS5B;IACE,eAAe;IACf,mBAAmB;EAFS;EAS9B;IACE,oBAAoB;EADE;EAQxB;IACE,UAAU;EAD2B;EAIvC;IASE,gBAAgB;EADqB;EAQvC;IACE,cAAc;EADoB;EAQpC;IACE,gBAAgB;EADD;EAQjB;IAGE,kBAAkB;EADG;EAQvB;IAEE,YAAY;EADc;EAQ5B;IACE,wBAAwB;EADmB;AAnZnC;AAwZZ,gBAAiB;ADvrBjB;EACI;IACI,oGAIC;EALF;EAOH;IAEI,8HAMC;EAPD;EASJ;IACI,uFAIC;EALA;AAlBuB;AAiEhC;EACI;IACI,UAAU;EADX;AAD0B;AASjC;EACI;IACI,UAAU;EADT;EAIL;IACI,UAAU;EADV;EAIJ;IACI,UAAU;EADX;AATyB;AAchC;EACI,4BAA4B;AADhB;AAIhB;EACI,kBAAkB;EAClB,UAAU;EACV,oDAAoD;EACpD,uEAAuE;AAJ7C;AAW9B;EACI,WAAW;EACX,kBAAkB;EAClB,sBAAsB;EACtB,UAAU;EACV,WAAW;EACX,0BAA0B;EAC1B,8BAA8B;EAC9B,UAAU;EACV,2EAA2E;EAC3E,uEAAuE;AAVtC;AAarC;EACI;IACI,UAAU;IACV,eAAe;EAFW;EAK9B;IACI,aAAa;EADoB;AAND;AGvTxC;EACI;;;;;IAKI,iDAAkD;EACrD;AACJ;AAED;EACI;;IAEI,4BAA6B;EAChC;AACJ;AAED;EACI;;IAEI,eAAgB;EACnB;AACJ;AAID;EAEI;IACI;;;;MAII,yBAA0B;IAC7B;EACJ;EAID;;;;IAII,gBAAiB;IACjB,eAAgB;IAChB,eAAgB;EACnB;AACJ;AAED;;EAEI,mBAAoB;EACpB,mBAAoB;EACpB,iCAAkC;EAClC,iCAAkC;EAClC,gCAAiC;EACjC,yBAA0B;EAC1B,2BAA4B;EAC5B,yBAA0B;EAC1B,qBAAsB;EACtB,0BAA2B;EAC3B,0BAA2B;EAC3B,gCAAiC;EACjC,6BAA8B;EAC9B,qBAAsB;EACtB,oCAAqC;EACrC,mCAAoC;EACpC,wCAAyC;EACzC,qCAAsC;AACzC;AAED;EACI;IACI,8BAA+B;EAClC;EAED;IACI,8BAA+B;EAClC;EAED;;;;IAKI,8BAA+B;IAC/B,8BAA+B;IAC/B,8CAA+C;IAC/C,4CAA6C;IAC7C,4CAA6C;IAC7C,2CAA4C;IAC5C,oCAAqC;IACrC,sCAAuC;IACvC,oCAAqC;IACrC,gCAAiC;IACjC,qCAAsC;IACtC,qCAAsC;IACtC,2CAA4C;IAC5C,wCAAyC;IACzC,gCAAiC;IACjC,+CAAgD;IAChD,8CAA+C;IAC/C,mDAAoD;IACpD,gDAAiD;IAGjD,oCAAqC;IACrC,oCAAqC;IACrC,oCAAqC;IACrC,oCAAqC;IACrC,oCAAqC;IACrC,oCAAqC;IACrC,oCAAqC;IACrC,oCAAqC;IACrC,oCAAqC;IACrC,oCAAqC;IAErC,8BAA+B;EAClC;AACJ;AACD;EACI,sBAAuB;EACvB,mCAAoC;EACpC,sBAAuB;EACvB,iCAAkC;EAClC,iCAAkC;EAClC,gCAAiC;EACjC,yBAA0B;EAC1B,2BAA4B;EAC5B,yBAA0B;EAC1B,qBAAsB;EACtB,0BAA2B;EAC3B,0BAA2B;EAC3B,gCAAiC;EACjC,6BAA8B;EAC9B,qBAAsB;EACtB,qCAAsC;EACtC,qCAAsC;EACtC,uCAAwC;EACxC,qCAAsC;AACzC;AAED;;EAEI,+CAAgD;AACnD;AAGD;EACI,kDAAmD;AACtD;AAED;EAEI,qBAAsB;EACtB,sBAAuB;EACvB,oBAAqB;EACrB,uBAAwB;EAExB,yBAA0B;EAE1B,2BAA4B;EAC5B,sBAAuB;EACvB,0BAA2B;EAC3B,wBAAyB;EACzB,0BAA2B;EAC3B,2BAA4B;EAC5B,yBAA0B;EAC1B,yBAA0B;EAE1B,yBAA0B;EAC1B,yBAA0B;EAC1B,yBAA0B;EAC1B,yBAA0B;EAC1B,yBAA0B;EAC1B,yBAA0B;EAC1B,yBAA0B;EAC1B,yBAA0B;EAC1B,yBAA0B;AAC7B;AAED;EACI,wCAAyC;EACzC;;6BAG0B;AAC7B;AAED;EACI,0BAA2B;EAC3B,4CAA4E;EAC5E;;;;;;;;;;;;mDAa+E;EAC/E,mBAAoB;EACpB,kBAAmB;AACtB;AAED;EACI,0BAA2B;EAC3B,4CAAkF;EAClF,kBAAmB;AACtB;AAED;EACI,0BAA2B;EAC3B,4CAA4E;EAC5E;;;;;;;;;;;;oDAa+E;EAC/E,mBAAoB;EACpB,kBAAmB;AACtB;AAED;EACI,0BAA2B;EAC3B,6CAAkF;EAClF,kBAAmB;AACtB;AAED;EACI,2BAA4B;EAC5B,6CAA6E;EAC7E;;;;;;;;;;;;oDAagF;EAChF,mBAAoB;EACpB,kBAAmB;AACtB;AAED;EACI,2BAA4B;EAC5B,6CAAmF;EACnF,kBAAmB;AACtB;AAED;EACI,4BAA6B;EAC7B,6CAA8E;EAC9E;;;;;;;;;;;;oDAaiF;EACjF,mBAAoB;EACpB,kBAAmB;AACtB;AAED;EACI,4BAA6B;EAC7B,6CAAoF;EACpF,kBAAmB;AACtB;AAED;EACI,6BAA8B;EAC9B,6CAAmF;EACnF;;;;;;;;;2BAUwB;EACxB,mBAAoB;EACpB,kBAAmB;AACtB;AAED;EACI,0BAA2B;EAC3B,6CAAgF;EAChF;;;;;;;;;2BAUwB;EACxB,mBAAoB;EACpB,kBAAmB;AACtB;AAED;EACI,4BAA6B;EAC7B,6CAAkF;EAClF;;;;;;;;;2BAUwB;EACxB,mBAAoB;EACpB,kBAAmB;AACtB;AAED;EACI,2BAA4B;EAC5B,6CAAiF;EACjF;;;;;;;;;2BAUwB;EACxB,mBAAoB;EACpB,kBAAmB;AACtB;AAED;EACI,yBAA0B;EAC1B,6CAA0F;EAC1F,gBAAiB;EACjB,kBAAmB;AACtB;AAED;EACI,qBAAsB;EACtB;uBACoB;EACpB,gBAAiB;EACjB,kBAAmB;AACtB;AAED;EACI,qBAAsB;EACtB;uBACoB;EACpB,gBAAiB;EACjB,kBAAmB;AACtB;AAED;EACI,qBAAsB;EACtB;uBACoB;EACpB,gBAAiB;EACjB,kBAAmB;AACtB;AAED;EACI,qBAAsB;EACtB;uBACoB;EACpB,gBAAiB;EACjB,kBAAmB;AACtB;AAED;EACI,yBAA0B;EAC1B;qBACkB;EAClB,gBAAiB;EACjB,kBAAmB;AACtB;AAED;EACI,+BAAgC;EAChC;uBACoB;EACpB,gBAAiB;EACjB,kBAAmB;AACtB;AAED;EACI,+BAAgC;EAChC;uBACoB;EACpB,gBAAiB;EACjB,kBAAmB;AACtB;AAED;EACI,+BAAgC;EAChC;uBACoB;EACpB,gBAAiB;EACjB,kBAAmB;AACtB;AAED;EACW,mCAAU;AACpB;AAED;EACW,sCAAa;AACvB;AAED;EACW,sCAAa;AACvB;AAED;EACW,sCAAa;AACvB;AAED;EACW,sCAAa;AACvB;AAED;EACW,sCAAa;AACvB;AAED;EACW,sCAAa;AACvB;AAED;EACW,sCAAa;AACvB;AAED;EACW,sCAAa;AACvB;AAED;EACI;IACW,gBAAe;EACzB;EAED;IACW,cAAK;EACf;EAED;IACW,6BAAc;EACxB;EAED;IACW,cAAK;IAAC,uCAAW;EAC3B;EAeD;IACI,6BAA8B;EACjC;EAED;IACW,uCAAW;EACrB;EAWD;;;;;IAKI,uCAAwC;EAC3C;EAED;IACI,qBAAsB;IACtB,wBAAyB;EAC5B;EAED;IACI,aAAc;EACjB;EAED;IACW,+BAAM;IAAN,gCAAM;IAAC,eAAc;IAAC,gBAAe;IAAC,0DAAsC;EACtF;EAED;IACW,0DAA4C;EACtD;AACJ;AAED;EACI,wBAAyB;EACzB,yBAA0B;AAC7B;AAED;EACI,iBAAkB;AACrB;AAED;EACI,gBAAiB;AACpB;AAED;EACI,iCAAkC;AACrC;AAED;EACW,0BAAQ;EAAR,4DAAQ;EAAC,yCAAS;EAAT,oCAAS;AAC5B;AACD;EACW,0BAAQ;EAAR,4DAAQ;EAAC,6CAAa;EAAb,wCAAa;AAChC;AACD;EACW,yBAAO;EAAP,2DAAO;EAAC,6CAAa;EAAb,wCAAa;AAC/B;AACD;EACW,qBAAS;EAAC,8CAAI;AACxB;AACD;EACW,wBAAY;EAAC,8CAAI;AAC3B;AACD;EACW,iDAAU;EAAV,8BAAU;EAAC,mCAAe;EAAC,uCAAI;EAAC,8CAAI;EAAC,4BAAa;EAAC,kBAAM;AACnE;AACD;EACW,sCAAI;EAAC,WAAM;EAAC,yBAAe;AACrC;AACD;;EAEW,oCAAM;EAAN,iBAAM;EAAC,mCAAe;EAAC,wCAAI;EAAC,uCAAI;EAAC,iBAAU;AACrD;AACD;EACW,sCAAI;EAAC,wCAAQ;EAAR,qBAAQ;EAAC,mCAAe;AACvC;AAED;EACW,wBAAS;EAAC;IAAA;MAAA,+BAAe;IAAA;EAAA;AACnC;AAED;EACI,uCAAwC;AAC3C;AHtdU;EAAA,WAAc;EAAd,iBAAc;EAAd,eAAc;AAAA;ACwvBvB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,gBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,gBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,gBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,gBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,gBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,gBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,gBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,gBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,oBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,wBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB,eAAmB;EAAnB,mBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,wBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB,eAAmB;EAAnB,mBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,wBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,wBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB,eAAmB;EAAnB,kBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,mBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,wBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,oBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB,eAAmB;EAAnB,mBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AA3ejB;EACE;IACE,yBAAyB;EADxB;AADW;AAMhB;EACE;IAEE,mBAAmB;IACnB,UAAU;EAFP;AAFS;AAQhB;EACE;IACE,YAAY;EADV;AADW;ACxUjB;EACI;IACI,WAAW;EADZ;EAGH;IACI,YAAY;EADZ;EAGJ;IACI,aAAa;EADb;EAGJ;IACI,cAAc;EADd;AAVY;AAepB;EACI;IACI,YAAY;EADZ;AADQ;AAMhB;EACI;IACI,UAAU;EADT;EAGL;IACI,UAAU;EADX;AAJW;AASlB;EACI;IACI,2BAA2B;IAC3B,QAAQ;IACR,YAAY;EAHb;EAKH;IACI,wBAAwB;IACxB,YAAY;IACZ,gBAAgB;EAHf;AANiB;AAa1B;EACI;IACI,UAAU;IACV,2BAA2B;EAF5B;EAIH;IACI,UAAU;IACV,wBAAwB;EAFvB;AALoB;AAW7B;EACI;IACI,wBAAwB;IACxB,YAAY;IACZ,gBAAgB;EAHjB;EAKH;IACI,2BAA2B;IAC3B,QAAQ;IACR,YAAY;EAHX;AANW;AAapB;EACI;IACI,UAAU;EADX;EAGH;IACI,aAAa;EADb;EAGJ;IACI,YAAY;IACZ,kBAAkB;IAClB,qBAAqB;EAHpB;AAPyB;AAclC;EACI;IACI,uBAAuB;EADxB;EAGH;IACI,yBAAyB;IACzB,qDAAqD;EAFrD;EAIJ;IACI,yBAAyB;IACzB,qDAAqD;EAFpD;AARyB;ADyOlC;EACE;IACE,yBAAyB;EADxB;AADW;AAMhB;EACE;IAEE,mBAAmB;IACnB,UAAU;EAFP;AAFS;AAQhB;EACE;IACE,YAAY;EADV;AADW;AD3RV;EAAA;IAAA;MAAA,gBAAc;MCwvBvB,mBAAmB;MAAnB,mBAAmB;MAAnB,mBAAmB;MAAnB,eAAmB;MAAnB,eAAmB;MAAnB,eAAmB;MAAnB,sBAAmB;MAAnB,sBAAmB;MAAnB,sBAAmB;MAAnB,oBAAmB;MAAnB,oBAAmB;MAAnB,uBAAmB;MAAnB,wBAAmB;MAAnB,wBAAmB;MAAnB,qBAAmB;MAAnB,yBAAmB;MAAnB,sBAAmB;MAAnB,qBAAmB;MAAnB,0BAAmB;MAAnB,4BAAmB;MAAnB,6BAAmB;MAAnB,8BAAmB;MAAnB,sBAAmB;MAAnB,0BAAmB;MAAnB,uBAAmB;MAAnB,4BAAmB;MAAnB,gCAAmB;MAAnB,6BAAmB;MAAnB,wBAAmB;MAAnB,2BAAmB;MAAnB,8BAAmB;MAAnB,iCAAmB;MAAnB,wBAAmB;MAAnB,2BAAmB;MAAnB,4BAAmB;MAAnB,kCAAmB;MAAnB,yBAAmB;MAAnB,kBAAmB;MAAnB,wBAAmB;MAAnB,sBAAmB;MAAnB,uBAAmB;MAAnB,wBAAmB;MAAnB,oBAAmB;MAAnB,qBAAmB;MAAnB,sBAAmB;MAAnB,mBAAmB;MAAnB,yBAAmB;MAAnB,+BAAmB;MAAnB,4BAAmB;MAAnB,8BAAmB;MAAnB,2BAAmB;MAAnB,iCAAmB;MAAnB,+BAAmB;MAAnB,gCAAmB;MAAnB,iCAAmB;MAAnB,6BAAmB;MAAnB,8BAAmB;MAAnB,+BAAmB;MAAnB,4BAAmB;MAAnB,sBAAmB;MAAnB,kBAAmB;IDxvBI;EAAA;AAAA","sourcesContent":[null,"@source '../../../**/*.{js,jsx,ts,tsx,html}';\n@import 'tailwindcss';\n\n@plugin '@tailwindcss/forms' {\n    strategy: 'class';\n}\n\n@utility darken-* {\n    background-image: linear-gradient(\n        rgb(0 0 0 / calc(--value(integer) * 1%)),\n        rgb(0 0 0 / calc(--value(integer) * 1%))\n    );\n}\n\n@utility brighten-* {\n    background-image: linear-gradient(\n        rgb(255 255 255 / calc(--value(integer) * 1%)),\n        rgb(255 255 255 / calc(--value(integer) * 1%))\n    );\n}\n\n@utility scrollbar-gutter-stable {\n    scrollbar-gutter: stable;\n}\n\n/* Reserves the gutter on both edges rather than only the one the scrollbar\n   lands on, so a region that gains a scrollbar stays put horizontally instead\n   of shifting, and stays symmetric while it has none. */\n@utility scrollbar-gutter-stable-both {\n    scrollbar-gutter: stable both-edges;\n}\n\n/* Shared timing for the meeting right-panel open/close. The panel columns\n   animate flex-basis; the self-view PiP keeps clear of the open panel by\n   animating its inset-inline-end. Sharing one utility keeps them in lockstep —\n   the PiP glides aside instead of jumping — with the duration/easing in one\n   place. */\n@utility meeting-panel-transition {\n    transition-property: flex-basis, inset-inline-end;\n    transition-duration: 300ms;\n    transition-timing-function: ease-out;\n}\n\n/* Reveals a row's action on hover or on keyboard focus.\n\n   For the handful of rows where that action is the only thing able to take\n   focus, `hidden` cannot be used: a display:none element is not focusable, so\n   nothing in the row could ever receive focus to reveal it, and the action\n   stayed unreachable from the keyboard. Staying in the layout keeps it in the\n   tab order, and gating pointer events stops it taking a tap while it is still\n   invisible. Pair it with the display the element needs, e.g. `flex`. */\n@utility reveal-on-hover-or-focus {\n    opacity: 0;\n    pointer-events: none;\n\n    :where(.group):hover &,\n    :where(.group):is(:focus-visible, :has(:focus-visible)) & {\n        opacity: 1;\n        pointer-events: auto;\n    }\n}\n\n/* A group's actions that show on hover or keyboard focus. While hidden they\n   are visually hidden, as sr-only, not display: none, so a screen reader still\n   finds them and Tab can still move focus to them: the group matches\n   :focus-visible only once the new focus has arrived. Focus that a click\n   leaves behind is not :focus-visible, so it does not keep them shown. Like\n   Tailwind's group-* variants, any engaged ancestor group reveals them, so a\n   row inside a focusable link shows its actions when the link has focus. */\n@utility sr-only-until-hover-or-focus {\n    &:not(:where(.group):is(:hover, :focus-visible, :has(:focus-visible)) *) {\n        position: absolute;\n        width: 1px;\n        height: 1px;\n        padding: 0;\n        margin: -1px;\n        overflow: hidden;\n        clip-path: inset(50%);\n        white-space: nowrap;\n        border-width: 0;\n    }\n}\n\n/* The keyboard focus indicator for a control: the browser's own focus ring,\n   in the browser's own colour, never the brand colour. So it has the colour\n   of the ring on a control without this utility.\n   `outline: revert` hands the outline back to the browser on focus-visible;\n   the offset leaves a 2px gap. The doubled :focus-visible lifts the rule\n   above an `outline-hidden` or `outline-none` on the control, prefixed with\n   `focus:` or `focus-visible:` or not, so those cannot hide the ring. The\n   resting outline colour is the ring's own (Chromium and Safari), so a\n   `transition-colors` on the control does not fade the ring in from the text\n   colour. Since the ring is the outline, a control must not draw its border\n   with `outline`; use `ring-1` (a box-shadow) instead, plus\n   `forced-colors:outline-1`, since forced colours drop box-shadows.\n   A `form-*` field also takes `focus:ring-0`, since the forms plugin draws\n   its own blue ring on focus. A `relative` control that touches its\n   neighbours takes `focus-visible:z-10`; otherwise they cover the ring.\n   A mouse click on a button shows nothing; a text field shows the ring on\n   every focus, as the browser does. BaseButton carries it, so every Button\n   has it. */\n@utility focus-ring {\n    outline-color: -webkit-focus-ring-color;\n\n    &:focus-visible:focus-visible {\n        outline: revert;\n        outline-offset: 2px;\n    }\n}\n\n/* `focus-ring` drawn inside the box, for a list row that fills its scroller:\n   there the scroller cuts off a ring drawn outside, and the next row covers\n   it. The offset fits the whole ring inside, including the light edge that\n   Chromium draws around it. BaseListItem carries it. */\n@utility focus-ring-inset {\n    outline-color: -webkit-focus-ring-color;\n\n    &:focus-visible:focus-visible {\n        outline: revert;\n        outline-offset: -3px;\n    }\n}\n\n/* A control that covers its card, such as the link in a call history row.\n   The control holds only its own text, so a screen reader reads that text as\n   its name. Its ::after covers the card, which is the nearest `relative`\n   ancestor, so a click anywhere on the card reaches the control. The focus\n   ring goes on that area, around the whole card, as `focus-ring-inset` does\n   on a list row. The browser styles only the control, not its ::after, so\n   the control keeps the colour of the browser's ring with its outline style\n   set to none, and the ::after inherits that colour. The card's other\n   controls come later in the DOM and are positioned, so they take their own\n   clicks. */\n@utility stretched-control {\n    @apply after:absolute after:inset-0 after:rounded-sm;\n    outline-style: none;\n\n    /* On a BaseButton, `focus-ring` puts the browser's ring back on the\n       control itself at (0,3,0). Tailwind orders utilities by property, not\n       by source, so this wins by specificity (0,4,0) and keeps the control\n       bare: only the ::after ring shows. */\n    &.focus-ring:focus-visible:focus-visible {\n        outline-style: none;\n    }\n\n    &:focus-visible::after {\n        outline: auto 1px;\n        outline-color: inherit;\n        outline-offset: -3px;\n    }\n}\n\n/* A camera-off meeting tile, sized so the avatar inside can measure it.\n   container-type is size, not inline-size: the avatar reads the shorter side. */\n@utility meeting-tile-avatar-container {\n    container-type: size;\n}\n\n/* The avatar on such a tile (Figma: Video avatars). It is 124px, and on a card\n   with no room for that it shrinks to leave a 24px padding — the padding\n   always wins. Continuous rather than stepped, so a resize scales it smoothly.\n   The floor keeps it visible on the smallest card the layout engine allows. */\n@utility meeting-tile-avatar {\n    --meeting-tile-avatar-size: clamp(24px, calc(100cqmin - 48px), 124px);\n    width: var(--meeting-tile-avatar-size);\n    height: var(--meeting-tile-avatar-size);\n    /* Initials are 24px on a 124px avatar. */\n    font-size: calc(var(--meeting-tile-avatar-size) * 0.194);\n}\n\n/* One line of text that shrinks to fit its width, down to 60% of its font\n   size. Put it on the element that sets the font size; text-fit is inherited.\n   Chromium applies an ellipsis before text-fit, and then text-fit scales only\n   the visible part, so a `truncate` inside loses its ellipsis. Text that is\n   still too long at 60% scrolls sideways instead, with no scrollbar, and fades\n   out at each edge that has more text behind it. The fade runs on the scroll\n   position, so text that fits has none. A browser without text-fit keeps the\n   full size and the ellipsis. */\n@utility text-fit-shrink {\n    @supports (text-fit: shrink) {\n        text-fit: shrink 60%;\n        white-space: nowrap;\n\n        & .truncate {\n            --text-fit-fade-direction: to right;\n            overflow-x: auto;\n            scrollbar-width: none;\n            text-overflow: clip;\n            animation: text-fit-scroll-fade linear backwards;\n            animation-timeline: scroll(self inline);\n\n            &:dir(rtl) {\n                --text-fit-fade-direction: to left;\n            }\n        }\n    }\n}\n\n@keyframes text-fit-scroll-fade {\n    0% {\n        mask-image: linear-gradient(\n            var(--text-fit-fade-direction),\n            black calc(100% - 0.9em),\n            transparent\n        );\n    }\n    1%,\n    99% {\n        mask-image: linear-gradient(\n            var(--text-fit-fade-direction),\n            transparent,\n            black 0.9em,\n            black calc(100% - 0.9em),\n            transparent\n        );\n    }\n    100% {\n        mask-image: linear-gradient(\n            var(--text-fit-fade-direction),\n            transparent,\n            black 0.9em\n        );\n    }\n}\n\n@utility animate-ellipsis {\n    &::after {\n        content: '';\n        animation: var(--animate-ellipsis);\n    }\n}\n\n/* group-focus-within for keyboard focus only, for what hides while a group's\n   actions show. The group itself can hold the focus, and :has() looks at\n   descendants only. */\n@custom-variant group-focus-visible-within (&:is(:where(.group):is(:focus-visible, :has(:focus-visible)) *));\n\n@custom-variant dark (&:where(.dark):not(.no-dark, .no-dark *), &:where(.dark *):not(.no-dark, .no-dark *));\n\n@custom-variant progress-unfilled {\n    &::-webkit-progress-bar,\n    & {\n        @slot;\n    }\n}\n\n@custom-variant progress-filled {\n    &::-webkit-progress-value,\n    &::-moz-progress-bar {\n        @slot;\n    }\n}\n\n@source inline('bg-flavor-{1..9}{/50,}');\n\n/* Reveals already-parsed markdown a chunk at a time. rehype-reveal-ticks wraps\n   each chunk in a .reveal-chunk span carrying its tick number, and the delay is\n   that number of ticks — so the whole animation is declarative and nothing runs\n   per frame.\n\n   The text holds its final position from the first frame, since only opacity\n   changes, so the block never reflows as it fills in and needs nothing behind\n   it to reserve the height. It also stays selectable and findable throughout. */\n@keyframes summary-reveal-appear {\n    to {\n        opacity: 1;\n    }\n}\n\n/* The caret belongs to the chunk being revealed and is gone by the next one, so\n   it travels with the text: inline beside the last visible character, whatever\n   block that character is in, rather than hanging off the last block. */\n@keyframes summary-reveal-caret {\n    from {\n        opacity: 1;\n    }\n\n    99% {\n        opacity: 1;\n    }\n\n    to {\n        opacity: 0;\n    }\n}\n\n.summary-reveal {\n    --reveal-tick-duration: 16ms;\n}\n\n.summary-reveal .reveal-chunk {\n    position: relative;\n    opacity: 0;\n    animation: summary-reveal-appear 1ms linear forwards;\n    animation-delay: calc(var(--reveal-tick) * var(--reveal-tick-duration));\n}\n\n/* Taken out of the inline flow: `opacity: 0` hides paint but not layout, so an\n   in-flow caret on every chunk would gap the text by its own width for good —\n   not just while that chunk is revealing. Out of flow it also leaves the\n   animation compositor-only, with no reflow per tick. */\n.summary-reveal .reveal-chunk::after {\n    content: '';\n    position: absolute;\n    inset-inline-end: -3px;\n    width: 2px;\n    height: 1em;\n    transform: translateY(2px);\n    background-color: currentColor;\n    opacity: 0;\n    animation: summary-reveal-caret var(--reveal-tick-duration) linear forwards;\n    animation-delay: calc(var(--reveal-tick) * var(--reveal-tick-duration));\n}\n\n@media (prefers-reduced-motion: reduce) {\n    .summary-reveal .reveal-chunk {\n        opacity: 1;\n        animation: none;\n    }\n\n    .summary-reveal .reveal-chunk::after {\n        content: none;\n    }\n}\n","@layer theme, base, components, utilities;\n\n@layer theme {\n  @theme default {\n    --font-sans:\n      ui-sans-serif, system-ui, sans-serif, \"Apple Color Emoji\",\n      \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n    --font-serif: ui-serif, Georgia, Cambria, \"Times New Roman\", Times, serif;\n    --font-mono:\n      ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\",\n      \"Courier New\", monospace;\n\n    --color-red-50: oklch(97.1% 0.013 17.38);\n    --color-red-100: oklch(93.6% 0.032 17.717);\n    --color-red-200: oklch(88.5% 0.062 18.334);\n    --color-red-300: oklch(80.8% 0.114 19.571);\n    --color-red-400: oklch(70.4% 0.191 22.216);\n    --color-red-500: oklch(63.7% 0.237 25.331);\n    --color-red-600: oklch(57.7% 0.245 27.325);\n    --color-red-700: oklch(50.5% 0.213 27.518);\n    --color-red-800: oklch(44.4% 0.177 26.899);\n    --color-red-900: oklch(39.6% 0.141 25.723);\n    --color-red-950: oklch(25.8% 0.092 26.042);\n\n    --color-orange-50: oklch(98% 0.016 73.684);\n    --color-orange-100: oklch(95.4% 0.038 75.164);\n    --color-orange-200: oklch(90.1% 0.076 70.697);\n    --color-orange-300: oklch(83.7% 0.128 66.29);\n    --color-orange-400: oklch(75% 0.183 55.934);\n    --color-orange-500: oklch(70.5% 0.213 47.604);\n    --color-orange-600: oklch(64.6% 0.222 41.116);\n    --color-orange-700: oklch(55.3% 0.195 38.402);\n    --color-orange-800: oklch(47% 0.157 37.304);\n    --color-orange-900: oklch(40.8% 0.123 38.172);\n    --color-orange-950: oklch(26.6% 0.079 36.259);\n\n    --color-amber-50: oklch(98.7% 0.022 95.277);\n    --color-amber-100: oklch(96.2% 0.059 95.617);\n    --color-amber-200: oklch(92.4% 0.12 95.746);\n    --color-amber-300: oklch(87.9% 0.169 91.605);\n    --color-amber-400: oklch(82.8% 0.189 84.429);\n    --color-amber-500: oklch(76.9% 0.188 70.08);\n    --color-amber-600: oklch(66.6% 0.179 58.318);\n    --color-amber-700: oklch(55.5% 0.163 48.998);\n    --color-amber-800: oklch(47.3% 0.137 46.201);\n    --color-amber-900: oklch(41.4% 0.112 45.904);\n    --color-amber-950: oklch(27.9% 0.077 45.635);\n\n    --color-yellow-50: oklch(98.7% 0.026 102.212);\n    --color-yellow-100: oklch(97.3% 0.071 103.193);\n    --color-yellow-200: oklch(94.5% 0.129 101.54);\n    --color-yellow-300: oklch(90.5% 0.182 98.111);\n    --color-yellow-400: oklch(85.2% 0.199 91.936);\n    --color-yellow-500: oklch(79.5% 0.184 86.047);\n    --color-yellow-600: oklch(68.1% 0.162 75.834);\n    --color-yellow-700: oklch(55.4% 0.135 66.442);\n    --color-yellow-800: oklch(47.6% 0.114 61.907);\n    --color-yellow-900: oklch(42.1% 0.095 57.708);\n    --color-yellow-950: oklch(28.6% 0.066 53.813);\n\n    --color-lime-50: oklch(98.6% 0.031 120.757);\n    --color-lime-100: oklch(96.7% 0.067 122.328);\n    --color-lime-200: oklch(93.8% 0.127 124.321);\n    --color-lime-300: oklch(89.7% 0.196 126.665);\n    --color-lime-400: oklch(84.1% 0.238 128.85);\n    --color-lime-500: oklch(76.8% 0.233 130.85);\n    --color-lime-600: oklch(64.8% 0.2 131.684);\n    --color-lime-700: oklch(53.2% 0.157 131.589);\n    --color-lime-800: oklch(45.3% 0.124 130.933);\n    --color-lime-900: oklch(40.5% 0.101 131.063);\n    --color-lime-950: oklch(27.4% 0.072 132.109);\n\n    --color-green-50: oklch(98.2% 0.018 155.826);\n    --color-green-100: oklch(96.2% 0.044 156.743);\n    --color-green-200: oklch(92.5% 0.084 155.995);\n    --color-green-300: oklch(87.1% 0.15 154.449);\n    --color-green-400: oklch(79.2% 0.209 151.711);\n    --color-green-500: oklch(72.3% 0.219 149.579);\n    --color-green-600: oklch(62.7% 0.194 149.214);\n    --color-green-700: oklch(52.7% 0.154 150.069);\n    --color-green-800: oklch(44.8% 0.119 151.328);\n    --color-green-900: oklch(39.3% 0.095 152.535);\n    --color-green-950: oklch(26.6% 0.065 152.934);\n\n    --color-emerald-50: oklch(97.9% 0.021 166.113);\n    --color-emerald-100: oklch(95% 0.052 163.051);\n    --color-emerald-200: oklch(90.5% 0.093 164.15);\n    --color-emerald-300: oklch(84.5% 0.143 164.978);\n    --color-emerald-400: oklch(76.5% 0.177 163.223);\n    --color-emerald-500: oklch(69.6% 0.17 162.48);\n    --color-emerald-600: oklch(59.6% 0.145 163.225);\n    --color-emerald-700: oklch(50.8% 0.118 165.612);\n    --color-emerald-800: oklch(43.2% 0.095 166.913);\n    --color-emerald-900: oklch(37.8% 0.077 168.94);\n    --color-emerald-950: oklch(26.2% 0.051 172.552);\n\n    --color-teal-50: oklch(98.4% 0.014 180.72);\n    --color-teal-100: oklch(95.3% 0.051 180.801);\n    --color-teal-200: oklch(91% 0.096 180.426);\n    --color-teal-300: oklch(85.5% 0.138 181.071);\n    --color-teal-400: oklch(77.7% 0.152 181.912);\n    --color-teal-500: oklch(70.4% 0.14 182.503);\n    --color-teal-600: oklch(60% 0.118 184.704);\n    --color-teal-700: oklch(51.1% 0.096 186.391);\n    --color-teal-800: oklch(43.7% 0.078 188.216);\n    --color-teal-900: oklch(38.6% 0.063 188.416);\n    --color-teal-950: oklch(27.7% 0.046 192.524);\n\n    --color-cyan-50: oklch(98.4% 0.019 200.873);\n    --color-cyan-100: oklch(95.6% 0.045 203.388);\n    --color-cyan-200: oklch(91.7% 0.08 205.041);\n    --color-cyan-300: oklch(86.5% 0.127 207.078);\n    --color-cyan-400: oklch(78.9% 0.154 211.53);\n    --color-cyan-500: oklch(71.5% 0.143 215.221);\n    --color-cyan-600: oklch(60.9% 0.126 221.723);\n    --color-cyan-700: oklch(52% 0.105 223.128);\n    --color-cyan-800: oklch(45% 0.085 224.283);\n    --color-cyan-900: oklch(39.8% 0.07 227.392);\n    --color-cyan-950: oklch(30.2% 0.056 229.695);\n\n    --color-sky-50: oklch(97.7% 0.013 236.62);\n    --color-sky-100: oklch(95.1% 0.026 236.824);\n    --color-sky-200: oklch(90.1% 0.058 230.902);\n    --color-sky-300: oklch(82.8% 0.111 230.318);\n    --color-sky-400: oklch(74.6% 0.16 232.661);\n    --color-sky-500: oklch(68.5% 0.169 237.323);\n    --color-sky-600: oklch(58.8% 0.158 241.966);\n    --color-sky-700: oklch(50% 0.134 242.749);\n    --color-sky-800: oklch(44.3% 0.11 240.79);\n    --color-sky-900: oklch(39.1% 0.09 240.876);\n    --color-sky-950: oklch(29.3% 0.066 243.157);\n\n    --color-blue-50: oklch(97% 0.014 254.604);\n    --color-blue-100: oklch(93.2% 0.032 255.585);\n    --color-blue-200: oklch(88.2% 0.059 254.128);\n    --color-blue-300: oklch(80.9% 0.105 251.813);\n    --color-blue-400: oklch(70.7% 0.165 254.624);\n    --color-blue-500: oklch(62.3% 0.214 259.815);\n    --color-blue-600: oklch(54.6% 0.245 262.881);\n    --color-blue-700: oklch(48.8% 0.243 264.376);\n    --color-blue-800: oklch(42.4% 0.199 265.638);\n    --color-blue-900: oklch(37.9% 0.146 265.522);\n    --color-blue-950: oklch(28.2% 0.091 267.935);\n\n    --color-indigo-50: oklch(96.2% 0.018 272.314);\n    --color-indigo-100: oklch(93% 0.034 272.788);\n    --color-indigo-200: oklch(87% 0.065 274.039);\n    --color-indigo-300: oklch(78.5% 0.115 274.713);\n    --color-indigo-400: oklch(67.3% 0.182 276.935);\n    --color-indigo-500: oklch(58.5% 0.233 277.117);\n    --color-indigo-600: oklch(51.1% 0.262 276.966);\n    --color-indigo-700: oklch(45.7% 0.24 277.023);\n    --color-indigo-800: oklch(39.8% 0.195 277.366);\n    --color-indigo-900: oklch(35.9% 0.144 278.697);\n    --color-indigo-950: oklch(25.7% 0.09 281.288);\n\n    --color-violet-50: oklch(96.9% 0.016 293.756);\n    --color-violet-100: oklch(94.3% 0.029 294.588);\n    --color-violet-200: oklch(89.4% 0.057 293.283);\n    --color-violet-300: oklch(81.1% 0.111 293.571);\n    --color-violet-400: oklch(70.2% 0.183 293.541);\n    --color-violet-500: oklch(60.6% 0.25 292.717);\n    --color-violet-600: oklch(54.1% 0.281 293.009);\n    --color-violet-700: oklch(49.1% 0.27 292.581);\n    --color-violet-800: oklch(43.2% 0.232 292.759);\n    --color-violet-900: oklch(38% 0.189 293.745);\n    --color-violet-950: oklch(28.3% 0.141 291.089);\n\n    --color-purple-50: oklch(97.7% 0.014 308.299);\n    --color-purple-100: oklch(94.6% 0.033 307.174);\n    --color-purple-200: oklch(90.2% 0.063 306.703);\n    --color-purple-300: oklch(82.7% 0.119 306.383);\n    --color-purple-400: oklch(71.4% 0.203 305.504);\n    --color-purple-500: oklch(62.7% 0.265 303.9);\n    --color-purple-600: oklch(55.8% 0.288 302.321);\n    --color-purple-700: oklch(49.6% 0.265 301.924);\n    --color-purple-800: oklch(43.8% 0.218 303.724);\n    --color-purple-900: oklch(38.1% 0.176 304.987);\n    --color-purple-950: oklch(29.1% 0.149 302.717);\n\n    --color-fuchsia-50: oklch(97.7% 0.017 320.058);\n    --color-fuchsia-100: oklch(95.2% 0.037 318.852);\n    --color-fuchsia-200: oklch(90.3% 0.076 319.62);\n    --color-fuchsia-300: oklch(83.3% 0.145 321.434);\n    --color-fuchsia-400: oklch(74% 0.238 322.16);\n    --color-fuchsia-500: oklch(66.7% 0.295 322.15);\n    --color-fuchsia-600: oklch(59.1% 0.293 322.896);\n    --color-fuchsia-700: oklch(51.8% 0.253 323.949);\n    --color-fuchsia-800: oklch(45.2% 0.211 324.591);\n    --color-fuchsia-900: oklch(40.1% 0.17 325.612);\n    --color-fuchsia-950: oklch(29.3% 0.136 325.661);\n\n    --color-pink-50: oklch(97.1% 0.014 343.198);\n    --color-pink-100: oklch(94.8% 0.028 342.258);\n    --color-pink-200: oklch(89.9% 0.061 343.231);\n    --color-pink-300: oklch(82.3% 0.12 346.018);\n    --color-pink-400: oklch(71.8% 0.202 349.761);\n    --color-pink-500: oklch(65.6% 0.241 354.308);\n    --color-pink-600: oklch(59.2% 0.249 0.584);\n    --color-pink-700: oklch(52.5% 0.223 3.958);\n    --color-pink-800: oklch(45.9% 0.187 3.815);\n    --color-pink-900: oklch(40.8% 0.153 2.432);\n    --color-pink-950: oklch(28.4% 0.109 3.907);\n\n    --color-rose-50: oklch(96.9% 0.015 12.422);\n    --color-rose-100: oklch(94.1% 0.03 12.58);\n    --color-rose-200: oklch(89.2% 0.058 10.001);\n    --color-rose-300: oklch(81% 0.117 11.638);\n    --color-rose-400: oklch(71.2% 0.194 13.428);\n    --color-rose-500: oklch(64.5% 0.246 16.439);\n    --color-rose-600: oklch(58.6% 0.253 17.585);\n    --color-rose-700: oklch(51.4% 0.222 16.935);\n    --color-rose-800: oklch(45.5% 0.188 13.697);\n    --color-rose-900: oklch(41% 0.159 10.272);\n    --color-rose-950: oklch(27.1% 0.105 12.094);\n\n    --color-slate-50: oklch(98.4% 0.003 247.858);\n    --color-slate-100: oklch(96.8% 0.007 247.896);\n    --color-slate-200: oklch(92.9% 0.013 255.508);\n    --color-slate-300: oklch(86.9% 0.022 252.894);\n    --color-slate-400: oklch(70.4% 0.04 256.788);\n    --color-slate-500: oklch(55.4% 0.046 257.417);\n    --color-slate-600: oklch(44.6% 0.043 257.281);\n    --color-slate-700: oklch(37.2% 0.044 257.287);\n    --color-slate-800: oklch(27.9% 0.041 260.031);\n    --color-slate-900: oklch(20.8% 0.042 265.755);\n    --color-slate-950: oklch(12.9% 0.042 264.695);\n\n    --color-gray-50: oklch(98.5% 0.002 247.839);\n    --color-gray-100: oklch(96.7% 0.003 264.542);\n    --color-gray-200: oklch(92.8% 0.006 264.531);\n    --color-gray-300: oklch(87.2% 0.01 258.338);\n    --color-gray-400: oklch(70.7% 0.022 261.325);\n    --color-gray-500: oklch(55.1% 0.027 264.364);\n    --color-gray-600: oklch(44.6% 0.03 256.802);\n    --color-gray-700: oklch(37.3% 0.034 259.733);\n    --color-gray-800: oklch(27.8% 0.033 256.848);\n    --color-gray-900: oklch(21% 0.034 264.665);\n    --color-gray-950: oklch(13% 0.028 261.692);\n\n    --color-zinc-50: oklch(98.5% 0 0);\n    --color-zinc-100: oklch(96.7% 0.001 286.375);\n    --color-zinc-200: oklch(92% 0.004 286.32);\n    --color-zinc-300: oklch(87.1% 0.006 286.286);\n    --color-zinc-400: oklch(70.5% 0.015 286.067);\n    --color-zinc-500: oklch(55.2% 0.016 285.938);\n    --color-zinc-600: oklch(44.2% 0.017 285.786);\n    --color-zinc-700: oklch(37% 0.013 285.805);\n    --color-zinc-800: oklch(27.4% 0.006 286.033);\n    --color-zinc-900: oklch(21% 0.006 285.885);\n    --color-zinc-950: oklch(14.1% 0.005 285.823);\n\n    --color-neutral-50: oklch(98.5% 0 0);\n    --color-neutral-100: oklch(97% 0 0);\n    --color-neutral-200: oklch(92.2% 0 0);\n    --color-neutral-300: oklch(87% 0 0);\n    --color-neutral-400: oklch(70.8% 0 0);\n    --color-neutral-500: oklch(55.6% 0 0);\n    --color-neutral-600: oklch(43.9% 0 0);\n    --color-neutral-700: oklch(37.1% 0 0);\n    --color-neutral-800: oklch(26.9% 0 0);\n    --color-neutral-900: oklch(20.5% 0 0);\n    --color-neutral-950: oklch(14.5% 0 0);\n\n    --color-stone-50: oklch(98.5% 0.001 106.423);\n    --color-stone-100: oklch(97% 0.001 106.424);\n    --color-stone-200: oklch(92.3% 0.003 48.717);\n    --color-stone-300: oklch(86.9% 0.005 56.366);\n    --color-stone-400: oklch(70.9% 0.01 56.259);\n    --color-stone-500: oklch(55.3% 0.013 58.071);\n    --color-stone-600: oklch(44.4% 0.011 73.639);\n    --color-stone-700: oklch(37.4% 0.01 67.558);\n    --color-stone-800: oklch(26.8% 0.007 34.298);\n    --color-stone-900: oklch(21.6% 0.006 56.043);\n    --color-stone-950: oklch(14.7% 0.004 49.25);\n\n    --color-black: #000;\n    --color-white: #fff;\n\n    --spacing: 0.25rem;\n\n    --breakpoint-sm: 40rem;\n    --breakpoint-md: 48rem;\n    --breakpoint-lg: 64rem;\n    --breakpoint-xl: 80rem;\n    --breakpoint-2xl: 96rem;\n\n    --container-3xs: 16rem;\n    --container-2xs: 18rem;\n    --container-xs: 20rem;\n    --container-sm: 24rem;\n    --container-md: 28rem;\n    --container-lg: 32rem;\n    --container-xl: 36rem;\n    --container-2xl: 42rem;\n    --container-3xl: 48rem;\n    --container-4xl: 56rem;\n    --container-5xl: 64rem;\n    --container-6xl: 72rem;\n    --container-7xl: 80rem;\n\n    --text-xs: 0.75rem;\n    --text-xs--line-height: calc(1 / 0.75);\n    --text-sm: 0.875rem;\n    --text-sm--line-height: calc(1.25 / 0.875);\n    --text-base: 1rem;\n    --text-base--line-height: calc(1.5 / 1);\n    --text-lg: 1.125rem;\n    --text-lg--line-height: calc(1.75 / 1.125);\n    --text-xl: 1.25rem;\n    --text-xl--line-height: calc(1.75 / 1.25);\n    --text-2xl: 1.5rem;\n    --text-2xl--line-height: calc(2 / 1.5);\n    --text-3xl: 1.875rem;\n    --text-3xl--line-height: calc(2.25 / 1.875);\n    --text-4xl: 2.25rem;\n    --text-4xl--line-height: calc(2.5 / 2.25);\n    --text-5xl: 3rem;\n    --text-5xl--line-height: 1;\n    --text-6xl: 3.75rem;\n    --text-6xl--line-height: 1;\n    --text-7xl: 4.5rem;\n    --text-7xl--line-height: 1;\n    --text-8xl: 6rem;\n    --text-8xl--line-height: 1;\n    --text-9xl: 8rem;\n    --text-9xl--line-height: 1;\n\n    --font-weight-thin: 100;\n    --font-weight-extralight: 200;\n    --font-weight-light: 300;\n    --font-weight-normal: 400;\n    --font-weight-medium: 500;\n    --font-weight-semibold: 600;\n    --font-weight-bold: 700;\n    --font-weight-extrabold: 800;\n    --font-weight-black: 900;\n\n    --tracking-tighter: -0.05em;\n    --tracking-tight: -0.025em;\n    --tracking-normal: 0em;\n    --tracking-wide: 0.025em;\n    --tracking-wider: 0.05em;\n    --tracking-widest: 0.1em;\n\n    --leading-tight: 1.25;\n    --leading-snug: 1.375;\n    --leading-normal: 1.5;\n    --leading-relaxed: 1.625;\n    --leading-loose: 2;\n\n    --radius-xs: 0.125rem;\n    --radius-sm: 0.25rem;\n    --radius-md: 0.375rem;\n    --radius-lg: 0.5rem;\n    --radius-xl: 0.75rem;\n    --radius-2xl: 1rem;\n    --radius-3xl: 1.5rem;\n    --radius-4xl: 2rem;\n\n    --shadow-2xs: 0 1px rgb(0 0 0 / 0.05);\n    --shadow-xs: 0 1px 2px 0 rgb(0 0 0 / 0.05);\n    --shadow-sm: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);\n    --shadow-md:\n      0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);\n    --shadow-lg:\n      0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);\n    --shadow-xl:\n      0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);\n    --shadow-2xl: 0 25px 50px -12px rgb(0 0 0 / 0.25);\n\n    --inset-shadow-2xs: inset 0 1px rgb(0 0 0 / 0.05);\n    --inset-shadow-xs: inset 0 1px 1px rgb(0 0 0 / 0.05);\n    --inset-shadow-sm: inset 0 2px 4px rgb(0 0 0 / 0.05);\n\n    --drop-shadow-xs: 0 1px 1px rgb(0 0 0 / 0.05);\n    --drop-shadow-sm: 0 1px 2px rgb(0 0 0 / 0.15);\n    --drop-shadow-md: 0 3px 3px rgb(0 0 0 / 0.12);\n    --drop-shadow-lg: 0 4px 4px rgb(0 0 0 / 0.15);\n    --drop-shadow-xl: 0 9px 7px rgb(0 0 0 / 0.1);\n    --drop-shadow-2xl: 0 25px 25px rgb(0 0 0 / 0.15);\n\n    --text-shadow-2xs: 0px 1px 0px rgb(0 0 0 / 0.15);\n    --text-shadow-xs: 0px 1px 1px rgb(0 0 0 / 0.2);\n    --text-shadow-sm:\n      0px 1px 0px rgb(0 0 0 / 0.075), 0px 1px 1px rgb(0 0 0 / 0.075),\n      0px 2px 2px rgb(0 0 0 / 0.075);\n    --text-shadow-md:\n      0px 1px 1px rgb(0 0 0 / 0.1), 0px 1px 2px rgb(0 0 0 / 0.1),\n      0px 2px 4px rgb(0 0 0 / 0.1);\n    --text-shadow-lg:\n      0px 1px 2px rgb(0 0 0 / 0.1), 0px 3px 2px rgb(0 0 0 / 0.1),\n      0px 4px 8px rgb(0 0 0 / 0.1);\n\n    --ease-in: cubic-bezier(0.4, 0, 1, 1);\n    --ease-out: cubic-bezier(0, 0, 0.2, 1);\n    --ease-in-out: cubic-bezier(0.4, 0, 0.2, 1);\n\n    --animate-spin: spin 1s linear infinite;\n    --animate-ping: ping 1s cubic-bezier(0, 0, 0.2, 1) infinite;\n    --animate-pulse: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;\n    --animate-bounce: bounce 1s infinite;\n\n    @keyframes spin {\n      to {\n        transform: rotate(360deg);\n      }\n    }\n\n    @keyframes ping {\n      75%,\n      100% {\n        transform: scale(2);\n        opacity: 0;\n      }\n    }\n\n    @keyframes pulse {\n      50% {\n        opacity: 0.5;\n      }\n    }\n\n    @keyframes bounce {\n      0%,\n      100% {\n        transform: translateY(-25%);\n        animation-timing-function: cubic-bezier(0.8, 0, 1, 1);\n      }\n\n      50% {\n        transform: none;\n        animation-timing-function: cubic-bezier(0, 0, 0.2, 1);\n      }\n    }\n\n    --blur-xs: 4px;\n    --blur-sm: 8px;\n    --blur-md: 12px;\n    --blur-lg: 16px;\n    --blur-xl: 24px;\n    --blur-2xl: 40px;\n    --blur-3xl: 64px;\n\n    --perspective-dramatic: 100px;\n    --perspective-near: 300px;\n    --perspective-normal: 500px;\n    --perspective-midrange: 800px;\n    --perspective-distant: 1200px;\n\n    --aspect-video: 16 / 9;\n\n    --default-transition-duration: 150ms;\n    --default-transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n    --default-font-family: --theme(--font-sans, initial);\n    --default-font-feature-settings: --theme(\n      --font-sans--font-feature-settings,\n      initial\n    );\n    --default-font-variation-settings: --theme(\n      --font-sans--font-variation-settings,\n      initial\n    );\n    --default-mono-font-family: --theme(--font-mono, initial);\n    --default-mono-font-feature-settings: --theme(\n      --font-mono--font-feature-settings,\n      initial\n    );\n    --default-mono-font-variation-settings: --theme(\n      --font-mono--font-variation-settings,\n      initial\n    );\n  }\n\n  /* Deprecated */\n  @theme default inline reference {\n    --blur: 8px;\n    --shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);\n    --shadow-inner: inset 0 2px 4px 0 rgb(0 0 0 / 0.05);\n    --drop-shadow: 0 1px 2px rgb(0 0 0 / 0.1), 0 1px 1px rgb(0 0 0 / 0.06);\n    --radius: 0.25rem;\n    --max-width-prose: 65ch;\n  }\n}\n\n@layer base {\n  /*\n  1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)\n  2. Remove default margins and padding\n  3. Reset all borders.\n*/\n\n  *,\n  ::after,\n  ::before,\n  ::backdrop,\n  ::file-selector-button {\n    box-sizing: border-box; /* 1 */\n    margin: 0; /* 2 */\n    padding: 0; /* 2 */\n    border: 0 solid; /* 3 */\n  }\n\n  /*\n  1. Use a consistent sensible line-height in all browsers.\n  2. Prevent adjustments of font size after orientation changes in iOS.\n  3. Use a more readable tab size.\n  4. Use the user's configured `sans` font-family by default.\n  5. Use the user's configured `sans` font-feature-settings by default.\n  6. Use the user's configured `sans` font-variation-settings by default.\n  7. Disable tap highlights on iOS.\n*/\n\n  html,\n  :host {\n    line-height: 1.5; /* 1 */\n    -webkit-text-size-adjust: 100%; /* 2 */\n    tab-size: 4; /* 3 */\n    font-family: --theme(\n      --default-font-family,\n      ui-sans-serif,\n      system-ui,\n      sans-serif,\n      \"Apple Color Emoji\",\n      \"Segoe UI Emoji\",\n      \"Segoe UI Symbol\",\n      \"Noto Color Emoji\"\n    ); /* 4 */\n    font-feature-settings: --theme(\n      --default-font-feature-settings,\n      normal\n    ); /* 5 */\n    font-variation-settings: --theme(\n      --default-font-variation-settings,\n      normal\n    ); /* 6 */\n    -webkit-tap-highlight-color: transparent; /* 7 */\n  }\n\n  /*\n  1. Add the correct height in Firefox.\n  2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)\n  3. Reset the default border style to a 1px solid border.\n*/\n\n  hr {\n    height: 0; /* 1 */\n    color: inherit; /* 2 */\n    border-top-width: 1px; /* 3 */\n  }\n\n  /*\n  Add the correct text decoration in Chrome, Edge, and Safari.\n*/\n\n  abbr:where([title]) {\n    -webkit-text-decoration: underline dotted;\n    text-decoration: underline dotted;\n  }\n\n  /*\n  Remove the default font size and weight for headings.\n*/\n\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6 {\n    font-size: inherit;\n    font-weight: inherit;\n  }\n\n  /*\n  Reset links to optimize for opt-in styling instead of opt-out.\n*/\n\n  a {\n    color: inherit;\n    -webkit-text-decoration: inherit;\n    text-decoration: inherit;\n  }\n\n  /*\n  Add the correct font weight in Edge and Safari.\n*/\n\n  b,\n  strong {\n    font-weight: bolder;\n  }\n\n  /*\n  1. Use the user's configured `mono` font-family by default.\n  2. Use the user's configured `mono` font-feature-settings by default.\n  3. Use the user's configured `mono` font-variation-settings by default.\n  4. Correct the odd `em` font sizing in all browsers.\n*/\n\n  code,\n  kbd,\n  samp,\n  pre {\n    font-family: --theme(\n      --default-mono-font-family,\n      ui-monospace,\n      SFMono-Regular,\n      Menlo,\n      Monaco,\n      Consolas,\n      \"Liberation Mono\",\n      \"Courier New\",\n      monospace\n    ); /* 1 */\n    font-feature-settings: --theme(\n      --default-mono-font-feature-settings,\n      normal\n    ); /* 2 */\n    font-variation-settings: --theme(\n      --default-mono-font-variation-settings,\n      normal\n    ); /* 3 */\n    font-size: 1em; /* 4 */\n  }\n\n  /*\n  Add the correct font size in all browsers.\n*/\n\n  small {\n    font-size: 80%;\n  }\n\n  /*\n  Prevent `sub` and `sup` elements from affecting the line height in all browsers.\n*/\n\n  sub,\n  sup {\n    font-size: 75%;\n    line-height: 0;\n    position: relative;\n    vertical-align: baseline;\n  }\n\n  sub {\n    bottom: -0.25em;\n  }\n\n  sup {\n    top: -0.5em;\n  }\n\n  /*\n  1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)\n  2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)\n  3. Remove gaps between table borders by default.\n*/\n\n  table {\n    text-indent: 0; /* 1 */\n    border-color: inherit; /* 2 */\n    border-collapse: collapse; /* 3 */\n  }\n\n  /*\n  Use the modern Firefox focus style for all focusable elements.\n*/\n\n  :-moz-focusring {\n    outline: auto;\n  }\n\n  /*\n  Add the correct vertical alignment in Chrome and Firefox.\n*/\n\n  progress {\n    vertical-align: baseline;\n  }\n\n  /*\n  Add the correct display in Chrome and Safari.\n*/\n\n  summary {\n    display: list-item;\n  }\n\n  /*\n  Make lists unstyled by default.\n*/\n\n  ol,\n  ul,\n  menu {\n    list-style: none;\n  }\n\n  /*\n  1. Make replaced elements `display: block` by default. (https://github.com/mozdevs/cssremedy/issues/14)\n  2. Add `vertical-align: middle` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)\n      This can trigger a poorly considered lint error in some tools but is included by design.\n*/\n\n  img,\n  svg,\n  video,\n  canvas,\n  audio,\n  iframe,\n  embed,\n  object {\n    display: block; /* 1 */\n    vertical-align: middle; /* 2 */\n  }\n\n  /*\n  Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)\n*/\n\n  img,\n  video {\n    max-width: 100%;\n    height: auto;\n  }\n\n  /*\n  1. Inherit font styles in all browsers.\n  2. Remove border radius in all browsers.\n  3. Remove background color in all browsers.\n  4. Ensure consistent opacity for disabled states in all browsers.\n*/\n\n  button,\n  input,\n  select,\n  optgroup,\n  textarea,\n  ::file-selector-button {\n    font: inherit; /* 1 */\n    font-feature-settings: inherit; /* 1 */\n    font-variation-settings: inherit; /* 1 */\n    letter-spacing: inherit; /* 1 */\n    color: inherit; /* 1 */\n    border-radius: 0; /* 2 */\n    background-color: transparent; /* 3 */\n    opacity: 1; /* 4 */\n  }\n\n  /*\n  Restore default font weight.\n*/\n\n  :where(select:is([multiple], [size])) optgroup {\n    font-weight: bolder;\n  }\n\n  /*\n  Restore indentation.\n*/\n\n  :where(select:is([multiple], [size])) optgroup option {\n    padding-inline-start: 20px;\n  }\n\n  /*\n  Restore space after button.\n*/\n\n  ::file-selector-button {\n    margin-inline-end: 4px;\n  }\n\n  /*\n  Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)\n*/\n\n  ::placeholder {\n    opacity: 1;\n  }\n\n  /*\n  Set the default placeholder color to a semi-transparent version of the current text color in browsers that do not\n  crash when using `color-mix(…)` with `currentcolor`. (https://github.com/tailwindlabs/tailwindcss/issues/17194)\n*/\n\n  @supports (not (-webkit-appearance: -apple-pay-button)) /* Not Safari */ or\n    (contain-intrinsic-size: 1px) /* Safari 17+ */ {\n    ::placeholder {\n      color: color-mix(in oklab, currentcolor 50%, transparent);\n    }\n  }\n\n  /*\n  Prevent resizing textareas horizontally by default.\n*/\n\n  textarea {\n    resize: vertical;\n  }\n\n  /*\n  Remove the inner padding in Chrome and Safari on macOS.\n*/\n\n  ::-webkit-search-decoration {\n    -webkit-appearance: none;\n  }\n\n  /*\n  1. Ensure date/time inputs have the same height when empty in iOS Safari.\n  2. Ensure text alignment can be changed on date/time inputs in iOS Safari.\n*/\n\n  ::-webkit-date-and-time-value {\n    min-height: 1lh; /* 1 */\n    text-align: inherit; /* 2 */\n  }\n\n  /*\n  Prevent height from changing on date/time inputs in macOS Safari when the input is set to `display: block`.\n*/\n\n  ::-webkit-datetime-edit {\n    display: inline-flex;\n  }\n\n  /*\n  Remove excess padding from pseudo-elements in date/time inputs to ensure consistent height across browsers.\n*/\n\n  ::-webkit-datetime-edit-fields-wrapper {\n    padding: 0;\n  }\n\n  ::-webkit-datetime-edit,\n  ::-webkit-datetime-edit-year-field,\n  ::-webkit-datetime-edit-month-field,\n  ::-webkit-datetime-edit-day-field,\n  ::-webkit-datetime-edit-hour-field,\n  ::-webkit-datetime-edit-minute-field,\n  ::-webkit-datetime-edit-second-field,\n  ::-webkit-datetime-edit-millisecond-field,\n  ::-webkit-datetime-edit-meridiem-field {\n    padding-block: 0;\n  }\n\n  /*\n  Center dropdown marker shown on inputs with paired `<datalist>`s in Chrome. (https://github.com/tailwindlabs/tailwindcss/issues/18499)\n*/\n\n  ::-webkit-calendar-picker-indicator {\n    line-height: 1;\n  }\n\n  /*\n  Remove the additional `:invalid` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)\n*/\n\n  :-moz-ui-invalid {\n    box-shadow: none;\n  }\n\n  /*\n  Correct the inability to style the border radius in iOS Safari.\n*/\n\n  button,\n  input:where([type=\"button\"], [type=\"reset\"], [type=\"submit\"]),\n  ::file-selector-button {\n    appearance: button;\n  }\n\n  /*\n  Correct the cursor style of increment and decrement buttons in Safari.\n*/\n\n  ::-webkit-inner-spin-button,\n  ::-webkit-outer-spin-button {\n    height: auto;\n  }\n\n  /*\n  Make elements with the HTML hidden attribute stay hidden by default.\n*/\n\n  [hidden]:where(:not([hidden=\"until-found\"])) {\n    display: none !important;\n  }\n}\n\n@layer utilities {\n  @tailwind utilities;\n}\n","@source '../../../**/*.{js,jsx,ts,tsx,html}';\n@import 'tailwindcss';\n\n@theme {\n    --font-sans: Roboto;\n    --font-mono: RobotoMono;\n\n    --color-main: var(--color-main);\n    --color-green: var(--color-green);\n    --color-red: var(--color-red);\n    --color-yellow: var(--color-yellow);\n    --color-yellow-100: var(--color-yellow-light);\n\n    --color-white: var(--color-white);\n    --color-black: var(--color-black);\n    --color-chatYou: var(--color-chat-you);\n    --color-link: var(--color-link);\n\n    --color-pbx-conference: var(--color-conference);\n    --color-pbx-refer: var(--color-refer);\n    --color-pbx-huntgroup: var(--color-huntgroup);\n    --color-pbx-channel: var(--color-channel);\n    --color-pbx-voicemail: var(--color-voicemail);\n    --color-pbx-connection: var(--color-connection);\n    --color-iconOnBrand: var(--color-iconOnBrand);\n    --color-textOnBrand: var(--color-textOnBrand);\n\n    --color-flavor-1: var(--color-flavor-1);\n    --color-flavor-2: var(--color-flavor-2);\n    --color-flavor-3: var(--color-flavor-3);\n    --color-flavor-4: var(--color-flavor-4);\n    --color-flavor-5: var(--color-flavor-5);\n    --color-flavor-6: var(--color-flavor-6);\n    --color-flavor-7: var(--color-flavor-7);\n    --color-flavor-8: var(--color-flavor-8);\n    --color-flavor-9: var(--color-flavor-9);\n\n    --color-gray-100: var(--color-super-light-grey);\n    --color-gray-150: var(--color-light-background);\n    --color-gray-200: var(--color-dark-background);\n    --color-gray-300: var(--color-ornament);\n    --color-gray-400: var(--color-light-grey);\n    --color-gray-500: var(--color-mid-grey);\n    --color-gray-600: var(--color-icon);\n    --color-gray-700: var(--color-dark-icon);\n    --color-gray-800: var(--color-dark-grey);\n    --color-gray-900: var(--color-super-dark-grey);\n\n    --breakpoint-xs: 480px;\n    /* xs with the 320px right panel open on top */\n    --breakpoint-xs-panel: 800px;\n    --breakpoint-panel: 720px;\n\n    /* 96px, i.e. h-24 on the spacing scale.\n       Mirrored by FOOTER_HEIGHT in meeting-constants.js */\n    --spacing-meeting-footer: 6rem;\n\n    /* 80px, i.e. h-20 on the spacing scale — shorter than the footer, which\n       carries the call controls. Mirrored by HEADER_HEIGHT in\n       meeting-constants.js */\n    --spacing-meeting-header: 5rem;\n\n    /* Single source of truth for the meeting right-panel width (chat /\n       participants). Every region that reserves or insets around the panel —\n       both panel columns, the header, footer and corner self-view — derives\n       from this. Mirrored by RIGHT_PANEL_WIDTH in meeting-constants.js, and the\n       --breakpoint-*-panel values above bake it in; re-derive those if it\n       changes. */\n    --spacing-meeting-side-panel: 370px;\n\n    --text-2xs: 0.625rem;\n\n    --shadow-xs: 0 1px 2px 0 var(--shadow-color-xs);\n    --shadow-md:\n        0 4px 6px -1px var(--shadow-color-md),\n        0 2px 4px -2px var(--shadow-color-md);\n    --shadow-base: 0 6px 12px var(--shadow-color-base);\n    --shadow-lg: 0 6px 12px var(--shadow-color-lg);\n    --shadow-soft: 0 5px 10px 5px var(--shadow-color-xs);\n\n    --animate-fade: fade 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;\n    --animate-fade-in: fadeIn 200ms ease-out;\n    --animate-slideInDialpad: slideInDialpad 300ms ease-in forwards;\n    --animate-slideOut: slideOut 300ms ease-in forwards;\n    --animate-incomingCallPulseLarge: incomingCallPulseLarge 0.8s infinite;\n    --animate-spinSmoothAcceleration: spinSmoothAcceleration 2s infinite;\n    --animate-slideInFromBottom: slideInFromBottom 0.3s ease-out;\n    --animate-ellipsis: ellipsis 1.5s steps(4, end) infinite;\n\n    @keyframes ellipsis {\n        0% {\n            content: '';\n        }\n        25% {\n            content: '.';\n        }\n        50% {\n            content: '..';\n        }\n        75% {\n            content: '...';\n        }\n    }\n\n    @keyframes fade {\n        50% {\n            opacity: 50%;\n        }\n    }\n\n    @keyframes fadeIn {\n        from {\n            opacity: 0;\n        }\n        to {\n            opacity: 1;\n        }\n    }\n\n    @keyframes slideInDialpad {\n        0% {\n            transform: translateX(100%);\n            width: 0;\n            min-width: 0;\n        }\n        100% {\n            transform: translateX(0);\n            width: 360px;\n            min-width: 360px;\n        }\n    }\n\n    @keyframes slideInFromBottom {\n        0% {\n            opacity: 0;\n            transform: translateY(20px);\n        }\n        100% {\n            opacity: 1;\n            transform: translateY(0);\n        }\n    }\n\n    @keyframes slideOut {\n        0% {\n            transform: translateX(0);\n            width: 360px;\n            min-width: 360px;\n        }\n        100% {\n            transform: translateX(100%);\n            width: 0;\n            min-width: 0;\n        }\n    }\n\n    @keyframes incomingCallPulseLarge {\n        0% {\n            opacity: 1;\n        }\n        50% {\n            opacity: 0.75;\n        }\n        100% {\n            opacity: 0.5;\n            border-width: 10px;\n            transform: scale(1.2);\n        }\n    }\n\n    @keyframes spinSmoothAcceleration {\n        0% {\n            transform: rotate(0deg);\n        }\n        50% {\n            transform: rotate(360deg);\n            animation-timing-function: cubic-bezier(0.4, 0, 1, 1);\n        }\n        100% {\n            transform: rotate(720deg);\n            animation-timing-function: cubic-bezier(0.4, 1, 1, 0);\n        }\n    }\n\n    @keyframes tvx-ring {\n        0% {\n            transform: scale(0.6);\n            opacity: 1;\n        }\n        100% {\n            transform: scale(2.4);\n            opacity: 0;\n        }\n    }\n\n    @keyframes tvx-blink {\n        0%,\n        100% {\n            opacity: 1;\n        }\n        50% {\n            opacity: 0.3;\n        }\n    }\n\n    @keyframes tvx-pop {\n        0% {\n            transform: scale(0.5);\n            opacity: 0;\n        }\n        60% {\n            transform: scale(1.06);\n            opacity: 1;\n        }\n        100% {\n            transform: scale(1);\n        }\n    }\n}\n","@import './tailwind.config.css';\n@import './tailwind.plugin.css';\n\n@layer base {\n    *,\n    ::after,\n    ::before,\n    ::backdrop,\n    ::file-selector-button {\n        border-color: var(--color-gray-200, currentColor);\n    }\n}\n\n@layer base {\n    input::placeholder,\n    textarea::placeholder {\n        color: var(--color-gray-400);\n    }\n}\n\n@layer base {\n    button:not(:disabled),\n    [role='button']:not(:disabled) {\n        cursor: pointer;\n    }\n}\n\n/* iOS zooms the page in when a field with text smaller than 16px gets focus.\n   The @supports condition matches iOS WebKit only. */\n@supports (-webkit-touch-callout: none) {\n    /* A field without a text-size utility inherits its size from its parent. */\n    @layer base {\n        input,\n        textarea,\n        select,\n        [contenteditable='true'] {\n            font-size: max(16px, 1em);\n        }\n    }\n\n    /* The text-size utilities read these variables. Only the sizes below 16px\n       change, so a large field (text-2xl) keeps its size. */\n    input,\n    textarea,\n    select,\n    [contenteditable='true'] {\n        --text-2xs: 1rem;\n        --text-xs: 1rem;\n        --text-sm: 1rem;\n    }\n}\n\nhtml,\n.no-dark {\n    --color-white: #fff;\n    --color-black: #000;\n    --color-super-light-grey: #f8f8f8; /* 100 */\n    --color-light-background: #f5f5f5; /* 150 */\n    --color-dark-background: #ececec; /* 200 */\n    --color-ornament: #d7d7d7; /* 300 */\n    --color-light-grey: #adadad; /* 400 */\n    --color-mid-grey: #727272; /* 500 */\n    --color-icon: #474747; /* 600 */\n    --color-dark-icon: #3f4142; /* 700 */\n    --color-dark-grey: #242424; /* 800 */\n    --color-super-dark-grey: #121212; /* 900 */\n    --color-yellow-light: #fef698;\n    --color-link: #2c70b5;\n    --shadow-color-xs: rgb(0 0 0 / 0.05);\n    --shadow-color-md: rgb(0 0 0 / 0.1);\n    --shadow-color-base: rgba(0, 0, 0, 0.05);\n    --shadow-color-lg: rgba(0, 0, 0, 0.2);\n}\n\n@layer utilities {\n    .no-dark {\n        color-scheme: light !important;\n    }\n\n    .no-dark * {\n        color-scheme: light !important;\n    }\n\n    html.dark .no-dark,\n    html.dark .no-dark *,\n    .dark .no-dark,\n    .dark .no-dark * {\n        /* Force light mode colors for .no-dark elements */\n        --color-white: #fff !important;\n        --color-black: #000 !important;\n        --color-overlay: rgba(0, 0, 0, 0.5) !important;\n        --color-super-light-grey: #f8f8f8 !important;\n        --color-light-background: #f5f5f5 !important;\n        --color-dark-background: #ececec !important;\n        --color-ornament: #d7d7d7 !important;\n        --color-light-grey: #adadad !important;\n        --color-mid-grey: #727272 !important;\n        --color-icon: #474747 !important;\n        --color-dark-icon: #3f4142 !important;\n        --color-dark-grey: #242424 !important;\n        --color-super-dark-grey: #121212 !important;\n        --color-yellow-light: #fef698 !important;\n        --color-link: #2c70b5 !important;\n        --shadow-color-xs: rgb(0 0 0 / 0.05) !important;\n        --shadow-color-md: rgb(0 0 0 / 0.1) !important;\n        --shadow-color-base: rgba(0, 0, 0, 0.05) !important;\n        --shadow-color-lg: rgba(0, 0, 0, 0.2) !important;\n\n        /* Override Tailwind gray mappings */\n        --color-gray-100: #f8f8f8 !important;\n        --color-gray-150: #f5f5f5 !important;\n        --color-gray-200: #ececec !important;\n        --color-gray-300: #d7d7d7 !important;\n        --color-gray-400: #adadad !important;\n        --color-gray-500: #727272 !important;\n        --color-gray-600: #474747 !important;\n        --color-gray-700: #3f4142 !important;\n        --color-gray-800: #242424 !important;\n        --color-gray-900: #121212 !important;\n\n        color-scheme: light !important;\n    }\n}\nhtml.dark {\n    --color-white: #0e0e0e;\n    --color-overlay: rgba(0, 0, 0, 0.5);\n    --color-black: #ffffff;\n    --color-super-light-grey: #1a1a1a; /* 100 */\n    --color-light-background: #232323; /* 150 */\n    --color-dark-background: #2c2c2c; /* 200 */\n    --color-ornament: #3a3a3a; /* 300 */\n    --color-light-grey: #505050; /* 400 */\n    --color-mid-grey: #898989; /* 500 */\n    --color-icon: #bcbcbc; /* 600 */\n    --color-dark-icon: #c9c9c9; /* 700 */\n    --color-dark-grey: #d9d9d9; /* 800 */\n    --color-super-dark-grey: #e9e9e9; /* 900 */\n    --color-yellow-light: #524f31;\n    --color-link: #25a6d1;\n    --shadow-color-xs: rgba(0, 0, 0, 0.5);\n    --shadow-color-md: rgba(0, 0, 0, 0.5);\n    --shadow-color-base: rgba(0, 0, 0, 0.5);\n    --shadow-color-lg: rgba(0, 0, 0, 0.5);\n}\n\nhtml.dark,\nhtml.dark body {\n    background-color: var(--color-super-light-grey);\n}\n\n/* Dark mode specific styles for divider */\n.dark\\:bg-gray-200:is(.dark *) > .divider > .bg-gray-200 {\n    background-color: var(--color-ornament) !important;\n}\n\nhtml {\n    /* default colors if branding request fails. */\n    --color-main: #2c3551;\n    --color-green: #2dc659;\n    --color-red: #fd5234;\n    --color-yellow: #fcd41e;\n\n    --color-chat-you: #2dc659;\n\n    --color-conference: #f17b3b;\n    --color-refer: #2c3551;\n    --color-huntgroup: #2dc659;\n    --color-channel: #25a6d1;\n    --color-voicemail: #37ba9b;\n    --color-connection: #2c70b5;\n    --color-iconOnBrand: #fff;\n    --color-textOnBrand: #fff;\n\n    --color-flavor-1: #f17b3b;\n    --color-flavor-2: #e6bd03;\n    --color-flavor-3: #89cb55;\n    --color-flavor-4: #37ba9b;\n    --color-flavor-5: #25a6d1;\n    --color-flavor-6: #2c70b5;\n    --color-flavor-7: #79438c;\n    --color-flavor-8: #d54f8c;\n    --color-flavor-9: #dc5e5e;\n}\n\nbody {\n    color: var(--color-dark-grey) !important;\n    font:\n        400 16px/1.5 'Roboto',\n        'Noto Sans Arabic',\n        sans-serif !important;\n}\n\n@font-face {\n    font-family: 'Gotham Bold';\n    src: url('../../../style_modules/less-components/fonts/GothamSSm-Bold.eot'); /* IE9 Compat Modes */\n    src:\n        url('../../../style_modules/less-components/fonts/GothamSSm-Bold.eot?#iefix')\n            format('embedded-opentype'),\n        /* IE6-IE8 */\n            url('../../../style_modules/less-components/fonts/GothamSSm-Bold.woff2')\n            format('woff2'),\n        /* Modern Browsers */\n            url('../../../style_modules/less-components/fonts/GothamSSm-Bold.woff')\n            format('woff'),\n        /* Modern Browsers */\n            url('../../../style_modules/less-components/fonts/GothamSSm-Bold.ttf')\n            format('truetype'),\n        /* Safari, Android, iOS */\n            url('../../../style_modules/less-components/fonts/GothamSSm-Bold.otf');\n    font-weight: normal;\n    font-style: normal;\n}\n\n@font-face {\n    font-family: 'Gotham Bold';\n    src: url('../../../style_modules/less-components/fonts/GothamSSm-BoldItalic.otf');\n    font-style: italic;\n}\n\n@font-face {\n    font-family: 'Gotham Book';\n    src: url('../../../style_modules/less-components/fonts/GothamSSm-Book.eot'); /* IE9 Compat Modes */\n    src:\n        url('../../../style_modules/less-components/fonts/GothamSSm-Book.eot?#iefix')\n            format('embedded-opentype'),\n        /* IE6-IE8 */\n            url('../../../style_modules/less-components/fonts/GothamSSm-Book.woff2')\n            format('woff2'),\n        /* Modern Browsers */\n            url('../../../style_modules/less-components/fonts/GothamSSm-Book.woff')\n            format('woff'),\n        /* Modern Browsers */\n            url('../../../style_modules/less-components/fonts/GothamSSm-Book.ttf')\n            format('truetype'),\n        /* Safari, Android, iOS */\n            url('../../../style_modules/less-components/fonts/GothamSSm-Book.otf');\n    font-weight: normal;\n    font-style: normal;\n}\n\n@font-face {\n    font-family: 'Gotham Book';\n    src: url('../../../style_modules/less-components/fonts/GothamSSm-BookItalic.otf');\n    font-style: italic;\n}\n\n@font-face {\n    font-family: 'Gotham Light';\n    src: url('../../../style_modules/less-components/fonts/GothamSSm-light.eot'); /* IE9 Compat Modes */\n    src:\n        url('../../../style_modules/less-components/fonts/GothamSSm-light.eot?#iefix')\n            format('embedded-opentype'),\n        /* IE6-IE8 */\n            url('../../../style_modules/less-components/fonts/GothamSSm-light.woff2')\n            format('woff2'),\n        /* Modern Browsers */\n            url('../../../style_modules/less-components/fonts/GothamSSm-light.woff')\n            format('woff'),\n        /* Modern Browsers */\n            url('../../../style_modules/less-components/fonts/GothamSSm-light.ttf')\n            format('truetype'),\n        /* Safari, Android, iOS */\n            url('../../../style_modules/less-components/fonts/GothamSSm-Light.otf');\n    font-weight: normal;\n    font-style: normal;\n}\n\n@font-face {\n    font-family: 'Gotham Light';\n    src: url('../../../style_modules/less-components/fonts/GothamSSm-LightItalic.otf');\n    font-style: italic;\n}\n\n@font-face {\n    font-family: 'Gotham Medium';\n    src: url('../../../style_modules/less-components/fonts/GothamSSm-Medium.eot'); /* IE9 Compat Modes */\n    src:\n        url('../../../style_modules/less-components/fonts/GothamSSm-Medium.eot?#iefix')\n            format('embedded-opentype'),\n        /* IE6-IE8 */\n            url('../../../style_modules/less-components/fonts/GothamSSm-Medium.woff2')\n            format('woff2'),\n        /* Modern Browsers */\n            url('../../../style_modules/less-components/fonts/GothamSSm-Medium.woff')\n            format('woff'),\n        /* Modern Browsers */\n            url('../../../style_modules/less-components/fonts/GothamSSm-Medium.ttf')\n            format('truetype'),\n        /* Safari, Android, iOS */\n            url('../../../style_modules/less-components/fonts/GothamSSm-Medium.otf');\n    font-weight: normal;\n    font-style: normal;\n}\n\n@font-face {\n    font-family: 'Gotham Medium';\n    src: url('../../../style_modules/less-components/fonts/GothamSSm-MediumItalic.otf');\n    font-style: italic;\n}\n\n@font-face {\n    font-family: 'Roboto-Regular';\n    src: url('../../../style_modules/less-components/fonts/Roboto/Roboto-Regular.eot');\n    src:\n        url('../../../style_modules/less-components/fonts/Roboto/Roboto-Regular.eot?#iefix')\n            format('embedded-opentype'),\n        url('../../../style_modules/less-components/fonts/Roboto/Roboto-Regular.svg#Roboto-Regular')\n            format('svg'),\n        url('../../../style_modules/less-components/fonts/Roboto/Roboto-Regular.ttf')\n            format('truetype'),\n        url('../../../style_modules/less-components/fonts/Roboto/Roboto-Regular.woff')\n            format('woff'),\n        url('../../../style_modules/less-components/fonts/Roboto/Roboto-Regular.woff2')\n            format('woff2');\n    font-weight: normal;\n    font-style: normal;\n}\n\n@font-face {\n    font-family: 'Roboto-Bold';\n    src: url('../../../style_modules/less-components/fonts/Roboto/Roboto-Bold.eot');\n    src:\n        url('../../../style_modules/less-components/fonts/Roboto/Roboto-Bold.eot?#iefix')\n            format('embedded-opentype'),\n        url('../../../style_modules/less-components/fonts/Roboto/Roboto-Bold.svg#Roboto-Bold')\n            format('svg'),\n        url('../../../style_modules/less-components/fonts/Roboto/Roboto-Bold.ttf')\n            format('truetype'),\n        url('../../../style_modules/less-components/fonts/Roboto/Roboto-Bold.woff')\n            format('woff'),\n        url('../../../style_modules/less-components/fonts/Roboto/Roboto-Bold.woff2')\n            format('woff2');\n    font-weight: normal;\n    font-style: normal;\n}\n\n@font-face {\n    font-family: 'Roboto-Medium';\n    src: url('../../../style_modules/less-components/fonts/Roboto/Roboto-Medium.eot');\n    src:\n        url('../../../style_modules/less-components/fonts/Roboto/Roboto-Medium.eot?#iefix')\n            format('embedded-opentype'),\n        url('../../../style_modules/less-components/fonts/Roboto/Roboto-Medium.svg#Roboto-Medium')\n            format('svg'),\n        url('../../../style_modules/less-components/fonts/Roboto/Roboto-Medium.ttf')\n            format('truetype'),\n        url('../../../style_modules/less-components/fonts/Roboto/Roboto-Medium.woff')\n            format('woff'),\n        url('../../../style_modules/less-components/fonts/Roboto/Roboto-Medium.woff2')\n            format('woff2');\n    font-weight: normal;\n    font-style: normal;\n}\n\n@font-face {\n    font-family: 'Roboto-Light';\n    src: url('../../../style_modules/less-components/fonts/Roboto/Roboto-Light.eot');\n    src:\n        url('../../../style_modules/less-components/fonts/Roboto/Roboto-Light.eot?#iefix')\n            format('embedded-opentype'),\n        url('../../../style_modules/less-components/fonts/Roboto/Roboto-Light.svg#Roboto-Light')\n            format('svg'),\n        url('../../../style_modules/less-components/fonts/Roboto/Roboto-Light.ttf')\n            format('truetype'),\n        url('../../../style_modules/less-components/fonts/Roboto/Roboto-Light.woff')\n            format('woff'),\n        url('../../../style_modules/less-components/fonts/Roboto/Roboto-Light.woff2')\n            format('woff2');\n    font-weight: normal;\n    font-style: normal;\n}\n\n@font-face {\n    font-family: 'RobotoMono';\n    src: url('../../../style_modules/less-components/fonts/RobotoMono/RobotoMono-Medium.ttf');\n    font-weight: 500;\n    font-style: normal;\n}\n\n@font-face {\n    font-family: 'Roboto';\n    src: url('../../../style_modules/less-components/fonts/Roboto/Roboto-Light.woff2')\n        format('woff2');\n    font-weight: 300;\n    font-style: normal;\n}\n\n@font-face {\n    font-family: 'Roboto';\n    src: url('../../../style_modules/less-components/fonts/Roboto/Roboto-Regular.woff2')\n        format('woff2');\n    font-weight: 400;\n    font-style: normal;\n}\n\n@font-face {\n    font-family: 'Roboto';\n    src: url('../../../style_modules/less-components/fonts/Roboto/Roboto-Medium.woff2')\n        format('woff2');\n    font-weight: 500;\n    font-style: normal;\n}\n\n@font-face {\n    font-family: 'Roboto';\n    src: url('../../../style_modules/less-components/fonts/Roboto/Roboto-Bold.woff2')\n        format('woff2');\n    font-weight: 700;\n    font-style: normal;\n}\n\n@font-face {\n    font-family: 'RobotoMono';\n    src: url('../../../style_modules/less-components/fonts/RobotoMono/RobotoMono-Medium.ttf')\n        format('ttf');\n    font-weight: 500;\n    font-style: normal;\n}\n\n@font-face {\n    font-family: 'Noto Sans Arabic';\n    src: url('../../../style_modules/less-components/fonts/Nato/NotoSansArabic-Regular.ttf')\n        format('woff2');\n    font-weight: 400;\n    font-style: normal;\n}\n\n@font-face {\n    font-family: 'Noto Sans Arabic';\n    src: url('../../../style_modules/less-components/fonts/Nato/NotoSansArabic-Medium.ttf')\n        format('woff2');\n    font-weight: 500;\n    font-style: normal;\n}\n\n@font-face {\n    font-family: 'Noto Sans Arabic';\n    src: url('../../../style_modules/less-components/fonts/Nato/NotoSansArabic-Bold.ttf')\n        format('woff2');\n    font-weight: 700;\n    font-style: normal;\n}\n\n.badge-bg.bg-white .badge {\n    @apply ring-white;\n}\n\n.badge-bg.bg-white .group:hover .badge {\n    @apply ring-gray-100;\n}\n\n.badge-bg.bg-gray-150 .badge {\n    @apply ring-gray-150;\n}\n\n.badge-bg.bg-gray-200 .badge {\n    @apply ring-gray-200;\n}\n\n.badge-bg.bg-gray-200 .group:hover .badge {\n    @apply ring-gray-300;\n}\n\n.badge-bg.bg-gray-800 .badge {\n    @apply ring-gray-800;\n}\n\n.badge-bg.bg-gray-800 .group:hover .badge {\n    @apply ring-gray-700;\n}\n\n.badge {\n    @apply ring-gray-100;\n}\n\n.group:hover .badge {\n    @apply ring-gray-200;\n}\n\n@layer utilities {\n    .scrollbar {\n        @apply overflow-y-auto;\n    }\n\n    .scrollbar::-webkit-scrollbar {\n        @apply block;\n    }\n\n    .scrollbar::-webkit-scrollbar-track {\n        @apply bg-transparent;\n    }\n\n    .scrollbar::-webkit-scrollbar-thumb {\n        @apply block bg-gray-300;\n    }\n\n    /* Opt-in, for a list that works out where to sit before it shows anything:\n       the thumb stays invisible until the list says it has settled, so it does\n       not flicker meanwhile. Once settled it shows like every other list's.\n\n       It used to show only under the pointer. Chromium does not repaint a\n       scrollbar when the pointer enters the scroller, so that rule relied on\n       the message action bar switching display on hover, which repainted the\n       list as a side effect. When the bar started revealing with opacity\n       instead, the thumb stopped appearing until the list scrolled.\n\n       Every other .scrollbar keeps the thumb it has always had. This was once\n       written onto .scrollbar itself, which took the thumb away from all forty\n       or so lists that never asked for it. */\n    .scrollbar.scrollbar-deferred::-webkit-scrollbar-thumb {\n        background-color: transparent;\n    }\n\n    .scrollbar.scrollbar-deferred.scrollbar-ready::-webkit-scrollbar-thumb {\n        @apply bg-gray-300;\n    }\n\n    /* Opt-in, for a list on a surface that dark mode paints gray-300 — a floating\n       panel, say — where the thumb would otherwise be drawn in the colour of the\n       thing it sits on. Light mode keeps the standard thumb. Every other\n       .scrollbar is left alone.\n\n       Written out rather than `@apply dark:bg-gray-400`, which Tailwind nests as\n       `::-webkit-scrollbar-thumb:where(.dark *)` — a pseudo-element followed by a\n       condition on its ancestors, so it matches nothing. The dark root has to\n       come first. */\n    html.dark\n        .scrollbar.scrollbar-contrast:not(\n            .no-dark,\n            .no-dark *\n        )::-webkit-scrollbar-thumb {\n        background-color: var(--color-gray-400);\n    }\n\n    .hide-scrollbar {\n        scrollbar-width: none; /* Firefox */\n        -ms-overflow-style: none; /* IE / legacy Edge */\n    }\n\n    .hide-scrollbar::-webkit-scrollbar {\n        display: none;\n    }\n\n    [type='search']::-webkit-search-cancel-button {\n        @apply size-4 cursor-pointer appearance-none bg-[url('../images/clear-search.svg')];\n    }\n\n    .dark [type='search']::-webkit-search-cancel-button {\n        @apply bg-[url('../images/clear-search-white.svg')];\n    }\n}\n\nem-emoji-picker {\n    --border-radius: 0.25rem;\n    --color-border-over: none;\n}\n\n.no-select {\n    user-select: none;\n}\n\n.no-select::selection {\n    background: none;\n}\n\n.override-hover:hover {\n    background-image: none !important;\n}\n\n.markdown h1 {\n    @apply text-3xl font-bold;\n}\n.markdown h2 {\n    @apply text-2xl font-semibold;\n}\n.markdown h3 {\n    @apply text-xl font-semibold;\n}\n.markdown ul {\n    @apply list-disc ps-6;\n}\n.markdown ol {\n    @apply list-decimal ps-6;\n}\n.markdown blockquote {\n    @apply border-s-4 border-gray-300 py-2 ps-4 text-gray-600 italic;\n}\n.markdown table {\n    @apply my-2 w-full border-collapse;\n}\n.markdown th,\n.markdown td {\n    @apply border border-gray-300 px-4 py-2 text-start;\n}\n.markdown hr {\n    @apply my-4 border-t border-gray-300;\n}\n\n.markdown a {\n    @apply text-link hover:underline;\n}\n\n.dark .transfer-modal .left-nav-scroll-wrapper {\n    --color-gray-200: var(--color-ornament);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
